import opentype from "opentype.js"
import Swal from 'sweetalert2';
import Util from './Util.js';

// Global image cache
const imageCache = new Map();


export function getImage(imageName, webId, demo)
{
    // --- build URL ---
    let url = "";
    let u = Util.getInstance();
    let serverName = u.getServerName();

    /*
    if(webId == "")
    {
      url = demo ? `https://ait.myaiweb.ca/images/${imageName}`
      : `https://myaiweb.ca/${imageName}`;
    }
    else
    {
      url = demo ? `https://ait.myaiweb.ca/images/${imageName}`
      : `https://myaiweb.ca/${webId}/${imageName}`;
    }
    */

    if(webId == "")
    {
      url = demo ? `${serverName}/${imageName}`
      : `${serverName}/${imageName}`;
    }
    else
    {
      url = demo ? `${serverName}/${webId}/${imageName}`
      : `${serverName}/${webId}/${imageName}`;
    }


  return imageCache.get(url);
}

export function invalidateImageCache(imageName, webId, demo) {

  let u = Util.getInstance();
  let serverName = u.getServerName();

  /*
  const url = demo
    ? `https://ait.myaiweb.ca/images/${imageName}`
    : `https://myaiweb.ca/${webId}/${imageName}`;
  */
  const url = demo
    ? `${serverName}/${webId}/${imageName}`
    : `${serverName}/${webId}/${imageName}`;

  imageCache.delete(url);
}

export function getCachedImage(imageName, webId, demo, onReady) {
  // --- build URL ---
  let url = "";
  let u = Util.getInstance();
  let serverName = u.getServerName();


  /*
  if(webId === "")
  {
    url = demo ? `https://ait.myaiweb.ca/images/${imageName}`
                : `https://myaiweb.ca/${imageName}`;

  }
  else
  {
    url = demo ? `https://ait.myaiweb.ca/images/${imageName}`
                : `https://myaiweb.ca/${webId}/${imageName}`;
  }
  */
    if(webId === "")
    {
      url = demo ? `${serverName}/${imageName}`
                  : `${serverName}/${imageName}`;

    }
    else
    {
      url = demo ? `${serverName}/${webId}/${imageName}`
                  : `${serverName}/${webId}/${imageName}`;
    }


  let entry = imageCache.get(url);

  if (!entry) {
    const img = new Image();

    entry = {
      img,
      status: "loading",
    };

    imageCache.set(url, entry);

    img.onload = () => {
      entry.status = "loaded";
      if (onReady) onReady();
    };

    img.onerror = () => {
      entry.status = "error";
      if (onReady) onReady();
    };

    img.src = url;
  }

  return entry;
}



export function drawImage0(
  ctx,
  x,
  y,
  w,
  h,
  webId,
  imageName,
  demo,
  onReady
) {
  ctx.save();

  // --- cache lookup ---
  let iCache = imageCache.getImage(imageName,webId, demo);

  if (iCache?.status === "error") 
  {
    // don't retry broken image every frame
    ctx.fillStyle = "#eee";
    ctx.fillRect(x, y, w, h);
    ctx.restore();
    return;
  }

  
  // --- not ready yet → placeholder ---
  if (iCache?.status !== "loaded" || !img.complete) {
    ctx.fillStyle = "#eee";
    ctx.fillRect(x, y, w, h);
    ctx.restore();
    return;
  }


  const img = iCache?.img;
  ctx.drawImage(img, x, y, w, h);
  
  ctx.restore();
}

/*
export function drawImage0(ctx, x, y, w, h, webId, imageName, demo, onReady) {

  ctx.save();
  let url = `https://myaiweb.ca/u/${webId}/${imageName}`;

  if(demo === true)
  {
    url = `https://ait.myaiweb.ca/images/${imageName}`;
  }

  // const url = `https://myaiweb.ca/u/${webId}/${imageName}`;

  let img = imageCache.get(url);
  if (!img) {
    img = new Image();
    img.src = url;

    // When it loads, trigger a redraw once
    img.onload = () => {
      if (onReady) onReady();
    };

    imageCache.set(url, img);
  }

  if (img.complete) {
    ctx.drawImage(img, x, y, w, h);
    // drawRotatedImage(ctx,img,x,y,w,h,a);
  } else {
    // Optional: placeholder so user sees something while loading
    ctx.fillStyle = "#eee";
    ctx.fillRect(x, y, w, h);
  }
  ctx.restore();
}
*/

/*
export function drawResize(ctx,x,y,w,h,a)
{
  ctx.lineWidth = 1;        
  ctx.strokeRect(x+w-10, y+h-10,10, 10);
  ctx.fillStyle = "rgba(0, 0, 255, 0.6)"; 
  ctx.fillRect(x+w-10, y+h-10, 10, 10);
}
*/


export function drawResize(ctx, x, y, w, h, a)
{
  ctx.save();

  let rSize=20;
  // Rotate only if angle defined
  if (a !== undefined) {
    const cx = x + w / 2;
    const cy = y + h / 2;

    ctx.translate(cx, cy);
    ctx.rotate(a);

    x = -w / 2;
    y = -h / 2;
  }

  ctx.lineWidth = 1;

  ctx.strokeRect(x + w - rSize, y + h - rSize, rSize, rSize);

  ctx.fillStyle = "rgba(0, 0, 255, 0.6)";
  ctx.fillRect(x + w - rSize, y + h - rSize, rSize, rSize);

  ctx.restore();
}

export function drawPlaceholder(ctx, x,y,w,h,a, text, selected)
{
    ctx.save();
    ctx.fillStyle = "#eee";
    ctx.fillRect(x, y, w, h);

    ctx.fillStyle = "#999";
    ctx.font = "bold 16px sans-serif";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(text, x + w / 2, y + h / 2);

    if (selected) 
    {
        drawResize(ctx, x, y, w, h, a);
    }

    ctx.restore();
}




export function drawImage(
  ctx,
  x,
  y,
  w,
  h,
  a,
  webId,
  imageName,
  demo,
  selected,
  keepAspect,
  rect,
  onReady
) {
  try {
    ctx.save();

    // --- missing image fallback ---
    if (!imageName) {
      ctx.fillStyle = "#eee";
      ctx.fillRect(x, y, w, h);

      ctx.fillStyle = "#999";
      ctx.font = "bold 16px sans-serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText("Image", x + w / 2, y + h / 2);

      if (selected) {
        drawResize(ctx, x, y, w, h, a);
      }

      ctx.restore();
      return;
    }


      // --- cache lookup ---
     let entry = getImage(imageName,webId, demo);

    
    if (entry?.status === "error") 
    {
      // don't retry broken image every frame
      ctx.fillStyle = "#eee";
      ctx.fillRect(x, y, w, h);
      ctx.restore();
      return;
    }
  
    const img = entry.img;

    // --- fallback while loading ---
    if (entry.status !== "loaded" || !img.complete) {
      ctx.fillStyle = "#eee";
      ctx.fillRect(x, y, w, h);

      if (selected) {
        drawResize(ctx, x, y, w, h, a);
      }

      ctx.restore();
      return;
    }

    // --- draw image ---
    if (keepAspect) {
      const imgAspect = img.width / img.height;
      const boxAspect = w / h;

      let dw, dh;

      if (imgAspect > boxAspect) {
        dw = w;
        dh = w / imgAspect;
      } else {
        dh = h;
        dw = h * imgAspect;
      }

      const dx = x;
      const dy = y;

      drawRotatedImage(ctx, img, dx, dy, dw, dh, a, rect);
    } else {
      drawRotatedImage(ctx, img, x, y, w, h, a, rect);
    }

    
    // --- selection overlay ---
    if (selected) {
      // drawResize(ctx, x, y, w, h, a);
    }
    ctx.restore();
  } catch (e) {
    console.log("Exception in drawImage", e);
  }
}

/*
export function drawImage(ctx, x, y, w, h, a, webId, imageName, demo, selected, keepAspect, rect, onReady) {
  try {
    // If imageName is empty, draw centered text
    

    if (!imageName) {      
      ctx.save();
      // Draw placeholder background
      ctx.fillStyle = "#eee";
      ctx.fillRect(x, y, w, h);
      // Configure text style
      
      ctx.fillStyle = "#999";
      ctx.font = "bold 16px sans-serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      // Draw centered text (if needed)
      if (selected === true) {
        drawResize(ctx, x, y, w, h, a);
      }
      ctx.restore();

      return;
    }

    // Construct image URL
    let url = `https://myaiweb.ca/u/${webId}/${imageName}`;
    if (demo === true) {
      url = `https://ait.myaiweb.ca/images/${imageName}`;
    }

    // Attempt to use cached image
    let img = imageCache.get(url);
    if (!img) {
      img = new Image();
      img.src = url;

      img.onload = () => {
        if (onReady) onReady();
      };

      imageCache.set(url, img);
    }

    if (img.complete) {

      ctx.save();
      if(keepAspect)
      {
          // Calculate aspect ratio of the image and the canvas
          const imgAspect = img.width / img.height;
          const canvasAspect = w / h;

          let newWidth, newHeight;

          // Prioritize width for scaling, like object-fit: cover
          if (imgAspect > canvasAspect) {
            // Image is wider than the canvas: scale by width
            newWidth = w;
            newHeight = w / imgAspect;  // Adjust height based on the width
          } else {
            // Image is taller than the canvas: scale by height
            newHeight = h;
            newWidth = h * imgAspect;  // Adjust width based on the height
          }

          // To replicate "cover" behavior, clip the image if necessary
          // If the newHeight is smaller than the canvas height, we need to clip the image vertically
          const dx = x;
          // const dy = y + (h - newHeight) / 2;  // Center the image vertically
          const dy = y;

          // Draw the image on the canvas
          drawRotatedImage(ctx, img, dx, dy, newWidth, newHeight, a, rect);
        }
        else
        {
          drawRotatedImage(ctx, img, x, y, w, h, a, rect);    
        }

    } else {
      // Placeholder background while loading
      ctx.fillStyle = "#eee";
      ctx.fillRect(x, y, w, h);
    }

    if (selected === true) {
      drawResize(ctx, x, y, w, h, a);
    }
    ctx.restore();

  } catch (e) {
    console.log("Exception in drawImage", e);
  }
}

*/

export function drawRotatedRect(ctx, x, y, w, h, angle, stroke=false) {
  // Step 1: Translate to the center of the rectangle
  const centerX = x + w / 2;
  const centerY = y + h / 2;

  // Save the current canvas state
  ctx.save();

  // Step 2: Move the canvas to the center and rotate it
  ctx.translate(centerX, centerY);  // Translate to the center of the rectangle
  ctx.rotate(angle);  // Rotate by the angle (in radians)

  // Step 3: Draw the rectangle (position relative to the center)

  if(stroke)
  {
    ctx.strokeRect(-w / 2, -h / 2, w, h);  // The rectangle is drawn relative to the center
  }

  ctx.fillStyle = "rgba(0, 0, 0, 0.05)"; 
  ctx.fillRect(-w/2, -h/2, w, h);

  
  // Step 4: Restore the canvas state
  ctx.restore();
}

/*
function drawRotatedImage(
  ctx,
  img,
  x,
  y,
  w,
  h,
  rotationAngle,
  rect = null,
  panX = 0,
  panY = 0,
  sZoom = 1,
  viewPortRef
) {
  ctx.save();

  // Move origin to the center of the rectangle
  ctx.translate(x + w / 2, y + h / 2);

  // Apply rotation
  const radians = -rotationAngle * Math.PI / 180;
  ctx.rotate(radians);

  let actualZoom = 1;

  if (rect != null) {
    actualZoom = rect.imageZoom;
  }

  // Apply zoom to width and height (scaling the image)

  let sW = w*actualZoom;
  let sH = h*actualZoom;
  if (rect != null) {
    sW = w * actualZoom;
    sH = h * actualZoom;
  }

  // Apply the pan offsets relative to the image zoom (actualZoom) and page zoom (sZoom)
  // Scale panX and panY based on the image zoom and the page zoom
  const scaledPanX = panX*sZoom*actualZoom;
  const scaledPanY = panY*sZoom*actualZoom;

   // --- Page coordinates pan offsets (do NOT include sZoom) ---
   const pagePanX = panX * actualZoom;
   const pagePanY = panY * actualZoom;
 

  if (rect != null) 
  {



      // --- Page coordinates calculation for SVG ---
      // Start with canvas coordinates *before canvas zoom*:
      // undo the canvas zoom for x and y
      const unzoomedX = x / sZoom;
      const unzoomedY = y / sZoom;
      const uw = w /sZoom;
      const uh = h/sZoom;
    
      // Use only image zoom (actualZoom) and pan for positioning
      const pageX = unzoomedX + uw/2 - (uw * actualZoom) / 2 + panX * actualZoom;
      const pageY = unzoomedY + uh/2 - (uh * actualZoom) / 2 + panY * actualZoom;
    
      // Convert screen → page coordinates
      // const { x: pageImageLeft, y: pageImageTop } = screenToPage(pageX, pageY, viewPortRef);

      const { offsetX, offsetY, zoom } = viewPortRef.current;
      
      let pageImageLeft = pageX - offsetX;
      let pageImageTop =  pageY - offsetY;

    
      rect.iX = pageImageLeft - rect.x;
      rect.iY = pageImageTop - rect.y;
    
      rect.iW = uw * actualZoom;
      rect.iH = uh * actualZoom;
  }


  // Draw image centered with scaled pan offset
  ctx.drawImage(
    img,
    -sW / 2 + scaledPanX,
    -sH / 2 + scaledPanY,
    sW,
    sH
  );

  ctx.restore();
}
*/


function drawRotatedImage(
  ctx,
  img,
  x,
  y,
  w,
  h,
  rotationAngle,
  rect = null,
  panX = 0,
  panY = 0,
  sZoom = 1,
  viewPortRef
) 
{
  ctx.save();

  // Apply opacity
  if(rect != null)
  {
    ctx.globalAlpha = getOpacity(rect); //rect.fillAlpha;

    if(rect.type === "Group")
    {
      console.log("Drawing Group Image");
      console.log(rect.bAlpha);
      // use background alpha when drawing images if group
      ctx.globalAlpha = rect.bAlpha;
    }
  }

  applyEffects(ctx,rect);

  // Move origin to the center of the rectangle
  ctx.translate(x + w / 2, y + h / 2);

  // Apply rotation
  const radians = -rotationAngle * Math.PI / 180;
  ctx.rotate(radians);

  let actualZoom = 1;

  if (rect != null) {
    actualZoom = rect.imageZoom;
  }

  let sW = w * actualZoom;
  let sH = h * actualZoom;

  // Apply the pan offsets
  const scaledPanX = panX * actualZoom;
  const scaledPanY = panY * actualZoom;

  const pagePanX = panX * actualZoom;
  const pagePanY = panY * actualZoom;

  if (rect != null) 
  {
      const pageX = x + w/2 - (w * actualZoom) / 2 + panX * actualZoom;
      const pageY = y + h/2 - (h * actualZoom) / 2 + panY * actualZoom;

      rect.iX = pageX - rect.x;
      rect.iY = pageY - rect.y;

      rect.iW = w * actualZoom;
      rect.iH = h * actualZoom;
  }

  // Draw image centered with scaled pan offset
  ctx.drawImage(
    img,
    -sW / 2 + scaledPanX,
    -sH / 2 + scaledPanY,
    sW,
    sH
  );

  ctx.restore();
}

/*
function drawRotatedImage(
  ctx,
  img,
  x,
  y,
  w,
  h,
  rotationAngle,
  rect = null,
  panX = 0,
  panY = 0,
  sZoom = 1,
  viewPortRef
) {
  ctx.save();

  // Move origin to the center of the rectangle
  ctx.translate(x + w / 2, y + h / 2);

  // Apply rotation
  const radians = -rotationAngle * Math.PI / 180;
  ctx.rotate(radians);

  let actualZoom = 1;

  if (rect != null) {
    actualZoom = rect.imageZoom;
  }

  // Apply zoom to width and height (scaling the image)

  let sW = w*actualZoom;
  let sH = h*actualZoom;
  if (rect != null) {
    sW = w * actualZoom;
    sH = h * actualZoom;
  }

  // Apply the pan offsets relative to the image zoom (actualZoom) and page zoom (sZoom)
  // Scale panX and panY based on the image zoom and the page zoom
  const scaledPanX = panX*actualZoom;
  const scaledPanY = panY*actualZoom;

   // --- Page coordinates pan offsets (do NOT include sZoom) ---
   const pagePanX = panX * actualZoom;
   const pagePanY = panY * actualZoom;
 

  if (rect != null) 
  {
    
      // --- Page coordinates calculation for SVG ---
      // Start with canvas coordinates *before canvas zoom*:
      // undo the canvas zoom for x and y
    
      // Use only image zoom (actualZoom) and pan for positioning
      const pageX = x + w/2 - (w * actualZoom) / 2 + panX * actualZoom;
      const pageY = y + h/2 - (h * actualZoom) / 2 + panY * actualZoom;
    
      // Convert screen → page coordinates
      // const { x: pageImageLeft, y: pageImageTop } = screenToPage(pageX, pageY, viewPortRef);

  
       rect.iX = pageX -rect.x;
       rect.iY = pageY -rect.y;

    
      rect.iW = w * actualZoom;
      rect.iH = h * actualZoom;
      
  }


  // Draw image centered with scaled pan offset
  ctx.drawImage(
    img,
    -sW / 2 + scaledPanX,
    -sH / 2 + scaledPanY,
    sW,
    sH
  );

  ctx.restore();
}
*/

/*
function drawRotatedImage(ctx, img, x, y, w, h, rotationAngle) {
  ctx.save();

  // Move origin to the center of the rectangle
  ctx.translate(x + w / 2, y + h / 2);


  let radians = rotationAngle*Math.PI /180;
  ctx.rotate(radians);

  // Draw the image so its center is at the origin
  ctx.drawImage(img, -w / 2, -h / 2, w, h);

  ctx.restore();
}
*/

/*
export function drawImage(ctx, x, y, w, h, a, webId, imageName, demo, selected, onReady) {
  try {

    console.log("HELP HERE");
    // If imageName is empty, draw centered text
    if (!imageName) {
      // Draw placeholder background
      ctx.fillStyle = "#eee";
      ctx.fillRect(x, y, w, h);

      // Configure text style
      ctx.save();
      ctx.fillStyle = "#999";
      ctx.font = "bold 16px sans-serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      // Draw centered text
      // ctx.fillText("Select Image", x + w / 2, y + h / 2);

      if(selected === true)
      {
        drawResize(ctx,x,y,w,h,a);
      }
      ctx.restore();
      
      return;
    }

    // Construct image URL
    let url = `https://myaiweb.ca/u/${webId}/${imageName}`;
    if (demo === true) {
      url = `https://ait.myaiweb.ca/images/${imageName}`;
    }

    // Attempt to use cached image
    let img = imageCache.get(url);
    if (!img) {
      img = new Image();
      img.src = url;

      img.onload = () => {
        if (onReady) onReady();
      };

      imageCache.set(url, img);
    }

    if (img.complete) {
      // ctx.drawImage(img, x, y, w, h);
      drawRotatedImage(ctx, img, x, y, w, h, a);
    } else {
      // Placeholder background while loading
      ctx.fillStyle = "#eee";
      ctx.fillRect(x, y, w, h);      
    }

    if(selected === true)
    {
      drawResize(ctx,x,y,w,h,a);
    }

  } catch(e) {
    console.log("Exception in drawImage", e);
  }
}
*/
/*
export function drawImage(ctx, x, y, w, h, a, webId, imageName, demo, onReady) {

  try
  {

      let url = `https://myaiweb.ca/u/${webId}/${imageName}`;

      if(demo === true)
      {
        url = `https://ait.myaiweb.ca/images/${imageName}`;
      }
      let img = imageCache.get(url);
      if (!img) {
        img = new Image();
        img.src = url;

        // When it loads, trigger a redraw once
        img.onload = () => {
          if (onReady) onReady();
        };

        imageCache.set(url, img);
      }

      if (img.complete) {
        // ctx.drawImage(img, x, y, w, h);
        drawRotatedImage(ctx,img,x,y,w,h,a);
      } else {
        // Optional: placeholder so user sees something while loading
        ctx.fillStyle = "#eee";
        ctx.fillRect(x, y, w, h);
      }
    }
    catch(e)
    {
      console.log("Exception in drawImage");
    }
}
*/


export function drawImageClip(
  ctx,
  x,
  y,
  w,
  h,
  a,
  webId,
  imageName,
  iCache,
  demo,
  rect,
  viewPortRef
) {
  try {
    ctx.save();
           
    if (iCache?.status === "error") 
    {
      // don't retry broken image every frame
      ctx.fillStyle = "#eee";
      ctx.fillRect(x, y, w, h);
      ctx.restore();
      return;
    }
  
    const img = iCache?.img;

    if (img===undefined) 
    {
      // don't retry broken image every frame
      ctx.fillStyle = "#eee";
      ctx.fillRect(x, y, w, h);
      ctx.restore();
      return;
    }


    // --- not ready yet → placeholder ---
    if (iCache.status !== "loaded" || !img.complete) {
      ctx.fillStyle = "#eee";
      ctx.fillRect(x, y, w, h);
      ctx.restore();
      return;
    }

    // --- IMPORTANT: define clip shape FIRST ---
    // ctx.beginPath();

    /*
      If drawSvgCircle already created the path before this function,
      then use:
         ctx.clip();

      If not, define the rectangle manually:
    */

    // ctx.rect(x, y, w, h);

    ctx.clip();    

    if(rect.subType === "SvgSquare")
    {
      if(w < h)
      {
        h = w;
      }
      else
      {
        w = h;
      }    
    }

    const zoom = viewPortRef?.current?.zoom || 1;

    const pX = rect.imagePanX;
    const pY = rect.imagePanY;

    // --- draw image ---
    if (rect.keepAspect) {
      const imgAspect = img.width / img.height;
      const boxAspect = w / h;

      let dw, dh;

      if (imgAspect > boxAspect) {
        dw = w;
        dh = w / imgAspect;
      } else {
        dh = h;
        dw = h * imgAspect;
      }

      const dx = x + (w - dw) / 2;
      const dy = y + (h - dh) / 2;

      drawRotatedImage(ctx, img, dx, dy, dw, dh, a, rect, pX, pY, zoom, viewPortRef);
    } else {
      drawRotatedImage(ctx, img, x, y, w, h, a, rect, pX, pY, zoom, viewPortRef);
    }

    ctx.restore();
  } catch (e) {
    ctx.restore();
    console.log("Exception in drawImageClip", e);
  }
}


/*
export function drawImageClip(ctx, x, y, w, h, a, webId, imageName, demo, rect, viewPortRef, onReady) {

  try
  {
      ctx.save();

      let  url = `https://myaiweb.ca/u/${webId}/${imageName}`;

      if(demo === true)
      {
        url = `https://ait.myaiweb.ca/images/${imageName}`;
      }


      let img = imageCache.get(url);
      if (!img) {
        img = new Image();
        img.src = url;

        // When it loads, trigger a redraw once
        img.onload = () => {
          if (onReady)
          {
          
              onReady();
          }
        };

        imageCache.set(url, img);
      }

      if (img.complete) {
        // ctx.drawImage(img, x, y, w, h);
        ctx.clip();        


        if(rect.keepAspect)
        {
            // Calculate aspect ratio of the image and the canvas
            const imgAspect = img.width / img.height;
            const canvasAspect = w / h;
  
            let newWidth, newHeight;
  
            // Prioritize width for scaling, like object-fit: cover
            if (imgAspect > canvasAspect) {
              // Image is wider than the canvas: scale by width
              newWidth = w;
              newHeight = w / imgAspect;  // Adjust height based on the width
            } else {
              // Image is taller than the canvas: scale by height
              newHeight = h;
              newWidth = h * imgAspect;  // Adjust width based on the height
            }
  
       
            const dx = x + (w - newWidth) / 2;
            const dy = y + (h - newHeight) / 2;

            // Draw the image on the canvas
            // let {x:pX, y:pY} = pageToScreen(rect.imagePanX,rect.imagePanY, viewPortRef);
            let pX = rect.imagePanX;
            let pY = rect.imagePanY;
            let sZoom = viewPortRef.current.zoom;
            
            drawRotatedImage(ctx, img, dx, dy, newWidth, newHeight, a, rect,pX,pY,sZoom, viewPortRef);
          }
          else
          {
            let pX = rect.imagePanX;
            let pY = rect.imagePanY;
            let sZoom = viewPortRef.current.zoom;
            
            drawRotatedImage(ctx,img,x,y,w,h,a, rect, pX, pY, sZoom, viewPortRef);
          }
        
      } else {
        // Optional: placeholder so user sees something while loading
        ctx.fillStyle = "#eee";
        ctx.fillRect(x, y, w, h);
      }
      
      ctx.restore();
    }
    catch(e)
    {
      console.log("Exception in drawImage");
    }
}
*/


// rotate a point (x, y) around a center (cx, cy) by rotation degrees
function rotatePointAroundCenter(x, y, cx, cy, rotationDeg) {
  const rad = -rotationDeg * Math.PI / 180;
  const dx = x - cx;
  const dy = y - cy;
  return {
    x: cx + dx * Math.cos(rad) - dy * Math.sin(rad),
    y: cy + dx * Math.sin(rad) + dy * Math.cos(rad)
  };
}

export function rotatePath(px, py, w, h, rotation, lPath) {
  // compute the center of the enclosing rectangle
  const cx =  w / 2;
  const cy = h / 2;

  return lPath.map(line => {
    const newPoints = line.points.map(p =>
      rotatePointAroundCenter(p.x, p.y, cx, cy, rotation)
    );
    return {
      ...line,
      points: newPoints
    };
  });
}



export function rotateCurvePath(px, py, w, h, rotation, lPath, controls) {
  // compute the center of the enclosing rectangle
  const cx =  w / 2;
  const cy = h / 2;

  let rPath = lPath.map(line => {
    const newPoints = line.points.map(p =>
      rotatePointAroundCenter(p.x, p.y, cx, cy, rotation)
    );
    return {
      ...line,
      points: newPoints
    };
  });


  const rControls = (controls || []).map(control => {
    const newControls = (control.controls || []).map(c => {
      // guard if control points are missing
      const p1 = (c.x1 != null && c.y1 != null)
        ? rotatePointAroundCenter(c.x1, c.y1, cx, cy, rotation)
        : null;
      const p2 = (c.x2 != null && c.y2 != null)
        ? rotatePointAroundCenter(c.x2, c.y2, cx, cy, rotation)
        : null;

      // return new control object with rotated coords (preserve other props)
      return {
        ...c,
        ...(p1 ? { x1: p1.x, y1: p1.y } : {}),
        ...(p2 ? { x2: p2.x, y2: p2.y } : {})
      };
    });

    return { ...control, controls: newControls };
  });

  return ({rPath:rPath, rControls:rControls});
}

export function flipHorizontal(w, h, rotation, lPath, controls) {
  // Compute horizontal centerline of the rectangle
  const cy = h / 2;

  // Flip points around the horizontal centerline
  const flippedPath = lPath.map(line => {
    const flippedPoints = line.points.map(p => ({
      ...p,
      y: cy - (p.y - cy) // mirror Y relative to rectangle
    }));
    return { ...line, points: flippedPoints };
  });

  // Flip control points if provided
  const flippedControls = (controls || []).map(control => {
    const flippedControlPoints = (control.controls || []).map(c => ({
      ...c,
      y1: cy - (c.y1 - cy),
      y2: cy - (c.y2 - cy)
    }));
    return { ...control, controls: flippedControlPoints };
  });

  // Flip the rotation angle
  const flippedRotation = -rotation;

  return { rPath: flippedPath, rControls: flippedControls, flippedRotation };
}

export function flipVertical(w, h, rotation, lPath, controls) {
  // Compute vertical centerline of the rectangle
  const cx = w / 2;

  // Flip points around the vertical centerline
  const flippedPath = lPath.map(line => {
    const flippedPoints = line.points.map(p => ({
      ...p,
      x: cx - (p.x - cx) // mirror X relative to rectangle
    }));
    return { ...line, points: flippedPoints };
  });

  // Flip control points if provided
  const flippedControls = (controls || []).map(control => {
    const flippedControlPoints = (control.controls || []).map(c => ({
      ...c,
      x1: cx - (c.x1 - cx),
      x2: cx - (c.x2 - cx)
    }));
    return { ...control, controls: flippedControlPoints };
  });

  // Flip the rotation angle
  const flippedRotation = -rotation;

  return { rPath: flippedPath, rControls: flippedControls, flippedRotation };
}


export function getBoundingBoxFromPoints(lines) {
  let minX = Infinity, minY = Infinity;
  let maxX = -Infinity, maxY = -Infinity;

  lines.forEach(line => {
    line.points.forEach(p => {
      if (p.x < minX) minX = p.x;
      if (p.y < minY) minY = p.y;
      if (p.x > maxX) maxX = p.x;
      if (p.y > maxY) maxY = p.y;
    });
  });

  return {
    x: minX,
    y: minY,
    w: maxX - minX,
    h: maxY - minY
  };
}


export function rPathToSvg(rPath) {
  return rPath.map(path => {

    let closed = false;
    const { points, stroke, strokeColor, fill, fillColor } = path;

    if (!points || points.length === 0) return "";

    let d = points.map((p, i) => 
      `${i === 0 ? "M" : "L"} ${p.x.toFixed(6)} ${p.y.toFixed(6)}`
    ).join(" ");

    if (closed) d += " Z"; // close only if explicitly requested


    return `${d}`;

    /*
    return `<path d="${d}"
      stroke="${strokeColor || "black"}"
      stroke-width="${stroke || 1}"
      fill="${fill ? fillColor || "none" : "none"}"
    />`;
    */
  }).join("\n");
}


export function rPathToSvgMap(rPath) {
  return rPath.map(path => {

    let closed = false;
    const { points, stroke, strokeColor, fill, fillColor } = path;

    if (!points || points.length === 0) return "";

    let d = points.map((p, i) => 
      `${i === 0 ? "M" : "L"} ${p.x.toFixed(6)} ${p.y.toFixed(6)}`
    ).join(" ");

    if (closed) d += " Z"; // close only if explicitly requested


    return {
      d: d.trim(),
      strokeColor: strokeColor || "#000000",  // Default to black if strokeColor not provided
      strokeWidth: stroke || 1,             // Default to 1 if stroke not provided
      fillColor: fill ? fillColor || "none" : "none",  // Set to fillColor if fill is enabled, otherwise "none"
    };
   

    /*
    return `<path d="${d}"
      stroke="${strokeColor || "black"}"
      stroke-width="${stroke || 1}"
      fill="${fill ? fillColor || "none" : "none"}"
    />`;
    */
  }).filter(Boolean);
}



export function rPathToCurveSvg(lines, controls) {
  return lines.map((line, li) => {
    if (!line || !line.points || line.points.length < 2) return "";

    const { points, stroke, strokeColor, fill, fillColor } = line;
    const ctrlLine = (controls && controls[li] && Array.isArray(controls[li].controls))
      ? controls[li].controls
      : [];

    let d = "";

    for (let i = 0; i < points.length; i++) {
      const p = points[i];
      if (i === 0) {
        d += `M ${p.x.toFixed(6)} ${p.y.toFixed(6)} `;
      } else {
        // fallback if no controls exist
        const prev = points[i - 1];
        const prevCtrl = ctrlLine[i - 1] || { x2: prev.x, y2: prev.y };
        const currCtrl = ctrlLine[i]     || { x1: p.x, y1: p.y };

        d += `C ${prevCtrl.x2.toFixed(6)} ${prevCtrl.y2.toFixed(6)} ` +
             `${currCtrl.x1.toFixed(6)} ${currCtrl.y1.toFixed(6)} ` +
             `${p.x.toFixed(6)} ${p.y.toFixed(6)} `;
      }
    }

    // optional close if needed
    // if (line.closed) d += "Z";

    // if you just need `d` strings
    return d.trim();

    // If you want full <path> elements instead:
    /*
    return `<path d="${d.trim()}"
      stroke="${strokeColor || "black"}"
      stroke-width="${stroke || 1}"
      fill="${line.fill ? (fillColor || "none") : "none"}"
    />`;
    */
  }).join("\n");
}


export function rPathToCurveSvgMap(lines, controls) {
  return lines.map((line, li) => {
    if (!line || !line.points || line.points.length < 2) return null; // Return null if invalid line

    const { points, stroke, strokeColor, fill, fillColor } = line;
    const ctrlLine = (controls && controls[li] && Array.isArray(controls[li].controls))
      ? controls[li].controls
      : [];

    let d = "";

    for (let i = 0; i < points.length; i++) {
      const p = points[i];
      if (i === 0) {
        d += `M ${p.x.toFixed(6)} ${p.y.toFixed(6)} `;
      } else {
        const prev = points[i - 1];
        const prevCtrl = ctrlLine[i - 1] || { x2: prev.x, y2: prev.y };
        const currCtrl = ctrlLine[i] || { x1: p.x, y1: p.y };

        d += `C ${prevCtrl.x2.toFixed(6)} ${prevCtrl.y2.toFixed(6)} ` +
             `${currCtrl.x1.toFixed(6)} ${currCtrl.y1.toFixed(6)} ` +
             `${p.x.toFixed(6)} ${p.y.toFixed(6)} `;
      }
    }

    return {
      d: d.trim(),
      strokeColor: strokeColor || "#000000",  // Default to black if strokeColor not provided
      strokeWidth: stroke || 1,             // Default to 1 if stroke not provided
      fillColor: fill ? fillColor || "none" : "none",  // Set to fillColor if fill is enabled, otherwise "none"
    };
  }).filter(Boolean); // Remove null values from the array
}


//MS--> Experimental for converting fonts svg back to editor

/*
export function svgPathToBezierMap(svgPath) {

  const lines = [];
  const controls = [];

  if (!svgPath || typeof svgPath !== "string") {
    return { lines, controls };
  }


  const commands = svgPath.match(/[MLCQZmlcqz][^MLCQZmlcqz]/g);

  if (!commands) {
    return { lines, controls };
  }


  let points = [];
  let ctrl = [];

  let current = { x: 0, y: 0 };
  let startPoint = null;


  // Push current contour into output
  const saveContour = () => {

    if (points.length > 1) {

      lines.push({
        points,
        allowStroke: true,
        alpha: 1,
        strokeWidth: 1,
        stroke: 1,
        strokeColor: "#000000",
        fill: false,
        fillColor: "#000000"
      });


      controls.push({
        controls: ctrl
      });
    }


    // Start new contour
    points = [];
    ctrl = [];
  };


  commands.forEach(cmd => {

    const type = cmd[0];

    const nums = cmd
      .slice(1)
      .trim()
      .split(/[\s,]+/)
      .filter(Boolean)
      .map(Number);


    switch(type) {


      case "M":
      case "m":
      {

        // If a new M appears, save previous contour
        if (points.length > 0) {
          saveContour();
        }


        current = {
          x: type === "m" ? current.x + nums[0] : nums[0],
          y: type === "m" ? current.y + nums[1] : nums[1]
        };


        points.push({...current});

        ctrl.push({
          x1: current.x,
          y1: current.y,
          x2: current.x,
          y2: current.y
        });


        startPoint = {...current};

        break;
      }



      case "C":
      case "c":
      {

        const c1 = {
          x: type === "c" ? current.x + nums[0] : nums[0],
          y: type === "c" ? current.y + nums[1] : nums[1]
        };


        const c2 = {
          x: type === "c" ? current.x + nums[2] : nums[2],
          y: type === "c" ? current.y + nums[3] : nums[3]
        };


        const end = {
          x: type === "c" ? current.x + nums[4] : nums[4],
          y: type === "c" ? current.y + nums[5] : nums[5]
        };


        ctrl[ctrl.length - 1].x2 = c1.x;
        ctrl[ctrl.length - 1].y2 = c1.y;


        points.push(end);

        ctrl.push({
          x1: c2.x,
          y1: c2.y,
          x2: end.x,
          y2: end.y
        });


        current = end;

        break;
      }



      case "Q":
      case "q":
      {

        const qControl = {
          x: type === "q" ? current.x + nums[0] : nums[0],
          y: type === "q" ? current.y + nums[1] : nums[1]
        };


        const end = {
          x: type === "q" ? current.x + nums[2] : nums[2],
          y: type === "q" ? current.y + nums[3] : nums[3]
        };


        const c1 = {
          x: current.x + (2 / 3) * (qControl.x - current.x),
          y: current.y + (2 / 3) * (qControl.y - current.y)
        };


        const c2 = {
          x: end.x + (2 / 3) * (qControl.x - end.x),
          y: end.y + (2 / 3) * (qControl.y - end.y)
        };


        ctrl[ctrl.length - 1].x2 = c1.x;
        ctrl[ctrl.length - 1].y2 = c1.y;


        points.push(end);

        ctrl.push({
          x1: c2.x,
          y1: c2.y,
          x2: end.x,
          y2: end.y
        });


        current = end;

        break;
      }



      case "L":
      case "l":
      {

        const end = {
          x: type === "l" ? current.x + nums[0] : nums[0],
          y: type === "l" ? current.y + nums[1] : nums[1]
        };


        const c1 = {
          x: current.x + (end.x - current.x) / 3,
          y: current.y + (end.y - current.y) / 3
        };


        const c2 = {
          x: current.x + 2 * (end.x - current.x) / 3,
          y: current.y + 2 * (end.y - current.y) / 3
        };


        ctrl[ctrl.length - 1].x2 = c1.x;
        ctrl[ctrl.length - 1].y2 = c1.y;


        points.push(end);

        ctrl.push({
          x1: c2.x,
          y1: c2.y,
          x2: end.x,
          y2: end.y
        });


        current = end;

        break;
      }



      case "Z":
      case "z":
      {

        // Close contour
        if (startPoint &&
            (current.x !== startPoint.x ||
             current.y !== startPoint.y)) {

          points.push({...startPoint});

          ctrl.push({
            x1: startPoint.x,
            y1: startPoint.y,
            x2: startPoint.x,
            y2: startPoint.y
          });
        }


        current = {...startPoint};


        // Save this contour
        saveContour();

        startPoint = null;

        break;
      }

    }

  });


  // Save anything not closed by Z
  if (points.length > 0) {
    saveContour();
  }


  return {
    lines,
    controls
  };
}
*/


function arcToBezier(
  x1,
  y1,
  rx,
  ry,
  angle,
  largeArcFlag,
  sweepFlag,
  x2,
  y2
) {

  const curves = [];

  rx = Math.abs(rx);
  ry = Math.abs(ry);

  if (rx === 0 || ry === 0) {
      return [{
          c1:{x:x1,y:y1},
          c2:{x:x2,y:y2},
          end:{x:x2,y:y2}
      }];
  }


  const phi =
      angle * Math.PI / 180;


  const cosPhi =
      Math.cos(phi);

  const sinPhi =
      Math.sin(phi);


  const dx =
      (x1-x2)/2;

  const dy =
      (y1-y2)/2;


  const x1p =
      cosPhi*dx +
      sinPhi*dy;

  const y1p =
      -sinPhi*dx +
      cosPhi*dy;



  let lambda =
      (x1p*x1p)/(rx*rx) +
      (y1p*y1p)/(ry*ry);


  if(lambda > 1){

      const scale =
          Math.sqrt(lambda);

      rx *= scale;
      ry *= scale;
  }



  const sign =
      largeArcFlag === sweepFlag
      ? -1
      : 1;



  const sq =
      Math.max(
          0,
          (
              (rx*rx*ry*ry) -
              (rx*rx*y1p*y1p) -
              (ry*ry*x1p*x1p)
          )
          /
          (
              (rx*rx*y1p*y1p) +
              (ry*ry*x1p*x1p)
          )
      );



  const coef =
      sign * Math.sqrt(sq);



  const cxp =
      coef *
      ((rx*y1p)/ry);


  const cyp =
      coef *
      (-(ry*x1p)/rx);



  const cx =
      cosPhi*cxp -
      sinPhi*cyp +
      (x1+x2)/2;


  const cy =
      sinPhi*cxp +
      cosPhi*cyp +
      (y1+y2)/2;


  function vectorAngle(u, v) {

    const dot =
        u.x * v.x +
        u.y * v.y;


    const len =
        Math.sqrt(
            (u.x*u.x + u.y*u.y) *
            (v.x*v.x + v.y*v.y)
        );


    if(len === 0) {
        return 0;
    }


    let angle =
        Math.acos(
            Math.min(
                1,
                Math.max(
                    -1,
                    dot / len
                )
            )
        );


    const cross =
        u.x*v.y -
        u.y*v.x;


    if(cross < 0) {
        angle = -angle;
    }


    return angle;
  }


  const v1 = {
      x:(x1p-cxp)/rx,
      y:(y1p-cyp)/ry
  };


  const v2 = {
      x:(-x1p-cxp)/rx,
      y:(-y1p-cyp)/ry
  };


  let theta1 =
      vectorAngle(
          {x:1,y:0},
          v1
      );


  let delta =
      vectorAngle(
          v1,
          v2
      );


  if(!sweepFlag && delta>0)
      delta -= 2*Math.PI;

  if(sweepFlag && delta<0)
      delta += 2*Math.PI;


  // console.log({
  //      theta1,
  //      delta,
  //      rx,
  //      ry,
  //      x1,
  //      y1,
  //      x2,
  //      y2
  //  });

  if(!Number.isFinite(delta) || Math.abs(delta) < 0.000001)
  {
      return [{
          c1:{x:x1,y:y1},
          c2:{x:x2,y:y2},
          end:{x:x2,y:y2}
      }];
  }      

  // split large arcs into smaller pieces
  const segments =
      Math.ceil(
          Math.abs(delta)/(Math.PI/2)
      );


  const deltaSegment =
      delta/segments;



  for(let i=0;i<segments;i++){

      const t1 =
          theta1 +
          i*deltaSegment;

      const t2 =
          t1 +
          deltaSegment;


      const alpha =
          (4/3) *
          Math.tan(
              (t2-t1)/4
          );


      const p1 = {
          x: rx*Math.cos(t1),
          y: ry*Math.sin(t1)
      };


      const p2 = {
          x: rx*Math.cos(t2),
          y: ry*Math.sin(t2)
      };


      const c1 = {
          x:p1.x-alpha*rx*Math.sin(t1),
          y:p1.y+alpha*ry*Math.cos(t1)
      };


      const c2 = {
          x:p2.x+alpha*rx*Math.sin(t2),
          y:p2.y-alpha*ry*Math.cos(t2)
      };


      const end = {
          x:p2.x,
          y:p2.y
      };


      function transform(p){

          return {
              x:
                  cosPhi*p.x -
                  sinPhi*p.y +
                  cx,

              y:
                  sinPhi*p.x +
                  cosPhi*p.y +
                  cy
          };

      }


      curves.push({

          c1:transform(c1),
          c2:transform(c2),
          end:transform(end)

      });

  }
  return curves;
}

function tokenizeSvgPath(path) {
  const tokens = path.match(
    /[a-zA-Z]|[-+]?(?:\d*\.\d+|\d+\.?)(?:[eE][-+]?\d+)?/g
  );

  return tokens || [];
}

const commandLengths = {
  M: 2,
  m: 2,
  L: 2,
  l: 2,
  H: 1,
  h: 1,
  V: 1,
  v: 1,
  C: 6,
  c: 6,
  S: 4,
  s: 4,
  Q: 4,
  q: 4,
  T: 2,
  t: 2,
  A: 7,
  a: 7,
  Z: 0,
  z: 0
};


function parsePathTokens(tokens) {
  let i = 0;
  let cmd = null;
  const commands = [];

  while (i < tokens.length) {

    if (/[a-zA-Z]/.test(tokens[i])) {
      cmd = tokens[i++];
    }

    const length = commandLengths[cmd];

    if (length === undefined) {
      throw new Error("Unknown command " + cmd);
    }

    if (length === 0) {
      commands.push({cmd});
      continue;
    }

    const values = [];

    while (
      i < tokens.length &&
      !/[a-zA-Z]/.test(tokens[i])
    ) {
      values.push(Number(tokens[i++]));

      if (values.length === length) {
        commands.push({
          cmd,
          values: [...values]
        });

        values.length = 0;

        // M/l/c etc can repeat without a command letter
        if (cmd === "M") cmd = "L";
        if (cmd === "m") cmd = "l";
      }
    }
  }

  return commands;
}



function getSignedArea(points)
{
    let area = 0;

    for(let i = 0; i < points.length; i++)
    {
        const p1 = points[i];
        const p2 = points[(i + 1) % points.length];

        area += 
            (p2.x - p1.x) *
            (p2.y + p1.y);
    }

    return area;
}

function getBezierSignedArea(points, controls)
{
    const sampled=[];

    for(let i=0;i<points.length-1;i++)
    {
        const p0=points[i];
        const p3=points[i+1];
        const c=controls[i];

        for(let t=0;t<=1;t+=0.1)
        {
            const mt=1-t;

            sampled.push({
                x:
                mt*mt*mt*p0.x +
                3*mt*mt*t*c.x2 +
                3*mt*t*t*c.x1 +
                t*t*t*p3.x,

                y:
                mt*mt*mt*p0.y +
                3*mt*mt*t*c.y2 +
                3*mt*t*t*c.y1 +
                t*t*t*p3.y
            });
        }
    }


    return getSignedArea(sampled);
}

function sampleBezier(points, controls)
{
    const sampled=[];

    for(let i=0;i<points.length-1;i++)
    {
        const p0=points[i];
        const p3=points[i+1];
        const c=controls[i];

        for(let t=0;t<=1;t+=0.05)
        {
            const mt=1-t;

            sampled.push({
                x:
                mt*mt*mt*p0.x+
                3*mt*mt*t*c.x2+
                3*mt*t*t*c.x1+
                t*t*t*p3.x,

                y:
                mt*mt*mt*p0.y+
                3*mt*mt*t*c.y2+
                3*mt*t*t*c.y1+
                t*t*t*p3.y
            });
        }
    }

    return sampled;
}

function getContourCenter(points)
{
    let x = 0;
    let y = 0;

    for(const p of points)
    {
        x += p.x;
        y += p.y;
    }

    return {
        x:x / points.length,
        y:y / points.length
    };
}

function pointInPolygon(point, polygon)
{
    let inside = false;

    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++)
    {
        const xi = polygon[i].x;
        const yi = polygon[i].y;

        const xj = polygon[j].x;
        const yj = polygon[j].y;


        const intersect =
            ((yi > point.y) !== (yj > point.y)) &&
            (point.x <
                (xj - xi) *
                (point.y - yi) /
                (yj - yi) +
                xi);


        if (intersect)
        {
            inside = !inside;
        }
    }

    return inside;
}

function markFontHoles(lines)
{
    for (const line of lines)
    {
        line.isHole = false;
    }


    for (let i = 0; i < lines.length; i++)
    {
        const current = lines[i];

        let contained = false;


        for (let j = 0; j < lines.length; j++)
        {
            if(i === j)
                continue;


            const other = lines[j];


            if(Math.abs(other.contourArea) <= 
               Math.abs(current.contourArea))
                continue;


            if(pointInPolygon(                
                getContourCenter(current.points),
                other.sampledPoints))
            {
                contained = true;
                break;
            }
        }


        const windingOpposite =
            Math.sign(current.contourArea) !==
            Math.sign(lines[0].contourArea);


        /*
          Hole if:
          - it is contained
          AND
          - winding agrees with font convention
            OR winding is opposite
        */

        if(contained && windingOpposite)
        {
            current.isHole = true;
        }
    }

    
    for(const line of lines)
    {
        if(line.isHole)
        {
            line.allowFill = true;
            line.fillColor = "#FFFFFF";
        }
    }    
}


export function svgPathToBezierMap(svgPath, rect = null) {

  const lines = [];
  const controls = [];

  // console.log("svgPath: ", svgPath);

  if (!svgPath || typeof svgPath !== "string") 
  {

      return { lines, controls };
  }

  
  const tokens = tokenizeSvgPath(svgPath);
  if(tokens.length === 0)
  {
    return {lines, controls};
  }


  let commands = parsePathTokens(tokens);

//   console.log("Commands: ", commands);
  /*
  const commands =
      svgPath.match(
        /[a-zA-Z][^a-zA-Z]/g
      );
 
  */

  

  // console.log("commands: ",commands);

  if (!commands) {
      return { lines, controls };
  }

  let points = [];
  let ctrl = [];

  let current = {
      x:0,
      y:0
  };

  let startPoint = null;

  let lastControl = null;

  const saveContour = () => 
  {

      // Old font behavior:
      // save closed contours.
      //
      // New behavior:
      // also save open SVG paths (OpenMoji)
      if (ctrl.length > 0 && points.length > 1) {
          
          const area = getBezierSignedArea(points, ctrl);
          const sampled = sampleBezier(points, ctrl);
          let l = {};
          if(rect === null)
          {
            l = {
              points,

              allowStroke:true,
              alpha:1,

              strokeWidth:1,
              stroke:1,

              strokeColor:"#000000",

              fill:true,
              fillColor:"#000000"
            }
          }
          else
          {
            l = 
            {
              points,

              fillColor: rect.fillColor,
              strokeColor: rect.strokeColor,
              strokeWidth: rect.strokeWidth,
              allowStroke: rect.allowStroke,
              allowFill: rect.allowFill,
              fillMode: rect.fillMode,
              gradientColor1: rect.gradientColor1,
              gradientColor2: rect.gradientColor2,
              gradientAngle: rect.gradientAngle,
              alpha: rect.alpha,
              contourArea: area,
              sampledPoints: sampled
            }
          }

         
          lines.push(l);


          controls.push({
              controls:ctrl
          });

      }

      points = [];
      ctrl = [];
      lastControl = null;
  };


  commands.forEach(cmd => 
  {

      const type = cmd.cmd;
      const nums = cmd.values || [];
      

      switch(type) {

      case "M":
      case "m":
      {

          if (points.length > 0) {
              saveContour();
          }


          current = {

              x:
              type==="m"
              ? current.x + nums[0]
              : nums[0],

              y:
              type==="m"
              ? current.y + nums[1]
              : nums[1]
          };


          points.push({...current});


          ctrl.push({

              x1:current.x,
              y1:current.y,

              x2:current.x,
              y2:current.y

          });


          startPoint =
              {...current};


          break;
      }


      case "C":
      case "c":
      {

          const c1 = {

              x:type==="c"
              ? current.x+nums[0]
              : nums[0],

              y:type==="c"
              ? current.y+nums[1]
              : nums[1]

          };


          const c2 = {

              x:type==="c"
              ? current.x+nums[2]
              : nums[2],

              y:type==="c"
              ? current.y+nums[3]
              : nums[3]

          };


          const end = {

              x:type==="c"
              ? current.x+nums[4]
              : nums[4],

              y:type==="c"
              ? current.y+nums[5]
              : nums[5]

          };


          ctrl[ctrl.length-1].x2=c1.x;
          ctrl[ctrl.length-1].y2=c1.y;


          points.push(end);


          ctrl.push({

              x1:c2.x,
              y1:c2.y,

              x2:end.x,
              y2:end.y

          });


          current=end;

          lastControl=c2;

          break;
      }




      case "S":
      case "s":
      {

          const c1 = lastControl
          ? {
              x:2*current.x-lastControl.x,
              y:2*current.y-lastControl.y
            }
          : {...current};



          const c2 = {

              x:type==="s"
              ? current.x+nums[0]
              : nums[0],

              y:type==="s"
              ? current.y+nums[1]
              : nums[1]

          };


          const end = {

              x:type==="s"
              ? current.x+nums[2]
              : nums[2],

              y:type==="s"
              ? current.y+nums[3]
              : nums[3]

          };


          ctrl[ctrl.length-1].x2=c1.x;
          ctrl[ctrl.length-1].y2=c1.y;


          points.push(end);


          ctrl.push({

              x1:c2.x,
              y1:c2.y,

              x2:end.x,
              y2:end.y

          });


          current=end;
          lastControl=c2;

          break;

      }




      case "L":
      case "l":
      {

          const end = {

              x:type==="l"
              ? current.x+nums[0]
              : nums[0],

              y:type==="l"
              ? current.y+nums[1]
              : nums[1]

          };


          const c1 = {

              x:current.x+(end.x-current.x)/3,
              y:current.y+(end.y-current.y)/3

          };


          const c2 = {

              x:current.x+2*(end.x-current.x)/3,
              y:current.y+2*(end.y-current.y)/3

          };


          ctrl[ctrl.length-1].x2=c1.x;
          ctrl[ctrl.length-1].y2=c1.y;


          points.push(end);


          ctrl.push({

              x1:c2.x,
              y1:c2.y,

              x2:end.x,
              y2:end.y

          });


          current=end;

          break;

      }

      case "H":
      case "h":
      {

          const end = {

              x:type==="h"
              ? current.x+nums[0]
              : nums[0],

              y:current.y

          };


          points.push(end);


          ctrl.push({

              x1:current.x,
              y1:current.y,

              x2:end.x,
              y2:end.y

          });


          current=end;

          break;

      }

      case "V":
      case "v":
      {

          const end = {

              x:current.x,

              y:type==="v"
              ? current.y+nums[0]
              : nums[0]

          };


          points.push(end);


          ctrl.push({

              x1:current.x,
              y1:current.y,

              x2:end.x,
              y2:end.y

          });


          current=end;

          break;

      }

      case "Q":
      case "q":
      {

          const q = {

              x:type==="q"
              ? current.x+nums[0]
              : nums[0],

              y:type==="q"
              ? current.y+nums[1]
              : nums[1]

          };


          const end = {

              x:type==="q"
              ? current.x+nums[2]
              : nums[2],

              y:type==="q"
              ? current.y+nums[3]
              : nums[3]

          };


          const c1 = {

              x:current.x+
              (2/3)*(q.x-current.x),

              y:current.y+
              (2/3)*(q.y-current.y)

          };


          const c2 = {

              x:end.x+
              (2/3)*(q.x-end.x),

              y:end.y+
              (2/3)*(q.y-end.y)

          };


          ctrl[ctrl.length-1].x2=c1.x;
          ctrl[ctrl.length-1].y2=c1.y;


          points.push(end);


          ctrl.push({

              x1:c2.x,
              y1:c2.y,

              x2:end.x,
              y2:end.y

          });


          current=end;
          lastControl=q;

          break;

      }

      case "Z":
      case "z":
      {

          if(startPoint &&
            (current.x!==startPoint.x ||
             current.y!==startPoint.y))
          {

              points.push({...startPoint});

              ctrl.push({

                  x1:startPoint.x,
                  y1:startPoint.y,

                  x2:startPoint.x,
                  y2:startPoint.y

              });
          }

          if(startPoint) 
          {
            current={...startPoint};        
          }        
          // current={...startPoint};

          saveContour();


          startPoint=null;

          break;

      }


      case "A":
      case "a":
      {

          if(nums.length < 7) {

            console.warn(
                "Invalid arc command",
                cmd,
                nums
            );
    
            break;
          }

          const rx = nums[0];
          const ry = nums[1];
          const rotation = nums[2];

          const largeArc = nums[3];
          const sweep = nums[4];


          const end = {

              x:type==="a"
              ? current.x + nums[5]
              : nums[5],

              y:type==="a"
              ? current.y + nums[6]
              : nums[6]

          };


          const curves =
              arcToBezier(
                  current.x,
                  current.y,
                  rx,
                  ry,
                  rotation,
                  largeArc,
                  sweep,
                  end.x,
                  end.y
              );


          curves.forEach(curve=>{

              ctrl[ctrl.length-1].x2 =
                  curve.c1.x;

              ctrl[ctrl.length-1].y2 =
                  curve.c1.y;


              points.push(curve.end);


              ctrl.push({

                  x1:curve.c2.x,
                  y1:curve.c2.y,

                  x2:curve.end.x,
                  y2:curve.end.y

              });

          });


          current=end;

          lastControl=null;


          // console.log(
          //  "ARC",
          //  {
          //      current,
          //      rx,
          //      ry,
          //      rotation,
          //      largeArc,
          //      sweep,
          //      end
          //  }
          // );
        
        
          // console.log(
          //  "ARC CURVES",
          //  curves
          // );

          break;
      }
    }


  });



  if(points.length>  1){
      saveContour();
  }

  if(rect != null)
  {
    markFontHoles(lines)
  }

  return {
      lines,
      controls
  };
}



function svgTransformToMatrix(transformString)
{
    let matrix = new DOMMatrix();


    const commands =
        transformString.match(
            /[a-zA-Z]+\([^)]*\)/g
        );


    if(!commands)
        return matrix;


    commands.forEach(command =>
    {
        const name =
            command.substring(
                0,
                command.indexOf("(")
            );


        const values =
            command
            .match(
                /[-+]?(?:\d*\.\d+|\d+\.?)(?:[eE][-+]?\d+)?/g
            )
            ?.map(Number)
            ||
            [];


        let m = new DOMMatrix();


        switch(name)
        {

            case "matrix":
            {
                m =
                    new DOMMatrix([
                        values[0],
                        values[1],
                        values[2],
                        values[3],
                        values[4],
                        values[5]
                    ]);

                break;
            }


            case "translate":
            {
                m =
                    new DOMMatrix()
                    .translate(
                        values[0] || 0,
                        values[1] || 0
                    );

                break;
            }


            case "scale":
            {
                m =
                    new DOMMatrix()
                    .scale(
                        values[0],
                        values[1] ?? values[0]
                    );

                break;
            }


            case "rotate":
            {
                m =
                    new DOMMatrix()
                    .rotate(
                        values[0] || 0
                    );

                break;
            }


            case "skewX":
            {
                m =
                    new DOMMatrix()
                    .skewX(
                        values[0] || 0
                    );

                break;
            }


            case "skewY":
            {
                m =
                    new DOMMatrix()
                    .skewY(
                        values[0] || 0
                    );

                break;
            }
        }


        matrix =
            matrix.multiply(m);

    });


    return matrix;
}

function applyParentTransforms(element) {

  let transforms = [];
  // let current = element.parentElement;

  let current = element;   // <-- change this


  while(current) 
  {
      /*
      console.log(
        "PARENT:",
        current.tagName,
        "transform:",
        current.getAttribute("transform")
      );
      */
      const transform =
          current.getAttribute("transform");

      if(transform) 
      {
          transforms.unshift(transform);
      }


     current = current.parentElement;

  }

  if(transforms.length === 0)
      return;

  console.log(
        "ALL TRANSFORMS:",
        transforms
    );

  const matrix =
    svgTransformToMatrix(
        transforms.join(" ")
    );
  

  /*
  if(element.tagName === "path") 
  {
      const d =
          element.getAttribute("d");

      const path =
          new Path2D(d);

  }
  */
  // store matrix for later use
  element._svgMatrix = matrix;

}

function getInheritedAttribute(element, attribute)
{
    let current = element;

    while(current)
    {
        const value =
            current.getAttribute(attribute);

        if(value)
            return value;

        current =
            current.parentElement;
    }

    return null;
}


function getViewBoxMatrix(svg)
{
    const viewBox =
        svg.getAttribute("viewBox");


    if(!viewBox)
        return new DOMMatrix();


    const values =
        viewBox
        .split(/\s+/)
        .map(Number);


    const minX = values[0];
    const minY = values[1];
    const width = values[2];
    const height = values[3];


    const svgWidth =
        Number(
            svg.getAttribute("width")
        )
        ||
        width;


    const svgHeight =
        Number(
            svg.getAttribute("height")
        )
        ||
        height;


    const scaleX =
        svgWidth / width;

    const scaleY =
        svgHeight / height;


    return new DOMMatrix()
        .translate(
            -minX,
            -minY
        )
        .scale(
            scaleX,
            scaleY
        );
}

export function aiSvgToBezierMap(svgString) {

  const lines = [];
  const controls = [];

  try {

      console.log("AI SVG String:", svgString);


      /*
       * --------------------------------------------------------
       * Validate input
       * --------------------------------------------------------
       */

      if (
          !svgString ||
          typeof svgString !== "string"
      ) {

          console.error(
              "aiSvgToBezierMap: invalid SVG string"
          );

          return {
              lines,
              controls
          };
      }


      /*
       * --------------------------------------------------------
       * Remove markdown code fences if Astra happens to return:
       *
       * ```svg
       * <svg ...>
       * ...
       * </svg>
       * ```
       *
       * This makes the function more tolerant of AI output.
       * --------------------------------------------------------
       */

      let svgText =
          svgString.trim();


      svgText =
          svgText
              .replace(/^```(?:svg|xml)?\s*/i, "")
              .replace(/\s*```$/i, "")
              .trim();


      /*
       * --------------------------------------------------------
       * Parse SVG
       * --------------------------------------------------------
       */

      const parser =
          new DOMParser();


      const svgDoc =
          parser.parseFromString(
              svgText,
              "image/svg+xml"
          );


      /*
       * --------------------------------------------------------
       * Check for parser errors
       * --------------------------------------------------------
       */

      const parserError =
          svgDoc.querySelector(
              "parsererror"
          );


      if (parserError) {

          console.error(
              "Invalid AI SVG:",
              parserError.textContent
          );

          return {
              lines,
              controls
          };
      }


      /*
       * --------------------------------------------------------
       * Get SVG root
       * --------------------------------------------------------
       */

      const svg =
          svgDoc.querySelector("svg");


      if (!svg) {

          console.error(
              "aiSvgToBezierMap: no <svg> element found"
          );

          return {
              lines,
              controls
          };
      }


      /*
       * --------------------------------------------------------
       * ViewBox
       * --------------------------------------------------------
       */

      const viewBox =
          svg.getAttribute("viewBox");


      console.log(
          "AI SVG viewBox:",
          viewBox
      );


      /*
       * --------------------------------------------------------
       * Debug element structure
       * --------------------------------------------------------
       */

      console.log(
          [...svgDoc.querySelectorAll("*")]
              .map(e => e.tagName)
      );


      /*
       * --------------------------------------------------------
       * Debug groups
       * --------------------------------------------------------
       */

      [...svgDoc.querySelectorAll("g")]
          .forEach((g, i) => {

              console.log(
                  "GROUP",
                  i,
                  "transform:",
                  g.getAttribute("transform"),
                  "fill:",
                  g.getAttribute("fill"),
                  "stroke:",
                  g.getAttribute("stroke"),
                  "stroke-width:",
                  g.getAttribute("stroke-width")
              );

          });


      /*
       * --------------------------------------------------------
       * Get SVG elements
       *
       * This is intentionally the same element selection
       * used by your working svgFileToBezierMap().
       * --------------------------------------------------------
       */

      const elements =
          [
              ...svgDoc.querySelectorAll(
                  "path,circle,ellipse,rect,line,polyline,polygon"
              )
          ]
          .filter(
              el => !el.closest("defs")
          );


      /*
       * --------------------------------------------------------
       * ViewBox transformation
       * --------------------------------------------------------
       */

      const viewBoxMatrix =
          getViewBoxMatrix(svg);


      /*
       * --------------------------------------------------------
       * Process every SVG element
       * --------------------------------------------------------
       */

      elements.forEach(element => {


          /*
           * ----------------------------------------------------
           * Apply parent transforms
           * ----------------------------------------------------
           */

          applyParentTransforms(
              element
          );


          console.log(
              "Element:",
              element.tagName,
              "transform:",
              element._svgMatrix
          );


          /*
           * ----------------------------------------------------
           * Combine viewBox transformation with element
           * transformation.
           * ----------------------------------------------------
           */

          const finalMatrix =
              viewBoxMatrix.multiply(
                  element._svgMatrix
                  ||
                  new DOMMatrix()
              );


          console.log(
              "FinalMatrix:",
              finalMatrix
          );


          /*
           * ----------------------------------------------------
           * Convert geometry to your Bezier representation.
           * ----------------------------------------------------
           */

          const result =
              svgElementToBezierMap(
                  element,
                  finalMatrix
              );


          /*
           * ----------------------------------------------------
           * Get inline style.
           *
           * Example:
           *
           * style="fill:#ff0000;stroke:#000000"
           * ----------------------------------------------------
           */

          const style =
              element.getAttribute(
                  "style"
              ) || "";


          const getStyleValue =
              (name) => {

                  const match =
                      style.match(
                          new RegExp(
                              `${name}\\s*:\\s*([^;]+)`,
                              "i"
                          )
                      );


                  return match
                      ? match[1].trim()
                      : null;
              };


          /*
           * ----------------------------------------------------
           * FILL
           *
           * getInheritedAttribute() allows:
           *
           * <g fill="red">
           *     <path ... />
           * </g>
           *
           * to pass "red" to the path.
           *
           * Inline style is also supported.
           * ----------------------------------------------------
           */

          const fill =
              getInheritedAttribute(
                  element,
                  "fill"
              )
              ??
              getStyleValue("fill")
              ??
              "#000000";


          /*
           * ----------------------------------------------------
           * STROKE
           * ----------------------------------------------------
           */

          const stroke =
              getInheritedAttribute(
                  element,
                  "stroke"
              )
              ??
              getStyleValue("stroke")
              ??
              "none";


          /*
           * ----------------------------------------------------
           * STROKE WIDTH
           * ----------------------------------------------------
           */

          const strokeWidth =
              Number(
                  getInheritedAttribute(
                      element,
                      "stroke-width"
                  )
                  ??
                  getStyleValue(
                      "stroke-width"
                  )
                  ??
                  1
              );


          /*
           * ----------------------------------------------------
           * OPACITY
           * ----------------------------------------------------
           */

          const opacity =
              Number(
                  getInheritedAttribute(
                      element,
                      "opacity"
                  )
                  ??
                  getStyleValue(
                      "opacity"
                  )
                  ??
                  1
              );


          /*
           * ----------------------------------------------------
           * FILL OPACITY
           * ----------------------------------------------------
           */

          const fillOpacity =
              Number(
                  getInheritedAttribute(
                      element,
                      "fill-opacity"
                  )
                  ??
                  getStyleValue(
                      "fill-opacity"
                  )
                  ??
                  1
              );


          /*
           * ----------------------------------------------------
           * STROKE OPACITY
           * ----------------------------------------------------
           */

          const strokeOpacity =
              Number(
                  getInheritedAttribute(
                      element,
                      "stroke-opacity"
                  )
                  ??
                  getStyleValue(
                      "stroke-opacity"
                  )
                  ??
                  1
              );


          /*
           * ----------------------------------------------------
           * Safe numeric values
           * ----------------------------------------------------
           */

          const safeOpacity =
              Number.isFinite(opacity)
                  ? opacity
                  : 1;


          const safeFillOpacity =
              Number.isFinite(fillOpacity)
                  ? fillOpacity
                  : 1;


          const safeStrokeOpacity =
              Number.isFinite(strokeOpacity)
                  ? strokeOpacity
                  : 1;


          const safeStrokeWidth =
              Number.isFinite(strokeWidth)
                  ? strokeWidth
                  : 1;


          /*
           * ----------------------------------------------------
           * Apply style to converted Bezier lines.
           * ----------------------------------------------------
           */

          result.lines.forEach(line => {


              /*
               * FILL
               */

              line.allowFill =
                  fill !== "none";


              line.fillColor =
                  fill;


              /*
               * STROKE
               */

              line.allowStroke =
                  stroke !== "none";


              line.strokeColor =
                  stroke === "none"
                      ? "#000000"
                      : stroke;


              line.strokeWidth =
                  safeStrokeWidth;


              /*
               * OPACITY
               */

              line.alpha =
                  safeOpacity *
                  safeFillOpacity;


              /*
               * Keep stroke opacity available.
               */

              line.strokeAlpha =
                  safeOpacity *
                  safeStrokeOpacity;


              /*
               * Default fill mode.
               */

              line.fillMode =
                  "solid";

          });


          /*
           * ----------------------------------------------------
           * Add converted result.
           * ----------------------------------------------------
           */

          lines.push(
              ...result.lines
          );


          controls.push(
              ...result.controls
          );

      });


      /*
       * --------------------------------------------------------
       * Return final Bezier map
       * --------------------------------------------------------
       */

      return {
          lines,
          controls
      };

  }
  catch (err) {

      console.error(
          "AI SVG conversion error:",
          err
      );


      return {
          lines,
          controls
      };
  }
}


export async function svgFileToBezierMap(svgUrl, isLocal=false) {

  const lines = [];
  const controls = [];

  try {

      console.log("Url:", svgUrl);


      let svgText = "";
      if(!isLocal)
      {
        const response =
          await fetch(svgUrl);


        svgText =
          await response.text();
      }
      else
      {
        svgText = svgUrl;
      }


      const parser =
          new DOMParser();


      const svgDoc =
          parser.parseFromString(
              svgText,
              "image/svg+xml"
          );

      const svg =
          svgDoc.querySelector("svg");
      
      
      const viewBox =
          svg?.getAttribute("viewBox");    
      
      // console.log("viewBox:", viewBox);
      
    
      /*
      console.log([...svgDoc.querySelectorAll("*")].map(e => e.tagName));
                  
      [...svgDoc.querySelectorAll("g")].forEach((g, i) => {
        console.log(
          "GROUP",
          i,
          "transform:",
          g.getAttribute("transform"),
          "fill:",
          g.getAttribute("fill"),
          "stroke:",
          g.getAttribute("stroke")
        );
      });
      */
      
    
      const elements =
          [...svgDoc.querySelectorAll( "path,circle,ellipse,rect, line, polyline, polygon")].filter(
            el => !el.closest("defs")
        );
    

      elements.forEach(element => {

            applyParentTransforms(element);

            const viewBoxMatrix =
            getViewBoxMatrix(svg);

            /*
            console.log(
              "transform:",
              element._svgMatrix
          );
          */


        const finalMatrix =
            viewBoxMatrix.multiply(
                element._svgMatrix
                ||
                new DOMMatrix()
            );


            // console.log("FinalMatrix: ", finalMatrix);

            const result =
                svgElementToBezierMap(element, finalMatrix);
        
        
            const style =
                element.getAttribute("style") || "";
        
        
            const getStyleValue = (name) =>
            {
                const match =
                    style.match(
                        new RegExp(
                            `${name}\\s*:\\s*([^;]+)`
                        )
                    );
        
                return match
                    ? match[1].trim()
                    : null;
            };


            const fill =
              getInheritedAttribute(element,"fill")
              ??
              getStyleValue("fill")
              ??
              "#000000";


              const stroke =
                getInheritedAttribute(element, "stroke")
                ??
                getStyleValue("stroke")
                ??
                "none";
        
              const strokeWidth =
                  Number(
                      getInheritedAttribute(element, "stroke-width")
                      ??
                      getStyleValue("stroke-width")
                      ??
                      1
                  );                  
        
                    /*
            const strokeWidth =
                Number(
                    element.getAttribute("stroke-width")
                    ||
                    getStyleValue("stroke-width")
                    ||
                    1
                );
        
                  */
            result.lines.forEach(line =>
            {
                line.allowFill =
                    fill !== "none";
        
                line.fillColor =
                    fill;
        
        
                line.allowStroke =
                    stroke !== "none";
        
                line.strokeColor =
                    stroke === "none"
                    ? "#000000"
                    : stroke;
        
        
                line.strokeWidth =
                    strokeWidth;
            });
        
        
            lines.push(
                ...result.lines
            );
        
        
            controls.push(
                ...result.controls
            );
        
        });          

      return {
          lines,
          controls
      };


  }
  catch(err) {

      console.error(
          "SVG conversion error:",
          err
      );


      return {
          lines,
          controls
      };

  }
}

export function svgElementToBezierMap(element, matrix = null)
{
    const tag =
        element.tagName.toLowerCase();


    let svgPath = null;


    switch(tag)
    {

        case "path":
        {
            svgPath =
                element.getAttribute("d");

            break;
        }


        case "circle":
        {
            const cx =
                Number(element.getAttribute("cx") || 0);

            const cy =
                Number(element.getAttribute("cy") || 0);

            const r =
                Number(element.getAttribute("r") || 0);


            svgPath =
            `
            M ${cx-r},${cy}
            A ${r},${r},0,1,0,${cx+r},${cy}
            A ${r},${r},0,1,0,${cx-r},${cy}
            Z
            `;

            break;
        }


        case "ellipse":
        {
            const cx =
                Number(element.getAttribute("cx") || 0);

            const cy =
                Number(element.getAttribute("cy") || 0);

            const rx =
                Number(element.getAttribute("rx") || 0);

            const ry =
                Number(element.getAttribute("ry") || 0);


            svgPath =
            `
            M ${cx-rx},${cy}
            A ${rx},${ry},0,1,0,${cx+rx},${cy}
            A ${rx},${ry},0,1,0,${cx-rx},${cy}
            Z
            `;

            break;
        }


        case "rect":
        {
            const x =
                Number(element.getAttribute("x") || 0);

            const y =
                Number(element.getAttribute("y") || 0);

            const w =
                Number(element.getAttribute("width") || 0);

            const h =
                Number(element.getAttribute("height") || 0);


            svgPath =
            `
            M ${x},${y}
            L ${x+w},${y}
            L ${x+w},${y+h}
            L ${x},${y+h}
            Z
            `;

            break;
        }
        case "line":
        {
            const x1 =
                Number(element.getAttribute("x1") || 0);

            const y1 =
                Number(element.getAttribute("y1") || 0);

            const x2 =
                Number(element.getAttribute("x2") || 0);

            const y2 =
                Number(element.getAttribute("y2") || 0);


            svgPath =
            `
            M ${x1},${y1}
            L ${x2},${y2}
            `;

            break;
        }

        case "polyline":
        case "polygon":
        {
            const points =
                element.getAttribute("points");


            if(points)
            {
                const coords =
                    points
                    .trim()
                    .split(/[\s,]+/)
                    .map(Number);


                if(coords.length >= 4)
                {
                    svgPath =
                        `M ${coords[0]},${coords[1]}`;


                    for(let i = 2; i < coords.length; i += 2)
                    {
                        svgPath +=
                            ` L ${coords[i]},${coords[i+1]}`;
                    }


                    // polygon is closed, polyline is open
                    if(tag === "polygon")
                    {
                        svgPath += " Z";
                    }
                }
            }

            break;
        }

    }


    if(!svgPath)
    {
        return {
            lines:[],
            controls:[]
        };
    }


    const result =
    svgPathToBezierMap(svgPath);

/*
    console.log(
      "FINAL MATRIX:",
      matrix
    );
*/
    if(matrix)
    {
        applyMatrixToBezierMap(
            result,
            matrix
        );

        /*
        console.log(
          "Element parent:",
          element.outerHTML);
          */
  
    }
    

    return result;
    // return svgPathToBezierMap(svgPath);
}



function applyMatrixToBezierMap(result, matrix)
{
    if(!matrix)
        return;


    function transformPoint(x, y)
    {
        const p =
            new DOMPoint(x, y)
            .matrixTransform(matrix);

        return {
            x: p.x,
            y: p.y
        };
    }


    // Transform contour points
    result.lines.forEach(line =>
    {
        if(line.points)
        {
            line.points =
                line.points.map(point =>
                {
                    return transformPoint(
                        point.x,
                        point.y
                    );
                });
        }
    });



    // Transform bezier control handles
    result.controls.forEach(contour =>
    {
        if(contour.controls)
        {
            contour.controls =
                contour.controls.map(ctrl =>
                {
                    const p1 =
                        transformPoint(
                            ctrl.x1,
                            ctrl.y1
                        );


                    const p2 =
                        transformPoint(
                            ctrl.x2,
                            ctrl.y2
                        );


                    return {
                        x1:p1.x,
                        y1:p1.y,

                        x2:p2.x,
                        y2:p2.y
                    };
                });
        }
    });


    return result;
}

/*
export function rPathToSvg(rPath) {
  // Assume shape.rPath is an array of path segments
  return rPath.map(path => {
    const { points, stroke, strokeColor, fill, fillColor } = path;

    if (!points || points.length === 0) return "";

    // Build path string: Move to first point, then line to others, close path
    const d = points.map((p, i) => 
      `${i === 0 ? "M" : "L"} ${p.x.toFixed(6)} ${p.y.toFixed(6)}`
    ).join(" ") + " Z";

    return `<path d="${d}"
      stroke="${strokeColor || "black"}"
      stroke-width="${stroke || 1}"
      fill="${fill ? fillColor || "none" : "none"}"
    />`;
  }).join("\n");
}

*/

function getMaxGlyphWidth(font, fontSize) {
  const scale = fontSize / font.unitsPerEm;
  let maxWidth = 0;

  for (let i = 0; i < font.numGlyphs; i++) {
    const glyph = font.glyphs.get(i);
    if (glyph && glyph.advanceWidth) {
      const width = glyph.advanceWidth * scale;
      if (width > maxWidth) {
        maxWidth = width;
      }
    }
  }

  return maxWidth;
}

const fontCache = {};


function removeUnsupportedCharacters(text, font) 
{
  const cmap =
      font.tables.cmap.glyphIndexMap;

  return [...text]
      .filter(char => {
          const code =
              char.codePointAt(0);
          return cmap[code] !== undefined;
      })
      .join("");
}

export function textToSvgPath(text, fontUrl, opts, inRect, callback) {

  const processFont = (font) => {

    if (text == null) {
      console.error("Text is null or undefined");
      return;
    }

    if (!opts) {
        console.error("Options missing");
        return;
    }

    if (!Number.isFinite(opts.fontSize) || opts.fontSize <= 0) {
        console.error(
            "Invalid font size:",
            opts.fontSize
        );
        return;
    }


    const cleanText = removeUnsupportedCharacters(
        text,
        font
    );


    if (cleanText.length === 0) {
        console.warn(
            "No supported characters remain after filtering"
        );
        // return;
    }


    const { x, y, fontSize, rotation = 0 } = opts;

    const path = font.getPath(text, x, y + fontSize, fontSize);
    
    let uSvgPath = path.toPathData(6);
    const svgPath = sanitizePath(uSvgPath);
        
    const scale = fontSize / font.unitsPerEm;
    const descent = Math.abs(font.descender * scale);
    const maxWidth = getMaxGlyphWidth(font, fontSize);

    const path2D = new Path2D(svgPath);

    const bbox = path.getBoundingBox();

    const rect = {
      x: bbox.x1,
      y: bbox.y1,
      w: bbox.x2 - bbox.x1,
      h: bbox.y2 - bbox.y1,
    };

    callback({
      path2D,
      svgPath,
      rotation,
      rect,
      descent,
      maxWidth,
      inRect
    });
  };

  // ✅ Use cached font if available
  if (fontCache[fontUrl]) {
    processFont(fontCache[fontUrl]);
    return;
  }

  // ❗ Otherwise load it once
  opentype.load(fontUrl, (err, font) => {
    if (err) {
      console.log("fontUrl: ", fontUrl);
      console.error("Font load error:", err);
      return;
    }

    fontCache[fontUrl] = font; // ✅ cache it
    processFont(font);
  });
}


export function svgTextToSvgPath(svgUrl, opts, inRect, callback) {

  console.log("svgUrl", svgUrl);

  fetch(svgUrl)
  .then(response => response.text())
  .then(svgText => {

      const parser = new DOMParser();

      const svgDoc = parser.parseFromString(
          svgText,
          "image/svg+xml"
      );


      const svgElement = svgDoc.querySelector("svg");

      if (!svgElement) {
          console.error("Invalid SVG");
          return;
      }


      const paths = [
          ...svgDoc.querySelectorAll("path")
      ];


      if (paths.length === 0) {
          console.error("No SVG paths found");
          return;
      }


      let svgPath = paths
          .map(path => {
              const d = path.getAttribute("d");
              return d ? d : "";
          })
          .filter(Boolean)
          .join(" ");


     //  svgPath = sanitizePath(svgPath);


      const path2D = new Path2D(svgPath);


      const bbox = getSvgPathBounds(svgPath);


      const rect = {
          x: bbox.x,
          y: bbox.y,
          w: bbox.width,
          h: bbox.height
      };


      const rotation =
          opts?.rotation || 0;


      callback({
          path2D,
          svgPath,
          rotation,

          rect,

          // SVG has no font metrics
          descent: 0,

          maxWidth:
              bbox.width,

          inRect
      });

  })
  .catch(err => {

      console.error(
          "SVG load error:",
          err
      );

  });
}

function getSvgPathBounds(svgPath) {

  const svg =
      document.createElementNS(
          "http://www.w3.org/2000/svg",
          "svg"
      );

  const path =
      document.createElementNS(
          "http://www.w3.org/2000/svg",
          "path"
      );

  path.setAttribute(
      "d",
      svgPath
  );

  svg.appendChild(path);

  document.body.appendChild(svg);

  const box =
      path.getBBox();

  document.body.removeChild(svg);


  return {
      x: box.x,
      y: box.y,
      width: box.width,
      height: box.height
  };
}

export function sanitizePath(svgPath, precision = 2) {
  if (!svgPath) return '';

  // Keep all valid SVG commands and numbers
  let sanitized = svgPath.replace(/[^0-9eE\.\-\,MLCQZHVASTmlcqzhvas t\s]/g, '');

  // Add spaces after commands if missing
  sanitized = sanitized.replace(/([a-zA-Z])/g, ' $1 ').replace(/\s+/g, ' ').trim();

  // Reduce precision of numbers
  sanitized = sanitized.replace(/-?\d*\.?\d+(e[-+]?\d+)?/g, (num) => {
      let n = parseFloat(num);
      if (isNaN(n)) return num;
      return n.toFixed(precision);
  });

  return sanitized;
}

/*
export function sanitizePath(svgPath, precision = 2) {
  if (!svgPath) return '';

  // Keep only valid SVG commands and numbers
  let sanitized = svgPath.replace(/[^0-9eE\.\-\,MLCQZmlcqz\s]/g, '');

  // Add spaces after commands if missing
  sanitized = sanitized.replace(/([a-zA-Z])/g, ' $1 ').replace(/\s+/g, ' ').trim();

  // Reduce precision of numbers
  sanitized = sanitized.replace(/-?\d*\.?\d+(e[-+]?\d+)?/g, (num) => {
      let n = parseFloat(num);
      if (isNaN(n)) return num;
      return n.toFixed(precision);
  });

  return sanitized;
}
*/
/*
export function getPathBoundingBox(svgPathData) {
  // Create an offscreen SVG element
  const svgNS = "http://www.w3.org/2000/svg";
  const svg = document.createElementNS(svgNS, "svg");
  const path = document.createElementNS(svgNS, "path");
  path.setAttribute("d", svgPathData);
  svg.appendChild(path);
  document.body.appendChild(svg); // needed temporarily to getBBox to work

  // Get bounding box
  const bbox = path.getBBox();

  // Clean up
  document.body.removeChild(svg);

  return {
    x: bbox.x,
    y: bbox.y,
    w: bbox.width,
    h: bbox.height
  };
}
*/

// Cache to store the bounding box calculations
const boundingBoxCache = new Map();

export function getPathBoundingBox(svgPathData) {
  // Check if the bounding box is already cached
  if (boundingBoxCache.has(svgPathData)) {
    return boundingBoxCache.get(svgPathData);
  }

  // Create an offscreen canvas
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  // Create a Path2D object for the SVG path data
  const path = new Path2D(svgPathData);

  // Set up the canvas size (adjust to fit the path)
  canvas.width = 1000; // Adjust as necessary
  canvas.height = 1000; // Adjust as necessary

  // Set styles for drawing the path
  ctx.fillStyle = 'transparent'; // or any color
  ctx.strokeStyle = 'transparent'; // We won't actually fill or stroke it
  ctx.lineWidth = 0;

  // Draw the path onto the canvas
  ctx.stroke(path);

  // Get the image data to calculate the bounding box
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

  // Initialize bounding box variables
  let top = canvas.height;
  let left = canvas.width;
  let bottom = 0;
  let right = 0;

  // Scan the image data to find the bounds of the path
  for (let i = 0; i < imageData.data.length; i += 4) {
    const x = (i / 4) % canvas.width;
    const y = Math.floor(i / 4 / canvas.width);

    const alpha = imageData.data[i + 3]; // Alpha channel

    if (alpha > 0) { // If the pixel is not transparent
      top = Math.min(top, y);
      left = Math.min(left, x);
      bottom = Math.max(bottom, y);
      right = Math.max(right, x);
    }
  }

  // Calculate the bounding box (x, y, width, height)
  const boundingBox = {
    x: left,
    y: top,
    w: right - left,
    h: bottom - top
  };

  // Store the bounding box in the cache
  boundingBoxCache.set(svgPathData, boundingBox);

  return boundingBox;
}

/**
 * Draw an SVG path string on a canvas context, positioned/scaled to rect, with optional rotation and zoom
 * @param {CanvasRenderingContext2D} ctx - Canvas context
 * @param {string} svgPath - SVG path string from textToSvgPath
 * @param {number} x - Target x position
 * @param {number} y - Target y position
 * @param {number} w - Target width
 * @param {number} h - Target height
 * @param {number} rotation - Rotation in degrees (optional)
 * @param {number} zoomX - Horizontal scaling factor (optional, default 1)
 * @param {number} zoomY - Vertical scaling factor (optional, default 1)
 * @param {string} fillStyle - Fill color (optional)
 * @param {string} strokeStyle - Stroke color (optional)
 * @param {number} lineWidth - Stroke width (optional)
 */


export function drawTextPathOnCtx(
  ctx,  
  svgPath,
  x,
  y,
  w,
  h,
  rotation = 0,
  rect = null,
  zoomX = 1,
  zoomY = 1,
  fast = false // New parameter to determine if we use the fast drawing
) {
  if (!ctx || !svgPath) return;

  let rZoomX = 1;
  let rZoomY = 1;
  let fillStyle = "#000000";
  let strokeStyle = "#000000";
  let lineWidth = 1;

  if (rect != null) {
    rZoomX = rect.rZoomX;
    rZoomY = rect.rZoomY;
    fillStyle = rect.fillColor;
    strokeStyle = rect.strokeColor;
    lineWidth = rect.strokeWidth;
  }

  // Original path from SVG string
  const originalPath = new Path2D(svgPath);

  // Create new path scaled by rZoomX/rZoomY if necessary
  let pathToDraw = originalPath;

  ctx.save();

  if (rect.fillAlpha !== undefined) {
    ctx.globalAlpha = getOpacity(rect); //rect.fillAlpha;
  }

  applyEffects(ctx, rect);

  // Move to rectangle top-left and apply zoom via ctx
  ctx.translate(x, y);

  // Rotate around rectangle center
  ctx.translate(w / 2, h / 2);
  ctx.rotate((-rotation * Math.PI) / 180);
  ctx.translate(-w / 2, -h / 2);

  // If fast is true, draw a simple filled rectangle instead of the path
  if (fast) {
    // If `fast` is true, we just draw a filled rectangle to cover the area
    ctx.fillStyle = fillStyle;
    ctx.strokeRect(0, 0, w, h); // Draw a rectangle where the text would be
  } else {
    // Otherwise, we proceed with the full SVG path drawing


    if (rect.allowFill) {

      if (rect.fillMode === "gradient") {
    

        const angle = (rect.gradientAngle || 0) * Math.PI / 180;

        const dx = Math.cos(angle);
        const dy = Math.sin(angle);
      
        const cx = w / 2;
        const cy = h / 2;
      
        const halfW = w / 2;
        const halfH = h / 2;
      
        const x0 = cx - dx * halfW;
        const y0 = cy - dy * halfH;
        const x1 = cx + dx * halfW;
        const y1 = cy + dy * halfH;
      
        const grad = ctx.createLinearGradient(x0, y0, x1, y1);
      
        grad.addColorStop(0, rect.gradientColor1 || "#ffffff");
        grad.addColorStop(1, rect.gradientColor2 || "#000000");
      
        ctx.fillStyle = grad;
    
      } else {
        ctx.fillStyle = rect.fillColor;
      }
    
      ctx.fill(pathToDraw);
    }
  
  
    // Fill path
    /*
    if (rect.allowFill) {
      ctx.fillStyle = fillStyle;
      ctx.fill(pathToDraw);
    }
    */
    // Stroke path
    if (rect.allowStroke) {
      ctx.strokeStyle = strokeStyle;
      ctx.lineWidth = lineWidth;
      ctx.stroke(pathToDraw);
    }
  }

  ctx.restore();
}


export function scaleSvgPathString(svgPath, rZoomX, rZoomY) {
  if (!svgPath || !Number.isFinite(rZoomX) || !Number.isFinite(rZoomY)) {
    return svgPath;
  }

  // Proper SVG command splitter (does not break scientific notation)
  const commands = svgPath.match(/[AaCcHhLlMmQqSsTtVvZz][^AaCcHhLlMmQqSsTtVvZz]*/g);

  if (!commands) return svgPath;

  const scalePair = (nums, start = 0) => {
    for (let i = start; i + 1 < nums.length; i += 2) {
      nums[i] *= rZoomX;
      nums[i + 1] *= rZoomY;
    }
  };

  return commands.map(cmd => {
    const type = cmd[0];

    const nums = cmd
      .slice(1)
      .trim()
      .split(/[\s,]+/)
      .filter(Boolean)
      .map(Number);

    // If any number failed parsing, do not damage the path
    if (nums.some(n => !Number.isFinite(n))) {
      // console.warn("Invalid SVG command:", cmd);
      return cmd;
    }

    switch (type) {

      case 'M':
      case 'm':
      case 'L':
      case 'l':
      case 'T':
      case 't':
        scalePair(nums);
        break;


      case 'H':
      case 'h':
        for (let i = 0; i < nums.length; i++) {
          if (Number.isFinite(nums[i])) {
            nums[i] *= rZoomX;
          }
        }
        break;


      case 'V':
      case 'v':
        for (let i = 0; i < nums.length; i++) {
          if (Number.isFinite(nums[i])) {
            nums[i] *= rZoomY;
          }
        }
        break;


      case 'C':
      case 'c':
        for (let i = 0; i + 5 < nums.length; i += 6) {
          nums[i]     *= rZoomX;
          nums[i + 1] *= rZoomY;
          nums[i + 2] *= rZoomX;
          nums[i + 3] *= rZoomY;
          nums[i + 4] *= rZoomX;
          nums[i + 5] *= rZoomY;
        }
        break;


      case 'S':
      case 's':
      case 'Q':
      case 'q':
        for (let i = 0; i + 3 < nums.length; i += 4) {
          nums[i]     *= rZoomX;
          nums[i + 1] *= rZoomY;
          nums[i + 2] *= rZoomX;
          nums[i + 3] *= rZoomY;
        }
        break;


      case 'A':
      case 'a':
        for (let i = 0; i + 6 < nums.length; i += 7) {
          nums[i]     *= rZoomX; // radius x
          nums[i + 1] *= rZoomY; // radius y

          // rotation unchanged
          // flags unchanged

          nums[i + 5] *= rZoomX;
          nums[i + 6] *= rZoomY;
        }
        break;


      case 'Z':
      case 'z':
        return type;
    }

    return type + (nums.length ? " " + nums.join(" ") : "");

  }).join(" ");
}



  // Helper to draw circles with a red alpha overlay and a stroke color underneath
  function drawHandleCircle(ctx, x, y, r = 2, strokeColor = "#000", fillColor = "#f00", alpha = 0.5) {
    // Draw the fill circle with red color and alpha transparency

    ctx.beginPath();
    ctx.arc(x, y, r, 0, Math.PI * 2);
    ctx.fillStyle = `rgba(${hexToRgb(fillColor)}, ${alpha})`;  // Red with alpha (adjust alpha as needed)
    ctx.fill();

    // Draw the stroke (border) circle with stroke color
    ctx.lineWidth = 1;
    ctx.strokeStyle = strokeColor;
    ctx.stroke();
  }



// Utility function to convert hex color to RGB for alpha usage
export function hexToRgb(hex, factor=null) {
  hex = hex.replace(/^#/, '');

  if (hex.length === 3) {
    hex = hex.split('').map(function (hexChar) {
      return hexChar + hexChar;
    }).join('');
  }

  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  if(factor != null)
  {    
    r = Math.min(255, Math.max(0, r * factor));
    g = Math.min(255, Math.max(0, g * factor));
    b = Math.min(255, Math.max(0, b * factor));
  }

  return `${r}, ${g}, ${b}`;
}


/*
export function drawPLine(ctx, lines, viewPortRef, showHandles) {
  if (!ctx || !Array.isArray(lines)) return;

  for (const line of lines) {
    if (!line || !line.points || line.points.length === 0) continue;

    ctx.beginPath();
    const start = pageToScreen(line.points[0].x, line.points[0].y, viewPortRef);
    ctx.moveTo(start.x, start.y);

    // Draw the polyline path
    for (let i = 1; i < line.points.length; i++) {
      const pt = pageToScreen(line.points[i].x, line.points[i].y, viewPortRef);
      ctx.lineTo(pt.x, pt.y);
    }

    ctx.strokeStyle = line.strokeColor || "#000";
    ctx.lineWidth = line.stroke || 1;
    ctx.stroke();

    // Draw anchor circles (for every vertex, like in drawControls)
    if(showHandles)
    {
      for (let i = 0; i < line.points.length; i++) {
        const pt = pageToScreen(line.points[i].x, line.points[i].y, viewPortRef);
        drawHandleCircle(ctx, pt.x, pt.y, 4.0, line.strokeColor || "#000", "#f00", 0.6);
      }
    }
  }
}
*/

export function drawPLine(ctx, lines, viewPortRef, showHandles) {
  if (!ctx || !Array.isArray(lines)) return;

  for (let i=0; i< lines.length; i++) {

    ctx.save();

    
    const isLast = i === lines.length - 1;

    let  line = lines[i];    
    if (!line || !line.points || line.points.length === 0) 
    {
          ctx.restore();
          continue;
    }
    
    ctx.beginPath();

    ctx.globalAlpha = line.alpha;

    const start = pageToScreen(line.points[0].x, line.points[0].y, viewPortRef);
    ctx.moveTo(start.x, start.y);

    // Draw the polyline path
    for (let i = 1; i < line.points.length; i++) {
      const pt = pageToScreen(line.points[i].x, line.points[i].y, viewPortRef);
      ctx.lineTo(pt.x, pt.y);
    }

    // ctx.closePath();

    //console.log("LINE: ", JSON.stringify(line));

//    if(isLast)
//    {
//      ctx.strokeStyle = line.strokeColor || "#000";
//      ctx.lineWidth = line.stroke || 1;
//      ctx.stroke();
//    }
//    else
//    {


      if(line.allowStroke === false && line.allowFill === false)
      {
        ctx.strokeStyle = line.strokeColor || "#000";
        ctx.lineWidth = line.strokeWidth || 1;
        ctx.stroke();  

      }
      else
      {
        if(line.allowStroke)
        {
          ctx.strokeStyle = line.strokeColor || "#000";
          ctx.lineWidth = line.strokeWidth || 1;
          ctx.stroke();  
        }

        if (line.allowFill) {

          if (line.fillMode === "gradient") {
        
            const angle = (line.gradientAngle || 0) * Math.PI / 180;
        
            // Direction vector for gradient
            const dx = Math.cos(angle);
            const dy = Math.sin(angle);
        

            const bounds = getLineBounds(line.points);

            const cx = bounds.x + bounds.width / 2;
            const cy = bounds.y + bounds.height / 2;
            
            const halfW = bounds.width / 2;
            const halfH = bounds.height / 2;
            
            const x0 = cx - dx * halfW;
            const y0 = cy - dy * halfH;
            const x1 = cx + dx * halfW;
            const y1 = cy + dy * halfH;
            
            const p0 = pageToScreen(x0, y0, viewPortRef);
            const p1 = pageToScreen(x1, y1, viewPortRef);
            
            const grad = ctx.createLinearGradient(p0.x, p0.y, p1.x, p1.y);
            
            grad.addColorStop(0, line.gradientColor1 || "#ffffff");
            grad.addColorStop(1, line.gradientColor2 || "#000000");
            
            ctx.fillStyle = grad;

            /*
            // Scale gradient to shape size
            let {width, height} = getLineBounds(line.points);
            console.log("width: ", width);
            console.log("Height: ", height);
            console.log("dx: ", dx);
            console.log("dy: ", dy);
            console.log("color1: ", line.gradientColor1);
            console.log("color2: ", line.gradientColor2);
            const halfW = width / 2;
            const halfH = height / 2;
        
            const x0 = -dx * halfW;
            const y0 = -dy * halfH;
            const x1 = dx * halfW;
            const y1 = dy * halfH;
        
            const grad = ctx.createLinearGradient(x0, y0, x1, y1);
        
            grad.addColorStop(0, line.gradientColor1 || "#ffffff");
            grad.addColorStop(1, line.gradientColor2 || "#000000");
        
            ctx.fillStyle = grad;
            */
        
          } else {
            ctx.fillStyle = line.fillColor;
          }
        
          console.log("HELP");
          ctx.fill();
        }
      
      
        /*
        if(line.allowFill === true)
        {
          ctx.fillStyle = line.fillColor;
          ctx.fill();              
        } 
        */ 
      }
//    }


    // Draw anchor circles (for every vertex, like in drawControls)
    if(showHandles)
    {
      for (let i = 0; i < line.points.length; i++) {
        const pt = pageToScreen(line.points[i].x, line.points[i].y, viewPortRef);
        drawHandleCircle(ctx, pt.x, pt.y, 4.0, line.strokeColor || "#000", "#f00", 0.6);
      }
    }
    ctx.restore();
  }
}


export function getLineBounds(points) {
  if (!points || points.length === 0) {
    return { x: 0, y: 0, width: 0, height: 0 };
  }

  let minX = Infinity;
  let maxX = -Infinity;
  let minY = Infinity;
  let maxY = -Infinity;

  for (const p of points) {
    if (p.x < minX) minX = p.x;
    if (p.x > maxX) maxX = p.x;
    if (p.y < minY) minY = p.y;
    if (p.y > maxY) maxY = p.y;
  }

  return {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY
  };
}

export function drawFreehand(ctx, lines, viewPortRef)
{
     // 🔷 Draw each line in pointsRef
     for (const line of lines) {
      
      if(line.length !== 0 && line.points.length !== 0)
      {
        ctx.beginPath();
        const start = pageToScreen(line.points[0].x, line.points[0].y, viewPortRef);
        ctx.moveTo(start.x, start.y);

        // Draw a circle at the start point
        drawCircle(ctx, start.x, start.y, 1, "blue");

        // Draw line segments
        for (let i = 1; i < line.points.length; i++) {
          const pt = pageToScreen(line.points[i].x, line.points[i].y, viewPortRef);
          ctx.lineTo(pt.x, pt.y);
        }
        ctx.strokeStyle = line.strokeColor;
        ctx.lineWidth = line.stroke;
        ctx.stroke(); // Don't forget to stroke each path
      }

    } 
}


export function drawControls(ctx, lines, controls, viewPortRef, showControls, showEndPoints) {
  if (!ctx || !Array.isArray(lines)) return;

  // --- 1) faint straight polyline underneath ---
  ctx.save();
  ctx.globalAlpha = 0.35;
  ctx.lineWidth = 1;
  for (let li = 0; li < lines.length; li++) {
    const line = lines[li];
    if (!line || !line.points || line.points.length === 0) continue;

    ctx.beginPath();
    const s = pageToScreen(line.points[0].x, line.points[0].y, viewPortRef);
    ctx.moveTo(s.x, s.y);
    drawCircle(ctx, s.x, s.y, 1, "blue");

    for (let i = 1; i < line.points.length; i++) {
      const p = pageToScreen(line.points[i].x, line.points[i].y, viewPortRef);
      ctx.lineTo(p.x, p.y);
    }

    ctx.strokeStyle = line.strokeColor || "rgba(0,0,0,0.6)";
    ctx.stroke();
  }
  ctx.restore();


  for (let li = 0; li < lines.length; li++) {
    const line = lines[li];
    if (!line || !line.points || line.points.length < 2) continue;
  
    const ctrlLine = (controls && controls[li] && Array.isArray(controls[li].controls))
      ? controls[li].controls
      : [];
  
    const strokeColor = line.strokeColor || "#000";
    const lineWidth = line.strokeWidth || 1;
  
    ctx.save();
    ctx.beginPath(); // ✅ ONE path per line
  
    // ctx.globalAlpha = line.alpha;
    ctx.globalAlpha = ((line.alpha !== undefined && line.alpha !== null)? line.alpha : 1);
    const first = pageToScreen(line.points[0].x, line.points[0].y, viewPortRef);
    ctx.moveTo(first.x, first.y);


  
    for (let i = 1; i < line.points.length; i++) {
      const prev = line.points[i - 1];
      const curr = line.points[i];
  
      const prevCtrl = ctrlLine[i - 1] || { x2: prev.x, y2: prev.y, x1: prev.x, y1: prev.y };
      const currCtrl = ctrlLine[i]     || { x1: curr.x, y1: curr.y, x2: curr.x, y2: curr.y };
  
      const CP1 = pageToScreen(prevCtrl.x2, prevCtrl.y2, viewPortRef);
      const CP2 = pageToScreen(currCtrl.x1, currCtrl.y1, viewPortRef);
      const P3  = pageToScreen(curr.x, curr.y, viewPortRef);
  
      ctx.bezierCurveTo(CP1.x, CP1.y, CP2.x, CP2.y, P3.x, P3.y);

    }
  
    // ✅ NOW stroke/fill works correctly
    if (line.allowStroke === false && line.allowFill === false) {
      ctx.strokeStyle = strokeColor;
      ctx.lineWidth = lineWidth;
      ctx.stroke();
    } 
    else {
      if (line.allowStroke) {
        ctx.strokeStyle = strokeColor;
        ctx.lineWidth = lineWidth;
        ctx.stroke();
      }
  
      if (line.allowFill) {

        if (line.fillMode === "gradient") {
      
          const angle = (line.gradientAngle || 0) * Math.PI / 180;
      
          // Direction vector for gradient
          const dx = Math.cos(angle);
          const dy = Math.sin(angle);
      
          const bounds = getLineBounds(line.points);

          const cx = bounds.x + bounds.width / 2;
          const cy = bounds.y + bounds.height / 2;
          
          const halfW = bounds.width / 2;
          const halfH = bounds.height / 2;
          
          const x0 = cx - dx * halfW;
          const y0 = cy - dy * halfH;
          const x1 = cx + dx * halfW;
          const y1 = cy + dy * halfH;
          
          const p0 = pageToScreen(x0, y0, viewPortRef);
          const p1 = pageToScreen(x1, y1, viewPortRef);
          
          const grad = ctx.createLinearGradient(p0.x, p0.y, p1.x, p1.y);
          
          grad.addColorStop(0, line.gradientColor1 || "#ffffff");
          grad.addColorStop(1, line.gradientColor2 || "#000000");
          
          ctx.fillStyle = grad;

          /*
          // Scale gradient to shape size
          const {width, height} = getLineBounds(line.points);    
          const halfW = width / 2;
          const halfH = height / 2;
          
      
          const x0 = -dx * halfW;
          const y0 = -dy * halfH;
          const x1 = dx * halfW;
          const y1 = dy * halfH;
      
          const grad = ctx.createLinearGradient(x0, y0, x1, y1);
      
          grad.addColorStop(0, line.gradientColor1 || "#ffffff");
          grad.addColorStop(1, line.gradientColor2 || "#000000");
      
          ctx.fillStyle = grad;
          */
      
        } else {
          ctx.fillStyle = line.fillColor;
        }
      
        ctx.fill();
      }
    
      /*
      if (line.allowFill) {
        ctx.fillStyle = line.fillColor;
        ctx.fill();
      }
      */
    
    }
    ctx.restore();
      
    // --- draw controls (separate, no path interference) ---
    if (showControls === true || showEndPoints === true) {
      for (let i = 1; i < line.points.length; i++) {
        const prev = line.points[i - 1];
        const curr = line.points[i];
  
        const prevCtrl = ctrlLine[i - 1] || { x2: prev.x, y2: prev.y, x1: prev.x, y1: prev.y };
        const currCtrl = ctrlLine[i]     || { x1: curr.x, y1: curr.y, x2: curr.x, y2: curr.y };
  
        const P0  = pageToScreen(prev.x, prev.y, viewPortRef);
        const CP1 = pageToScreen(prevCtrl.x2, prevCtrl.y2, viewPortRef);
        const CP2 = pageToScreen(currCtrl.x1, currCtrl.y1, viewPortRef);
        const P3  = pageToScreen(curr.x, curr.y, viewPortRef);
  
        ctx.save();
  
        ctx.strokeStyle = "rgba(0,0,0,0.25)";
        ctx.lineWidth = 1;
        ctx.setLineDash([4, 4]);
  
        ctx.beginPath();
        ctx.moveTo(P0.x, P0.y);
        ctx.lineTo(CP1.x, CP1.y);
        ctx.moveTo(P3.x, P3.y);
        ctx.lineTo(CP2.x, CP2.y);
        ctx.stroke();
  
        // reset dash before circles
        ctx.setLineDash([]);
        if(showEndPoints)
        {
          drawHandleCircle(ctx, P0.x, P0.y, 4.0, strokeColor);
          drawHandleCircle(ctx, P3.x, P3.y, 4.0, strokeColor);
        }
        if(showControls)
        {
          drawHandleCircle(ctx, CP1.x, CP1.y, 4.0, strokeColor, "#0000FF", 0.6);
          drawHandleCircle(ctx, CP2.x, CP2.y, 4.0, strokeColor, "#0000FF", 0.6);
        }
  
        ctx.restore();
      }
    }
  }
}


export function drawFaintBezier(ctx, points, controls, viewPortRef) {
  if (!ctx || !Array.isArray(points) || !Array.isArray(controls)) return;


  if(points.length === 0 || controls.length === 0)
  {
    return;
  }

  // --- 1) Draw faint polyline (just for visualizing the anchor points) ---
  ctx.save();
  ctx.globalAlpha = 0.25;  // Set transparency for faint lines
  ctx.lineWidth = 1;

  // Draw polyline based on the points
  ctx.beginPath();
  const firstPoint = pageToScreen(points[0].x, points[0].y, viewPortRef);
  ctx.moveTo(firstPoint.x, firstPoint.y);
  for (let i = 1; i < points.length; i++) {
    const point = pageToScreen(points[i].x, points[i].y, viewPortRef);
    ctx.lineTo(point.x, point.y);
  }
  ctx.strokeStyle = "gray"; // Faint color for the polyline
  ctx.stroke();
  ctx.restore();

  // --- 2) Draw faint Bézier curves based on points and controls ---
  ctx.save();
  ctx.globalAlpha = 0.25;  // Set transparency for faint lines
  ctx.lineWidth = 1;

  for (let i = 1; i < points.length; i++) {
    const prev = points[i - 1];
    const curr = points[i];

    // Get the control points for the Bézier curve
    const prevCtrl = controls[i - 1] || { x2: prev.x, y2: prev.y, x1: prev.x, y1: prev.y };
    const currCtrl = controls[i]     || { x1: curr.x, y1: curr.y, x2: curr.x, y2: curr.y };

    // Convert points and control points to screen coordinates
    const P0 = pageToScreen(prev.x, prev.y, viewPortRef);
    const CP1 = pageToScreen(prevCtrl.x2, prevCtrl.y2, viewPortRef); // prev outgoing control point
    const CP2 = pageToScreen(currCtrl.x1, currCtrl.y1, viewPortRef); // curr incoming control point
    const P3 = pageToScreen(curr.x, curr.y, viewPortRef);

    // Draw faint dashed Bézier curve (just the curve)
    ctx.beginPath();
    ctx.moveTo(P0.x, P0.y);
    ctx.bezierCurveTo(CP1.x, CP1.y, CP2.x, CP2.y, P3.x, P3.y);
    ctx.strokeStyle = "gray";  // Faint color for the curve
    ctx.stroke();

    // --- 3) Draw faint dashed lines for the control handles (anchor -> control) ---
    ctx.save();
    ctx.setLineDash([4, 4]);  // Faint dashed line
    ctx.beginPath();
    ctx.moveTo(P0.x, P0.y);
    ctx.lineTo(CP1.x, CP1.y);
    ctx.moveTo(P3.x, P3.y);
    ctx.lineTo(CP2.x, CP2.y);
    ctx.strokeStyle = "gray";  // Faint color for dashed control lines
    ctx.stroke();
    ctx.restore();
  }

  ctx.restore();
}


export function drawFaintPLine(ctx, points, viewPortRef) {
  if (!ctx || !Array.isArray(points) || points.length === 0) return;

  // --- 1) Set up faint style ---
  ctx.save();
  ctx.globalAlpha = 0.25;  // Set transparency for faint lines
  ctx.lineWidth = 1;

  // --- 2) Draw the polyline ---
  ctx.beginPath();
  const firstPoint = pageToScreen(points[0].x, points[0].y, viewPortRef);
  ctx.moveTo(firstPoint.x, firstPoint.y);
  
  for (let i = 1; i < points.length; i++) {
    const point = pageToScreen(points[i].x, points[i].y, viewPortRef);
    ctx.lineTo(point.x, point.y);
  }
  
  // Set the faint color for the polyline
  ctx.strokeStyle = "gray";  // You can use any faint color here
  ctx.stroke();
  ctx.restore();
}


export function drawMirrorLine(ctx, mirrorPoint1, mirrorPoint2, viewPortRef) {
  if (!ctx) return;

  // --- 1) Check for mirror points ---
  if (!mirrorPoint1 && !mirrorPoint2) {
    return; // If both points are null, draw nothing
  }

  // --- 2) Convert points to screen coordinates ---
  const point1 = mirrorPoint1 ? pageToScreen(mirrorPoint1.x, mirrorPoint1.y, viewPortRef) : null;
  const point2 = mirrorPoint2 ? pageToScreen(mirrorPoint2.x, mirrorPoint2.y, viewPortRef) : null;

  // --- 3) Draw point1 if it's defined ---
  if (point1) {
    drawCircle(ctx, point1.x, point1.y, 4, "blue"); // Draw point1
    ctx.fillStyle = "blue";
    ctx.font = "12px Arial";
    ctx.fillText("p1", point1.x + 5, point1.y - 5); // Label p1
  }

  // --- 4) Draw line from point1 to point2 if both are defined ---
  if (point1 && point2) {
    ctx.beginPath();
    ctx.moveTo(point1.x, point1.y);
    ctx.lineTo(point2.x, point2.y);
    ctx.strokeStyle = "#000000"; // Or use any other color
    ctx.lineWidth = 2;
    ctx.stroke();

    // Draw point2 and label it as p2
    drawCircle(ctx, point2.x, point2.y, 4, "red"); // Draw point2
    ctx.fillStyle = "red";
    ctx.fillText("p2", point2.x + 5, point2.y - 5); // Label p2
  } else if (point1 && !point2) {
    // If only point1 is defined, just draw the point
    drawCircle(ctx, point1.x, point1.y, 4, "blue");
    ctx.fillStyle = "blue";
    ctx.fillText("p1", point1.x + 5, point1.y - 5); // Label p1
  }
}



function drawCircle(ctx, x, y, radius, color = 'black', stroke = false) {
  ctx.beginPath();
  ctx.arc(x, y, radius, 0, Math.PI * 2);

  ctx.fillStyle = color;
  ctx.fill();

  if (stroke) {
    ctx.strokeStyle = stroke === true ? 'black' : stroke; // Allow passing a color instead of just `true`
    ctx.lineWidth = 2;
    ctx.stroke();
  }

  ctx.closePath();
}

export function applyEffects(ctx, rect)
{
    // --- 1️ Determine shadow offsets ---
    let offsetX = rect.isDropShadow ? rect.shadowOffsetX : 0;
    let offsetY = rect.isDropShadow ? rect.shadowOffsetY : 0;
  
    // --- 2️ Determine shadow color ---
    let shadowColor = (rect.isDropShadow || rect.isGlow) ? rect.shadowColor : "transparent";
  
    // --- 3️ Determine shadow blur ---
    let shadowBlur = 0;
    if (rect.isDropShadow) shadowBlur = rect.shadowBlur;       // shadow blur
    // if (rect.isGlow) shadowBlur = Math.max(shadowBlur, rect.regularBlur); // glow may override or increase shadow blur
  
    // Apply device pixel ratio (zoom factor) to offsets and blur if needed
    const scaleFactor = window.devicePixelRatio; // Get the zoom factor
    offsetX *= scaleFactor;
    offsetY *= scaleFactor;
    shadowBlur *= scaleFactor; // Optional, adjust if blur appears off at different zoom levels


    ctx.shadowColor = shadowColor;
    ctx.shadowOffsetX = offsetX;
    ctx.shadowOffsetY = offsetY;
    ctx.shadowBlur = shadowBlur;
  
    // --- 4️⃣ Determine regular blur (filter) ---
    let filter = "none";
  
    if (rect.isBlur) {
      filter = `blur(${rect.regularBlur * scaleFactor}px)`;  // Adjust regular blur for zoom
      // filter = `blur(${rect.regularBlur}px)`;  // independent blur effect
    }
  
    ctx.filter = filter; 

    return {offsetX, offsetY, shadowBlur};
  
}

export function drawSvgCircle(ctx, x, y, w, h, rect)
{
  ctx.save();

  if(rect.fillAlpha !== undefined){
    ctx.globalAlpha = getOpacity(rect); //rect.fillAlpha;
  }

  const {offsetX, offsetY} = applyEffects(ctx,rect);

  x = x + w/2;
  y = y + h/2;


  // Calculate the radius based on the corrected width and height
  let radiusH = w / 2;
  let radiusW = h / 2;
  let radius = radiusW;

//  let radiusH = h/2;
//  let radiusW = w/2;
//  let radius = radiusW;

  let offset = rect.shadowOffsetX;
  if(radiusH < radiusW){
    radius = radiusH;
    offset = rect.shadowOffsetY;
  }

  if(rect.isDropShadow)
  {
    radius = radius - Math.abs(offset) - rect.shadowBlur;
  }
  if(rect.isBlur)
  {
    radius = radius - rect.regularBlur;
  }
   

  let color = rect.fillColor;
  let stroke = rect.allowStroke;
  let strokeColor = rect.strokeColor;
  let strokeWidth = rect.strokeWidth;

  ctx.beginPath();
  ctx.arc(x, y, radius, 0, Math.PI * 2);

  if (rect.allowFill) {

    if (rect.fillMode === "gradient") {
  
      const angle = (rect.gradientAngle || 0) * Math.PI / 180;
  
      // Direction vector for gradient
      const dx = Math.cos(angle);
      const dy = Math.sin(angle);

      // Use radius instead of w/h (since it's a circle)
      const r = radius;

      const x0 = x - dx * r;
      const y0 = y - dy * r;
      const x1 = x + dx * r;
      const y1 = y + dy * r;
    
      const grad = ctx.createLinearGradient(x0, y0, x1, y1);
  
      grad.addColorStop(0, rect.gradientColor1 || "#ffffff");
      grad.addColorStop(1, rect.gradientColor2 || "#000000");
  
      ctx.fillStyle = grad;
  
    } else {
      ctx.fillStyle = rect.fillColor;
    }
  
    ctx.fill();
  }

  /*
  if(rect.allowFill){
    ctx.fillStyle = color;
    ctx.fill();
  }
  */

  if (stroke) {
    ctx.strokeStyle = strokeColor;
    ctx.lineWidth = strokeWidth;
    ctx.stroke();
  }

  ctx.closePath();

  ctx.restore();
}



export function drawSvgSquare(ctx,x,y,w,h,rect)
{

  ctx.save();

  if(rect.fillAlpha !== undefined){
    ctx.globalAlpha = getOpacity(rect); // rect.fillAlpha;
  }
  const {offsetX, offsetY} = applyEffects(ctx,rect);

  if(w < h)
  {
    h = w;
  }
  else
  {
    w = h;
  }

  let color = rect.fillColor;
  let stroke = rect.allowStroke;
  let strokeColor = rect.strokeColor;
  let strokeWidth = rect.strokeWidth;

  let a = w/2;
  let b = h/2


  if(rect.isDropShadow)
  {
    a = a - Math.abs(offsetX) - rect.shadowBlur;
    b = b - Math.abs(offsetY) - rect.shadowBlur;
  }
  if(rect.isBlur)
  {
    a = a - rect.regularBlur;
    b = b - rect.regularBlur;    
  }


  ctx.beginPath();

  
   // Move origin to ellipse center
  ctx.translate(x+w/2, y+h/2);

  // Rotate around center
  const radians = -rect?.rotation * Math.PI / 180;
  ctx.rotate(radians);
  

  w = 2*a;
  h = 2*b;
  //ctx.rect(-w/2, -h/2, w,h);
  roundedRect(ctx, -w/2, -h/2, w,h, rect);
  
  // ctx.rect(x,y,w,h);
  if (rect.allowFill) {

    if (rect.fillMode === "gradient") {
  
      const angle = (rect.gradientAngle || 0) * Math.PI / 180;
  
      // Direction vector for gradient
      const dx = Math.cos(angle);
      const dy = Math.sin(angle);
  
      // Scale gradient to shape size
      const halfW = w / 2;
      const halfH = h / 2;
  
      const x0 = -dx * halfW;
      const y0 = -dy * halfH;
      const x1 = dx * halfW;
      const y1 = dy * halfH;
  
      const grad = ctx.createLinearGradient(x0, y0, x1, y1);
  
      grad.addColorStop(0, rect.gradientColor1 || "#ffffff");
      grad.addColorStop(1, rect.gradientColor2 || "#000000");
  
      ctx.fillStyle = grad;
  
    } else {
      ctx.fillStyle = rect.fillColor;
    }
  
    ctx.fill();
  }

  /*
  if(rect.allowFill)
  {
    ctx.fillStyle = color;
    ctx.fill();
  }
  */
  if (stroke) {
    ctx.strokeStyle = strokeColor; // Allow passing a color instead of just `true`
    ctx.lineWidth = strokeWidth;
    ctx.stroke();
  }
  ctx.closePath();
  ctx.restore();

}

export function drawGroup(ctx,x,y, w, h, rect)
{
  drawSvgRect(ctx,x,y,w,h,rect);
}


export function drawSvgRect(ctx,x,y,w,h,rect)
{
  ctx.save();
  if(rect.fillAlpha !== undefined){    
    ctx.globalAlpha = getOpacity(rect); // rect.fillAlpha;
  }

  const {offsetX, offsetY} = applyEffects(ctx,rect);

  let color = rect.fillColor;
  let stroke = rect.allowStroke;
  let strokeColor = rect.strokeColor;
  let strokeWidth = rect.strokeWidth;

  let a = w/2;
  let b = h/2

  // if(rect.type !== 'Group')
  // {
    if(rect.isDropShadow)
    {
      a = a - Math.abs(offsetX) - rect.shadowBlur;
      b = b - Math.abs(offsetY) - rect.shadowBlur;
    }
    if(rect.isBlur)
    {
      a = a - rect.regularBlur;
      b = b - rect.regularBlur;    
    }
  //}

  ctx.beginPath();

  // Move origin to ellipse center
  ctx.translate(x+w/2, y+h/2);
  // ctx.translate(cX,cY)

  // Rotate around center
  const radians = -rect?.rotation * Math.PI / 180;
  ctx.rotate(radians);
  
  // ctx.rect(-w/2, -h/2, w,h);
  w = a*2;
  h = b*2;
  roundedRect(ctx, -w/2, -h/2, w,h, rect);


  if (rect.allowFill) {

    if (rect.fillMode === "gradient") {
  
      const angle = (rect.gradientAngle || 0) * Math.PI / 180;
  
      // Direction vector for gradient
      const dx = Math.cos(angle);
      const dy = Math.sin(angle);
  
      // Scale gradient to shape size
      const halfW = w / 2;
      const halfH = h / 2;
  
      const x0 = -dx * halfW;
      const y0 = -dy * halfH;
      const x1 = dx * halfW;
      const y1 = dy * halfH;
  
      const grad = ctx.createLinearGradient(x0, y0, x1, y1);
  
      grad.addColorStop(0, rect.gradientColor1 || "#ffffff");
      grad.addColorStop(1, rect.gradientColor2 || "#000000");
  
      ctx.fillStyle = grad;
  
    } else {
      ctx.fillStyle = rect.fillColor;
    }
  
    ctx.fill();
  }

  /*
  if(rect.allowFill)
  {
    ctx.fillStyle = color;
    ctx.fill();
  }
  */

  if (stroke) {
    ctx.strokeStyle = strokeColor; // Allow passing a color instead of just `true`
    ctx.lineWidth = strokeWidth;
    ctx.stroke();
  }

  ctx.closePath();
  ctx.restore();

}


/**
 * Draws a rectangle with individual corner radii
 * @param {CanvasRenderingContext2D} ctx
 * @param {number} x - center x
 * @param {number} y - center y
 * @param {number} w - width
 * @param {number} h - height
 * @param {object} radii - {tl, tr, br, bl} top-left, top-right, bottom-right, bottom-left
 */
function roundedRect(ctx, x, y, w, h, rect) {
  
  let tl = rect.cornerTL;
  let tr = rect.cornerTR;
  let br = rect.cornerBR;
  let bl = rect.cornerBL;

//   const left = x - w/2;
//   const top = y - h/2;
//   const right = x + w/2;
//   const bottom = y + h/2;
  const left = x;
  const top = y;
  const right = x + w;
  const bottom = y + h;


  ctx.beginPath();
  ctx.moveTo(left + tl, top);
  ctx.lineTo(right - tr, top);
  ctx.quadraticCurveTo(right, top, right, top + tr);
  ctx.lineTo(right, bottom - br);
  ctx.quadraticCurveTo(right, bottom, right - br, bottom);
  ctx.lineTo(left + bl, bottom);
  ctx.quadraticCurveTo(left, bottom, left, bottom - bl);
  ctx.lineTo(left, top + tl);
  ctx.quadraticCurveTo(left, top, left + tl, top);
  ctx.closePath();
}

export function drawSvgEllipse(ctx,x,y,w,h,rect)
{

  
  ctx.save();

  if(rect.fillAlpha !== undefined){
    ctx.globalAlpha = getOpacity(rect); // rect.fillAlpha;
  }

  const {offsetX, offsetY} = applyEffects(ctx,rect);

  let a = w/2;
  let b = h/2
  let cX = x+a;
  let cY = y+b;


  if(rect.isDropShadow)
  {
    a = a - Math.abs(offsetX) - rect.shadowBlur;
    b = b - Math.abs(offsetY) - rect.shadowBlur;
  }
  if(rect.isBlur)
  {
    a = a - rect.regularBlur;
    b = b - rect.regularBlur;    
  }



  let color = rect.fillColor;
  let stroke = rect.allowStroke;
  let strokeColor = rect.strokeColor;
  let strokeWidth = rect.strokeWidth;

  ctx.beginPath();

   // Move origin to ellipse center
  ctx.translate(cX, cY);

  // Rotate around center
  const radians = -rect.rotation * Math.PI / 180;
  ctx.rotate(radians);

  // Draw ellipse centered at origin
  ctx.ellipse(0, 0, a, b, 0, 0, 2 * Math.PI);

  if (rect.allowFill) {

    if (rect.fillMode === "gradient") {
  
      const angle = (rect.gradientAngle || 0) * Math.PI / 180;
  
      // Direction vector for gradient
      const dx = Math.cos(angle);
      const dy = Math.sin(angle);
        
       // Use ellipse radii
      const x0 = -dx * a;
      const y0 = -dy * b;
      const x1 = dx * a;
      const y1 = dy * b;

      const grad = ctx.createLinearGradient(x0, y0, x1, y1);
  
      grad.addColorStop(0, rect.gradientColor1 || "#ffffff");
      grad.addColorStop(1, rect.gradientColor2 || "#000000");
  
      ctx.fillStyle = grad;
  
    } else {
      ctx.fillStyle = rect.fillColor;
    }
  
    ctx.fill();
  }


/*     
  if(rect.allowFill)
  {
    ctx.fillStyle = color;
    ctx.fill();
  }
  */

  if (stroke) {
    ctx.strokeStyle = strokeColor; // Allow passing a color instead of just `true`
    ctx.lineWidth = strokeWidth;
    ctx.stroke();
  }

  ctx.closePath();
  ctx.restore();

}

export function mirror(point1, point2, points, controls) {
  // Function to copy a point (x, y) and return a new object
  function copyPoint(point) {
    return { x: point.x, y: point.y };
  }

  // Function to reflect a point across a line defined by point1 and point2
  function reflectPoint(p, point1, point2) {
    // Calculate the line equation (point1, point2) in vector form
    const dx = point2.x - point1.x;
    const dy = point2.y - point1.y;

    // Vector from point1 to the point to be mirrored
    const mx = p.x - point1.x;
    const my = p.y - point1.y;

    // Projection of the point onto the line (point1, point2)
    const dotProduct = (mx * dx + my * dy) / (dx * dx + dy * dy);

    // The reflection point
    const rx = point1.x + 2 * dotProduct * dx - mx;
    const ry = point1.y + 2 * dotProduct * dy - my;

    return { x: rx, y: ry };
  }

  // Mirror points (make a copy to avoid mutating the original array)
  const mirroredPoints = points.map(point => {
    const copiedPoint = copyPoint(point);  // Copy the point
    return reflectPoint(copiedPoint, point1, point2);  // Reflect the copied point
  });

  // Mirror control points (copy and apply mirroring transformation)
  const mirroredControls = controls.map(ctrl => {
    console.log("Processing control:", ctrl); // Debugging log

    const start = { x: ctrl.x1, y: ctrl.y1 };
    const end = { x: ctrl.x2, y: ctrl.y2 };
    
    const mirroredStart = reflectPoint(start, point1, point2);
    const mirroredEnd = reflectPoint(end, point1, point2);

    const mirroredControl = { 
      x1: mirroredStart.x, 
      y1: mirroredStart.y, 
      x2: mirroredEnd.x, 
      y2: mirroredEnd.y 
    };

    console.log("Mirrored Control:", mirroredControl); // Debugging log

    return mirroredControl;
  });

  console.log("Mirrored Controls:", mirroredControls); // Final log to see the result
  return { mirroredPoints, mirroredControls };
}



export function resizeFunc(point1, point2, p3, points, controls) {
  // Function to copy a point (x, y) and return a new object
  function copyPoint(point) {
    return { x: point.x, y: point.y };
  }

  // Calculate the distance between two points
  function calculateDistance(a, b) {
    const dx = b.x - a.x;
    const dy = b.y - a.y;
    return Math.sqrt(dx * dx + dy * dy);
  }

  // Scale a point about a pivot
  function scalePoint(point, zoomFactor, pivot) {
    return {
      x: pivot.x + (point.x - pivot.x) * zoomFactor,
      y: pivot.y + (point.y - pivot.y) * zoomFactor
    };
  }

  // Determine the zoom factor
  const originalLength = calculateDistance(point1, point2);
  const currentLength = calculateDistance(point1, p3);

  const zoomFactor =
    originalLength === 0 ? 1 : currentLength / originalLength;

  // Scale points
  const resizedPoints = points.map(point => {
    const copiedPoint = copyPoint(point);
    return scalePoint(copiedPoint, zoomFactor, point1);
  });

  // Scale control points
  const resizedControls = controls.map(ctrl => {
    const start = { x: ctrl.x1, y: ctrl.y1 };
    const end = { x: ctrl.x2, y: ctrl.y2 };

    const resizedStart = scalePoint(start, zoomFactor, point1);
    const resizedEnd = scalePoint(end, zoomFactor, point1);

    return {
      x1: resizedStart.x,
      y1: resizedStart.y,
      x2: resizedEnd.x,
      y2: resizedEnd.y
    };
  });

  return {
    resizedPoints,
    resizedControls,
    zoomFactor
  };
}

export function rotateFunc(point1, point2, p3, points, controls) {
  // Function to copy a point (x, y) and return a new object
  function copyPoint(point) {
    return { x: point.x, y: point.y };
  }

  // Function to calculate the angle between the line (point1 -> point2) and (point1 -> p3)
  // This uses atan2 to return the signed angle
  function calculateAngle(point1, point2, p3) {
    // Calculate vectors for the lines (point1 -> point2) and (point1 -> p3)
    const dx1 = point2.x - point1.x;
    const dy1 = point2.y - point1.y;
    const dx2 = p3.x - point1.x;
    const dy2 = p3.y - point1.y;

    // Use atan2 to calculate the angle between the vectors
    const angle1 = Math.atan2(dy1, dx1); // Angle of (point1 -> point2)
    const angle2 = Math.atan2(dy2, dx2); // Angle of (point1 -> p3)

    // Calculate the difference between the two angles
    // let angleInRadians = angle2 - angle1;
    let angleInRadians = angle1 - angle2;

    // Normalize the angle to the range [-π, π] for full rotation handling
    if (angleInRadians > Math.PI) angleInRadians -= 2 * Math.PI;
    if (angleInRadians < -Math.PI) angleInRadians += 2 * Math.PI;

    // Convert the angle to degrees
    let angleInDegrees = angleInRadians * (180 / Math.PI);

    return angleInDegrees;
  }

  // Function to rotate a point by a given angle around a pivot point
  function rotatePoint(point, angle, pivot) {
    const rad = -angle * (Math.PI / 180); // Convert angle to radians
    const cosAngle = Math.cos(rad);
    const sinAngle = Math.sin(rad);

    // Translate point to origin (pivot - point)
    const xTranslated = point.x - pivot.x;
    const yTranslated = point.y - pivot.y;

    // Rotate point
    const xRotated = cosAngle * xTranslated - sinAngle * yTranslated + pivot.x;
    const yRotated = sinAngle * xTranslated + cosAngle * yTranslated + pivot.y;

    return { x: xRotated, y: yRotated };
  }

  // Calculate the angle between the line (point1 -> point2) and (point1 -> p3)
  const angle = calculateAngle(point1, point2, p3);

  // Rotate points (make a copy to avoid mutating the original array)
  const rotatedPoints = points.map(point => {
    const copiedPoint = copyPoint(point);  // Copy the point
    return rotatePoint(copiedPoint, angle, point1);  // Rotate the copied point
  });

  // Rotate control points (copy and apply rotation transformation)
  const rotatedControls = controls.map(ctrl => {
    const start = { x: ctrl.x1, y: ctrl.y1 };
    const end = { x: ctrl.x2, y: ctrl.y2 };

    const rotatedStart = rotatePoint(start, angle, point1);
    const rotatedEnd = rotatePoint(end, angle, point1);

    const rotatedControl = { 
      x1: rotatedStart.x, 
      y1: rotatedStart.y, 
      x2: rotatedEnd.x, 
      y2: rotatedEnd.y 
    };

    return rotatedControl;
  });

  // Return the rotated points and controls
  return { rotatedPoints, rotatedControls, angle };
}

export function straight(p0, c0, p1, c1) {
  const dx = p1.x - p0.x;
  const dy = p1.y - p0.y;
  const lenSq = dx * dx + dy * dy;

  // Degenerate case: endpoints coincide
  if (lenSq === 0) {
    return { p0, c0: p0, c1: p1, p1 };
  }

  function project(point) {
    const t =
      ((point.x - p0.x) * dx + (point.y - p0.y) * dy) / lenSq;

    return {
      x: p0.x + t * dx,
      y: p0.y + t * dy
    };
  }

  return {
    p0,
    c0: project(c0),
    c1: project(c1),
    p1
  };
}

export const screenToPage = (screenX, screenY, viewPortRef) => {
  const { offsetX, offsetY, zoom } = viewPortRef.current;

  return {
    x: screenX / zoom - offsetX,
    y: screenY / zoom - offsetY,
  };
};

export const pageToScreenN = (pageX, pageY, viewPortRef) => {
  const { offsetX, offsetY, zoom } = viewPortRef.current;

  /*
  return {
    x: (pageX + offsetX) * zoom,
    y: (pageY + offsetY) * zoom,
  };
  */

  return {
    x:pageX,
    y:pageY
  }
};


export const pageToScreen = (pageX, pageY, viewPortRef) => {
  const { offsetX, offsetY, zoom } = viewPortRef.current;
  
  return {
    x: (pageX + offsetX) * zoom,
    y: (pageY + offsetY) * zoom,
  };  
};

export function svgPathBoundingBoxMap(paths) {
  let minX = Infinity, minY = Infinity;
  let maxX = -Infinity, maxY = -Infinity;

  const updateBounds = (x, y) => {
    if (x < minX) minX = x;
    if (x > maxX) maxX = x;
    if (y < minY) minY = y;
    if (y > maxY) maxY = y;
  };

  const cubicExtrema = (p0, p1, p2, p3) => {
    // derivative coefficients: 3(-p0 + 3p1 - 3p2 + p3)t^2 + 6(p0 - 2p1 + p2)t + 3(-p0 + p1)
    const results = [];
    ["x", "y"].forEach(coord => {
      const a = -p0[coord] + 3 * p1[coord] - 3 * p2[coord] + p3[coord];
      const b = 2 * (p0[coord] - 2 * p1[coord] + p2[coord]);
      const c = -p0[coord] + p1[coord];

      if (Math.abs(a) < 1e-8) {
        if (Math.abs(b) > 1e-8) {
          const t = -c / b;
          if (t > 0 && t < 1) results.push(t);
        }
      } else {
        const disc = b * b - 4 * a * c;
        if (disc >= 0) {
          const t1 = (-b + Math.sqrt(disc)) / (2 * a);
          const t2 = (-b - Math.sqrt(disc)) / (2 * a);
          if (t1 > 0 && t1 < 1) results.push(t1);
          if (t2 > 0 && t2 < 1) results.push(t2);
        }
      }
    });
    return results;
  };

  const quadraticExtrema = (p0, p1, p2) => {
    const results = [];
    ["x", "y"].forEach(coord => {
      const t = (p0[coord] - p1[coord]) / (p0[coord] - 2 * p1[coord] + p2[coord]);
      if (t > 0 && t < 1) results.push(t);
    });
    return results;
  };

  const bezierPoint = (p0, p1, p2, p3, t) => {
    const mt = 1 - t;
    return {
      x: mt ** 3 * p0.x + 3 * mt ** 2 * t * p1.x + 3 * mt * t ** 2 * p2.x + t ** 3 * p3.x,
      y: mt ** 3 * p0.y + 3 * mt ** 2 * t * p1.y + 3 * mt * t ** 2 * p2.y + t ** 3 * p3.y
    };
  };

  const quadraticPoint = (p0, p1, p2, t) => {
    const mt = 1 - t;
    return {
      x: mt * mt * p0.x + 2 * mt * t * p1.x + t * t * p2.x,
      y: mt * mt * p0.y + 2 * mt * t * p1.y + t * t * p2.y
    };
  };

  // Loop through each path and calculate the bounding box
  paths.forEach(pathObj => {
    const pathStr = pathObj.d;  // The 'd' string in each path object
    const commands = pathStr.match(/[a-zA-Z][^a-zA-Z]*/g);
    if (!commands) return;

    let current = { x: 0, y: 0 };

    for (const cmdStr of commands) {
      const type = cmdStr[0];
      const nums = cmdStr.slice(1).trim().split(/[\s,]+/).map(Number);

      switch (type) {
        case "M":
          current.x = nums[0];
          current.y = nums[1];
          updateBounds(current.x, current.y);
          break;
        case "L":
          current.x = nums[0];
          current.y = nums[1];
          updateBounds(current.x, current.y);
          break;
        case "C":
          const p0 = { ...current };
          const p1 = { x: nums[0], y: nums[1] };
          const p2 = { x: nums[2], y: nums[3] };
          const p3 = { x: nums[4], y: nums[5] };

          updateBounds(p0.x, p0.y);
          updateBounds(p3.x, p3.y);

          const tVals = cubicExtrema(p0, p1, p2, p3);
          tVals.forEach(t => {
            const p = bezierPoint(p0, p1, p2, p3, t);
            updateBounds(p.x, p.y);
          });

          current = p3;
          break;
        case "Q":
          const q0 = { ...current };
          const q1 = { x: nums[0], y: nums[1] };
          const q2 = { x: nums[2], y: nums[3] };

          updateBounds(q0.x, q0.y);
          updateBounds(q2.x, q2.y);

          const tq = quadraticExtrema(q0, q1, q2);
          tq.forEach(t => {
            const p = quadraticPoint(q0, q1, q2, t);
            updateBounds(p.x, p.y);
          });

          current = q2;
          break;
        case "Z":
        case "z":
          break;
        default:
          console.warn("Unsupported SVG command:", type);
      }
    }
  });

  return { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
}





/**
 * Compute the bounding box of an SVG path string
 * Supports M, L, C, Q commands (absolute coordinates)
 */
export function svgPathBoundingBox(pathStr) {
  const commands = pathStr.match(/[a-zA-Z][^a-zA-Z]*/g);
  if (!commands) return null;

  let minX = Infinity, minY = Infinity;
  let maxX = -Infinity, maxY = -Infinity;

  let current = { x: 0, y: 0 };

  const updateBounds = (x, y) => {
    if (x < minX) minX = x;
    if (x > maxX) maxX = x;
    if (y < minY) minY = y;
    if (y > maxY) maxY = y;
  };

  const cubicExtrema = (p0, p1, p2, p3) => {
    // derivative coefficients: 3(-p0 + 3p1 - 3p2 + p3)t^2 + 6(p0 - 2p1 + p2)t + 3(-p0 + p1)
    const results = [];
    ["x","y"].forEach(coord => {
      const a = -p0[coord] + 3*p1[coord] - 3*p2[coord] + p3[coord];
      const b = 2*(p0[coord] - 2*p1[coord] + p2[coord]);
      const c = -p0[coord] + p1[coord];

      if (Math.abs(a) < 1e-8) {
        if (Math.abs(b) > 1e-8) {
          const t = -c / b;
          if (t > 0 && t < 1) results.push(t);
        }
      } else {
        const disc = b*b - 4*a*c;
        if (disc >= 0) {
          const t1 = (-b + Math.sqrt(disc)) / (2*a);
          const t2 = (-b - Math.sqrt(disc)) / (2*a);
          if (t1 > 0 && t1 < 1) results.push(t1);
          if (t2 > 0 && t2 < 1) results.push(t2);
        }
      }
    });
    return results;
  };

  const quadraticExtrema = (p0, p1, p2) => {
    const results = [];
    ["x","y"].forEach(coord => {
      const t = (p0[coord] - p1[coord]) / (p0[coord] - 2*p1[coord] + p2[coord]);
      if (t > 0 && t < 1) results.push(t);
    });
    return results;
  };

  const bezierPoint = (p0,p1,p2,p3,t) => {
    const mt = 1 - t;
    return {
      x: mt**3*p0.x + 3*mt**2*t*p1.x + 3*mt*t**2*p2.x + t**3*p3.x,
      y: mt**3*p0.y + 3*mt**2*t*p1.y + 3*mt*t**2*p2.y + t**3*p3.y
    };
  };

  const quadraticPoint = (p0,p1,p2,t) => {
    const mt = 1-t;
    return {
      x: mt*mt*p0.x + 2*mt*t*p1.x + t*t*p2.x,
      y: mt*mt*p0.y + 2*mt*t*p1.y + t*t*p2.y
    };
  };

  for (const cmdStr of commands) {
    const type = cmdStr[0];
    const nums = cmdStr.slice(1).trim().split(/[\s,]+/).map(Number);

    switch(type) {
      case "M":
        current.x = nums[0];
        current.y = nums[1];
        updateBounds(current.x, current.y);
        break;
      case "L":
        current.x = nums[0];
        current.y = nums[1];
        updateBounds(current.x, current.y);
        break;
      case "C":
        const p0 = { ...current };
        const p1 = { x: nums[0], y: nums[1] };
        const p2 = { x: nums[2], y: nums[3] };
        const p3 = { x: nums[4], y: nums[5] };

        updateBounds(p0.x, p0.y);
        updateBounds(p3.x, p3.y);

        const tVals = cubicExtrema(p0,p1,p2,p3);
        tVals.forEach(t => {
          const p = bezierPoint(p0,p1,p2,p3,t);
          updateBounds(p.x,p.y);
        });

        current = p3;
        break;
      case "Q":
        const q0 = { ...current };
        const q1 = { x: nums[0], y: nums[1] };
        const q2 = { x: nums[2], y: nums[3] };

        updateBounds(q0.x, q0.y);
        updateBounds(q2.x, q2.y);

        const tq = quadraticExtrema(q0,q1,q2);
        tq.forEach(t => {
          const p = quadraticPoint(q0,q1,q2,t);
          updateBounds(p.x,p.y);
        });

        current = q2;
        break;
      case "Z":
      case "z":
        break;
      default:
        console.warn("Unsupported SVG command:", type);
    }
  }

  return { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
}



export function calculateCurveBoundingBox(pointsRef, controlRef) {
  const lines = pointsRef?.current || [];
  const controls = controlRef?.current || [];

  let minX = Infinity, minY = Infinity;
  let maxX = -Infinity, maxY = -Infinity;

  const EPS = 1e-9;

  // Evaluate cubic bezier coordinate
  function bezierAt(t, p0, p1, p2, p3) {
    const mt = 1 - t;
    return (
      mt * mt * mt * p0 +
      3 * mt * mt * t * p1 +
      3 * mt * t * t * p2 +
      t * t * t * p3
    );
  }

  // Find extrema roots for cubic derivative
  function cubicExtrema(p0, p1, p2, p3) {
    const a = -p0 + 3 * p1 - 3 * p2 + p3;
    const b = 2 * (p0 - 2 * p1 + p2);
    const c = -p0 + p1;

    const ts = [];

    if (Math.abs(a) < EPS) {
      if (Math.abs(b) > EPS) {
        const t = -c / b;
        if (t > EPS && t < 1 - EPS) ts.push(t);
      }
    } else {
      const disc = b * b - 4 * a * c;

      if (disc >= 0) {
        const s = Math.sqrt(disc);
        const t1 = (-b + s) / (2 * a);
        const t2 = (-b - s) / (2 * a);

        if (t1 > EPS && t1 < 1 - EPS) ts.push(t1);
        if (t2 > EPS && t2 < 1 - EPS) ts.push(t2);
      }
    }

    return ts;
  }

  // Process each cubic segment
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const ctrlObj = controls[i] || {};

    const pts = Array.isArray(line?.points) ? line.points : [];
    const ctrls = Array.isArray(ctrlObj?.controls) ? ctrlObj.controls : [];

    for (let s = 0; s < pts.length - 1; s++) {
      const p0 = pts[s];
      const p3 = pts[s + 1];
      if (!p0 || !p3) continue;

      const c1 = ctrls[s] || { x2: p0.x, y2: p0.y };
      const c2 = ctrls[s + 1] || { x1: p3.x, y1: p3.y };

      const p1x = c1.x2 ?? p0.x;
      const p1y = c1.y2 ?? p0.y;
      const p2x = c2.x1 ?? p3.x;
      const p2y = c2.y1 ?? p3.y;

      const tValues = new Set([0, 1]);

      cubicExtrema(p0.x, p1x, p2x, p3.x).forEach(t => tValues.add(t));
      cubicExtrema(p0.y, p1y, p2y, p3.y).forEach(t => tValues.add(t));

      for (const t of tValues) {
        const x = bezierAt(t, p0.x, p1x, p2x, p3.x);
        const y = bezierAt(t, p0.y, p1y, p2y, p3.y);

        minX = Math.min(minX, x);
        minY = Math.min(minY, y);
        maxX = Math.max(maxX, x);
        maxY = Math.max(maxY, y);
      }
    }
  }

  // Default box if nothing valid
  if (!isFinite(minX) || !isFinite(minY) || !isFinite(maxX) || !isFinite(maxY)) {
    return {
      x: 0,
      y: 0,
      w: 10,
      h: 10,
      localPath: [],
      localControlPath: []
    };
  }

  const shift = 10;

  const dx = minX - shift;
  const dy = minY - shift;

  let width = (maxX - minX) + 2 * shift;
  let height = (maxY - minY) + 2 * shift;

  if (width < 10) width = 10;
  if (height < 10) height = 10;



  // Build local path
  const localPath = lines.map(line =>
    Array.isArray(line.points)
      ? {
          ...line,
          points: line.points.map(p => ({
            x: p.x - dx,
            y: p.y - dy
          }))
        }
      : line
  );

  // Build local control path
  const localControlPath = controls.map(ctrlObj => {
    const ctrlArray = Array.isArray(ctrlObj?.controls) ? ctrlObj.controls : [];

    return {
      controls: ctrlArray.map(c => ({
        x1: c.x1 - dx,
        y1: c.y1 - dy,
        x2: c.x2 - dx,
        y2: c.y2 - dy
      }))
    };
  });

  return {
    x: minX,
    y: minY,
    w: width,
    h: height,
    localPath,
    localControlPath
  };
}


/*
export function calculateCurveBoundingBox(pointsRef, controlRef) {
  const lines = pointsRef?.current || [];
  const controls = controlRef?.current || [];

  let minX = Infinity, minY = Infinity;
  let maxX = -Infinity, maxY = -Infinity;

  // Evaluate cubic bezier coordinate at t
  function bezierAt(t, p0, p1, p2, p3) {
    const mt = 1 - t;
    return mt * mt * mt * p0 + 3 * mt * mt * t * p1 + 3 * mt * t * t * p2 + t * t * t * p3;
  }

  // Returns t in (0,1) where extrema can occur for one coordinate
  function cubicExtrema(p0, p1, p2, p3) {
    const a = -p0 + 3 * p1 - 3 * p2 + p3;
    const b = 2 * (p0 - 2 * p1 + p2);
    const c = -p0 + p1;
    const ts = [];
    const EPS = 1e-12;

    if (Math.abs(a) < EPS) {
      if (Math.abs(b) > EPS) {
        const t = -c / b;
        if (t > 0 && t < 1) ts.push(t);
      }
    } else {
      const disc = b * b - 4 * a * c;
      if (disc >= 0) {
        const s = Math.sqrt(disc);
        const t1 = (-b + s) / (2 * a);
        const t2 = (-b - s) / (2 * a);
        if (t1 > 0 && t1 < 1) ts.push(t1);
        if (t2 > 0 && t2 < 1) ts.push(t2);
      }
    }
    return ts;
  }

  // 1) Include raw endpoints & control points in min/max
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const ctrlObj = controls[i] || {};
    const pts = Array.isArray(line?.points) ? line.points : [];
    const ctrls = Array.isArray(ctrlObj.controls) ? ctrlObj.controls : [];

    // Endpoints
    for (const p of pts) {
      if (p && typeof p.x === "number" && typeof p.y === "number") {
        minX = Math.min(minX, p.x);
        minY = Math.min(minY, p.y);
        maxX = Math.max(maxX, p.x);
        maxY = Math.max(maxY, p.y);
      }
    }

    // Control points
    for (const c of ctrls) {
      if (c && typeof c.x1 === "number" && typeof c.y1 === "number" && typeof c.x2 === "number" && typeof c.y2 === "number") {
        minX = Math.min(minX, c.x1, c.x2);
        minY = Math.min(minY, c.y1, c.y2);
        maxX = Math.max(maxX, c.x1, c.x2);
        maxY = Math.max(maxY, c.y1, c.y2);
      }
    }
  }

  // 2) Compute extrema along each cubic segment
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const ctrlObj = controls[i] || {};
    const pts = Array.isArray(line?.points) ? line.points : [];
    const ctrls = Array.isArray(ctrlObj.controls) ? ctrlObj.controls : [];

    for (let s = 0; s < pts.length - 1; s++) {
      const p0 = pts[s];
      const p3 = pts[s + 1];
      if (!p0 || !p3) continue;

      const c1 = ctrls[s] || { x2: p0.x, y2: p0.y, x1: p0.x, y1: p0.y };
      const c2 = ctrls[s + 1] || { x1: p3.x, y1: p3.y, x2: p3.x, y2: p3.y };

      const tSet = new Set([0, 1]);

      cubicExtrema(p0.x, c1.x2, c2.x1, p3.x).forEach(t => tSet.add(t));
      cubicExtrema(p0.y, c1.y2, c2.y1, p3.y).forEach(t => tSet.add(t));

      for (const t of tSet) {
        if (!isFinite(t)) continue;
        const x = bezierAt(t, p0.x, c1.x2, c2.x1, p3.x);
        const y = bezierAt(t, p0.y, c1.y2, c2.y1, p3.y);
        minX = Math.min(minX, x);
        minY = Math.min(minY, y);
        maxX = Math.max(maxX, x);
        maxY = Math.max(maxY, y);
      }
    }
  }

  // 3) Default box if no valid points
  if (!isFinite(minX) || !isFinite(minY) || !isFinite(maxX) || !isFinite(maxY)) {
    const defaultShift = 10;
    return {
      x: 0, y: 0,
      w: 10, h: 10,
      localPath: [],
      localControlPath: []
    };
  }

  // 4) Apply padding and compute width/height
  const shift = 10;
  const dx = minX - shift;
  const dy = minY - shift;
  let width = (maxX + 2 * shift) - minX;
  let height = (maxY + 2 * shift) - minY;
  if (width < 10) width = 10;
  if (height < 10) height = 10;

  // 5) Build localPath
  const localPath = lines.map(line =>
    Array.isArray(line.points)
      ? {
          ...line,
          points: line.points.map(p => ({ x: p.x - dx, y: p.y - dy }))
        }
      : line
  );

  // 6) Build localControlPath
  const localControlPath = controls.map(ctrlObj => {
    const ctrlArray = Array.isArray(ctrlObj?.controls) ? ctrlObj.controls : [];
    return {
      controls: ctrlArray.map(c => ({
        x1: c.x1 - dx,
        y1: c.y1 - dy,
        x2: c.x2 - dx,
        y2: c.y2 - dy
      }))
    };
  });

  return { x: minX, y: minY, w: width, h: height, localPath, localControlPath };
}
*/

function isPointInRect(p, x, y, w, h) {
  return (
    p.x >= x &&
    p.x <= x + w &&
    p.y >= y &&
    p.y <= y + h
  );
}

export function bezierPHit(x,y, lines, zoom)
{
  for(let i = 0; i<lines.length; i++)
  {
    const line = lines[i];
    for(let point = 0; point <line.points.length; point++)
    {
       // console.log(`x: ${x} y: ${y}`);

        const p = line.points[point];
        // console.log(`px: ${p.x} py: ${p.y}`);

        const pw = 10/zoom;

        if(isPointInRect(p,x-pw/2, y-pw/2, pw, pw))
        {
          return p;
        }
    }
  }
  
  return null;
}

export function bezierCHit(x,y, controls, zoom)
{

  // console.log("help");
  // console.log(JSON.stringify(controls));

  for(let i = 0; i<controls.length; i++)
  {
    const control = controls[i].controls;
    for(let c = 0; c < control.length; c++)
    {
        console.log(`x: ${x} y: ${y}`);

        const p = control[c];
        console.log(`px1: ${p.x1} py1: ${p.y1} px2: ${p.x2} py2: ${p.y2}`);

        const pw = 10/zoom;

        if(c != 0)
        {
          let p1 = {x: p.x1, y: p.y1}

          if(isPointInRect(p1,x-pw/2, y-pw/2, pw, pw))
          {
            return {control: p, loc: 0};
          }
        }

        if(c != control.length -1)
        {
          let p2 = {x: p.x2, y: p.y2}

          if(isPointInRect(p2,x-pw/2, y-pw/2, pw, pw))
          {
            return {control: p, loc: 1};
          }
        }
    }
  }
  
  return null;
}

export function pHit(x,y, lines,zoom)
{
  for(let i = 0; i<lines.length; i++)
  {
    const line = lines[i];
    for(let point = 0; point <line.points.length; point++)
    {
       // console.log(`x: ${x} y: ${y}`);

        const p = line.points[point];
        // console.log(`px: ${p.x} py: ${p.y}`);

        const pw = 10/zoom;

        if(isPointInRect(p,x-pw/2, y-pw/2, pw, pw))
        {
          return p;
        }
    }
  }
  
  return null;
}


export function removeStray(lines, controls, op, ignoreLast)
{
  let nLines = [];
  let nControls = [];

   // Iterate over lines to find if the first or last point of the current line matches other lines
   for (let i = 0; i < lines.length; i++) 
   {
      if(ignoreLast && i===lines.length-1)
      {
        nLines.push(JSON.parse(JSON.stringify(lines[i])));

        if(op === 'bezier')
        {
          nControls.push(JSON.parse(JSON.stringify(controls[i])))
        }
      }
      else
      {
        if(lines[i].points.length >= 2)
        {
          nLines.push(JSON.parse(JSON.stringify(lines[i])));

          if(op === 'bezier')
          {
            nControls.push(JSON.parse(JSON.stringify(controls[i])))
          }        
        }
      }
   }

   return {nLines, nControls};
}

export function jHit(currentLineIndex, lines) {
  const currentLine = lines[currentLineIndex];
  const firstPoint = currentLine.points[0];  // First point of the current line
  const lastPoint = currentLine.points[currentLine.points.length - 1]; // Last point of the current line

  let previousIndex = -1;
  let nextIndex = -1;
  let prevOrientation = '';
  let nextOrientation = '';

  const pw = 10; // Same as the pHit comparison, assuming this is the allowed tolerance range

  // Helper function to check if two points are "close enough"
  function arePointsClose(p1, p2) {
    return isPointInRect(p1, p2.x - pw / 2, p2.y - pw / 2, pw, pw);
  }

  // Helper function to determine orientation of a line: "same" or "reversed"
  function getOrientation(lineIndex, compareLine, loc) {
    const line = lines[lineIndex];
    const firstPointCompare = compareLine.points[0];
    const lastPointCompare = compareLine.points[compareLine.points.length - 1];


    if(loc === "prev")
    {
      if(arePointsClose(firstPoint, firstPointCompare))
      {
        return "reverse";
      }
      if(arePointsClose(firstPoint,lastPointCompare))
      {
        return "same";
      }
    }

    if(loc ==="next")
    {
      if(arePointsClose(lastPoint,firstPointCompare))
      {
        return "same";
      }
      if(arePointsClose(lastPoint,lastPointCompare))
      {
        return "reverse";
      }
    }  
    return "none";
  }

  // Iterate over lines to find if the first or last point of the current line matches other lines
  for (let i = 0; i < lines.length; i++) {
    if (i === currentLineIndex) continue; // Skip the current line
    
    const line = lines[i];
    
    // Check if the first or last point of the current line touches any other line
    if (arePointsClose(firstPoint, line.points[0]) || arePointsClose(firstPoint, line.points[line.points.length - 1])) {
      previousIndex = i;
      prevOrientation = getOrientation(i, line, "prev");
    }
    
    if (arePointsClose(lastPoint, line.points[0]) || arePointsClose(lastPoint, line.points[line.points.length - 1])) {

      if(i != previousIndex)
      {
        nextIndex = i;
        nextOrientation = getOrientation(i, line, "next");
      }
    }
  }

  return { previousIndex, prevOrientation, nextIndex, nextOrientation };
}



export function getSelectedSegments(pLines, selectionRect) {
  if (!pLines || !Array.isArray(pLines)) return [];

  const { x1, y1, x2, y2 } = selectionRect;
  const xmin = Math.min(x1, x2);
  const xmax = Math.max(x1, x2);
  const ymin = Math.min(y1, y2);
  const ymax = Math.max(y1, y2);

  const selected = [];

  // Loop through each polyline
  for (let li = 0; li < pLines.length; li++) {
    const line = pLines[li];
    if (!line || !line.points || line.points.length < 2) continue;

    // Loop through each segment in the line
    for (let i = 0; i < line.points.length - 1; i++) {
      // const p1 = line.points[i];
      // const p2 = line.points[i + 1];

      const p1 = {x:line.points[i].x, y:line.points[i].y}
      const p2 = {x:line.points[i+1].x, y:line.points[i+1].y}

      const p1In = (p1.x >= xmin && p1.x <= xmax && p1.y >= ymin && p1.y <= ymax);
      const p2In = (p2.x >= xmin && p2.x <= xmax && p2.y >= ymin && p2.y <= ymax);

      // Segment is selected if both endpoints are within the rectangle
      if (p1In && p2In) {
        selected.push({
          lineIndex: li,
          segmentIndex: i,
          p1,
          p2
        });
      }
    }
  }

  return selected;
}

export function getSegmentsRect(segments)
{
  if(!segments)
  {

    return null;
  }

  if(segments.length === 0)
  {
    return null;
  }

  let minX = 9999;
  let maxX = -9999;
  let minY = 9999;
  let maxY = -9999;

  for(let i=0; i<segments.length; i++)
  {
    if(segments[i].p1.x < minX)
    {
      minX = segments[i].p1.x;
    }

    if(segments[i].p2.x < minX)
    {
      minX = segments[i].p2.x;
    }

    if(segments[i].p1.y < minY)
    {
      minY = segments[i].p1.y;
    }

    if(segments[i].p2.y < minY)
    {
      minY = segments[i].p2.y;
    }

    if(segments[i].p1.x > maxX)
    {
      maxX = segments[i].p1.x;
    }

    if(segments[i].p2.x > maxX)
    {
      maxX = segments[i].p2.x;
    }

    if(segments[i].p1.y > maxY)
    {
      maxY = segments[i].p1.y;
    }

    if(segments[i].p2.y > maxY)
    {
      maxY = segments[i].p2.y;
    }
  }

  let w = maxX-minX;
  let h = maxY-minY;
  let rect = {x:minX,y:minY, w:w, h:h};

  return rect;
}

export function getSelectedSegmentsB(pLines, selectionRect, controls) {
  if (!pLines || !Array.isArray(pLines)) return [];

  const { x1, y1, x2, y2 } = selectionRect;
  const xmin = Math.min(x1, x2);
  const xmax = Math.max(x1, x2);
  const ymin = Math.min(y1, y2);
  const ymax = Math.max(y1, y2);

  const selected = [];

  // Loop through each polyline
  for (let li = 0; li < pLines.length; li++) {
    const line = pLines[li];
    const control = controls[li];
    if (!line || !line.points || line.points.length < 2) continue;

    // Loop through each segment in the line
    for (let i = 0; i < line.points.length - 1; i++) {
      /*
      const p1 = line.points[i];
      const p2 = line.points[i + 1];
      const c1 = control.controls[i];
      const c2 = control.controls[i+1];
      */

      const p1 = {x:line.points[i].x, y:line.points[i].y};
      const p2 = {x:line.points[i + 1].x, y:line.points[i+1].y};
      const c1 = {x1:control.controls[i].x1,y1:control.controls[i].y1, x2:control.controls[i].x2, y2:control.controls[i].y2};
      const c2 = {x1:control.controls[i+1].x1, y1:control.controls[i+1].y1, x2:control.controls[i+1].x2,y2:control.controls[i+1].y2};


      const p1In = (p1.x >= xmin && p1.x <= xmax && p1.y >= ymin && p1.y <= ymax);
      const p2In = (p2.x >= xmin && p2.x <= xmax && p2.y >= ymin && p2.y <= ymax);

      // Segment is selected if both endpoints are within the rectangle
      if (p1In && p2In) {
        selected.push({
          lineIndex: li,
          segmentIndex: i,
          p1,
          p2,
          c1,
          c2
        });
      }
    }
  }

  return selected;
}



export function breakSegment(lines, segment, isBezier, controls) 
{
  if (!lines || !segment) return;

  const { lineIndex, segmentIndex } = segment;

  // Loop through each polyline
  let newLines = [];
  let newControls=[];

  for (let li = 0; li < lines.length; li++) 
  {
    const line = lines[li];
    let control = [];
    
    if(isBezier)
    {
      control = controls[li];
    }
        
    if(li === lineIndex)
    {
      // this is the line that has to be broken;
      if(segmentIndex==0)
      { 
        let dupP1 = {x:line.points[segmentIndex].x, y:line.points[segmentIndex].y};       
        let dupP2 = {x:line.points[segmentIndex+1].x, y:line.points[segmentIndex+1].y};

        let dupC2 = undefined;
        let dupC1=undefined;


        if(isBezier)
        {
          // c1=control.controls[segmentIndex];
          dupC1 = {x1:control.controls[segmentIndex].x1,y1:control.controls[segmentIndex].y1, x2:control.controls[segmentIndex].x2, y2:control.controls[segmentIndex].y2};
          dupC2 = {x1:control.controls[segmentIndex+1].x1,y1:control.controls[segmentIndex+1].y1, x2:control.controls[segmentIndex+1].x2, y2:control.controls[segmentIndex+1].y2};
        }

        let extraPoints = [          
          dupP1,  //  line.points[segmentIndex],       // p1 reference
          dupP2,    // p2 reference
        ];
        
        let extraControls = [
          dupC1,
          dupC2
        ]

        segment.lineIndex = li;
        segment.segmentIndex = 0;
        segment.p1 = {x:dupP1.x, y:dupP1.y }; // line.points[segmentIndex];
        segment.p2 = {x:dupP2.x, y:dupP2.y};
        // segment.c1 = c1;
        if(isBezier)
        {
          segment.c1 = {x1:dupC1.x1, y1:dupC1.y1, x2:dupC1.x2, y2:dupC1.y2}
          segment.c2 = {x1:dupC2.x1, y1:dupC2.y1, x2:dupC2.x2, y2:dupC2.y2} // dupC2;
        }

        
        let lineExtra = {...line,points:extraPoints};
        newLines.push(lineExtra);

        let controlExtra = {};
        if(isBezier)
        {
          controlExtra = {controls:extraControls};
          newControls.push(controlExtra);
        }

        // Remaining piece of the original line
        const lineAfterBreak = {
            ...line,
            points: line.points.slice(1) // skip p0, p1
          };

        let controlAfterBreak = {controls:[]};
        if(isBezier)
        {
          controlAfterBreak = {
            controls: control.controls.slice(1)
          }   
        }

        // Only add if valid
        if (lineAfterBreak.points.length >= 2) {
            newLines.push(lineAfterBreak);
        }                
        if(isBezier)
        {
          if(controlAfterBreak.controls.length >=2)
          {         
            newControls.push(controlAfterBreak);
          }
        }
      }
      else
      {
        if(segmentIndex === line.points.length-2)
        {    
            // Remaining piece of the original line
            const lineBeforeBreak = {
                ...line,
                points: line.points.slice(0,segmentIndex+1) // skip p0, p1
              };
    
            let controlBeforeBreak = {controls:[]};
            if(isBezier)
            {
              controlBeforeBreak = {
                controls: control.controls.slice(0,segmentIndex+1)
              }   
            }
      
            // Only add if valid
            if (lineBeforeBreak.points.length >= 2) {
                newLines.push(lineBeforeBreak);
            }        

            if(isBezier)
            {
              if(controlBeforeBreak.controls.length >=2)
              {         
                newControls.push(controlBeforeBreak);
              }
            }
          
            let dupP1 = {x:line.points[segmentIndex].x, y:line.points[segmentIndex].y};
            let dupP2 = {x:line.points[segmentIndex+1].x, y:line.points[segmentIndex+1].y};
            let extraPoints = [
              dupP1,       
              dupP2, // line.points[segmentIndex+1],
            ];


            let dupC1 = undefined;
            let dupC2=undefined;
    
            if(isBezier)
            {
              // c2=control.controls[segmentIndex+1];
              dupC2 = {x1:control.controls[segmentIndex+1].x1,y1:control.controls[segmentIndex+1].y1, x2:control.controls[segmentIndex+1].x2, y2:control.controls[segmentIndex+1].y2};
              dupC1 = {x1:control.controls[segmentIndex].x1,y1:control.controls[segmentIndex].y1, x2:control.controls[segmentIndex].x2, y2:control.controls[segmentIndex].y2};
            }

            let extraControls = [
              dupC1,
              dupC2 // c2
            ]
    
        
            segment.lineIndex = li+1;
            segment.segmentIndex = 0; // segmentIndex;
            segment.p1 = {x:dupP1.x, y:dupP1.y};
            segment.p2 = {x:dupP2.x, y:dupP2.y};
            if(isBezier)
            {
              segment.c1 =  {x1:dupC1.x1, y1:dupC1.y1, x2:dupC1.x2, y2:dupC1.y2}; // dupC1;
              segment.c2 = {x1:dupC2.x1, y1:dupC2.y1, x2:dupC2.x2, y2:dupC2.y2}; //c2;
            }
    
            let lineExtra = {...line, points:extraPoints};
            newLines.push(lineExtra);


            let controlExtra = {controls:extraControls};
            newControls.push(controlExtra);

      
            console.log("last Line");
        }
        else
        {
          console.log("middle line");


          console.log("middle line");

          // PART 1 — BEFORE BREAK
          const lineBeforeBreak = {
              ...line,
              points: line.points.slice(0, segmentIndex + 1)
          };
          if (lineBeforeBreak.points.length >= 2)
              newLines.push(lineBeforeBreak);

          // CONTROL: BEFORE BREAK  ✅ FIXED
          if (isBezier) {
              const controlBeforeBreak = {
                  controls: control.controls.slice(0, segmentIndex + 1).map(c => ({ ...c }))
              };
              if (controlBeforeBreak.controls.length >= 2)
                  newControls.push(controlBeforeBreak);
          }

          // PART 2 — MID BREAK
          let dupP1 = { ...line.points[segmentIndex] };
          let dupP2 = { ...line.points[segmentIndex + 1] };

          let midLine = {
              ...line,
              points: [dupP1, dupP2]
          };

          segment.lineIndex = li + 1;
          segment.segmentIndex = 0;
          segment.p1 = {x:dupP1.x, y:dupP1.y};
          segment.p2 = {x:dupP2.x, y:dupP2.y};

          newLines.push(midLine);

          // CONTROL: MID BREAK
          if (isBezier) {
              let dupC1 = { ...control.controls[segmentIndex] };
              let dupC2 = { ...control.controls[segmentIndex + 1] };
              segment.c1 = {x1:dupC1.x1, y1:dupC1.y1, x2:dupC1.x2, y2:dupC1.y2}; // dupC1;
              segment.c2 = {x1:dupC2.x1, y1:dupC2.y1, x2:dupC2.x2, y2:dupC2.y2}; //dupC2;

              newControls.push({
                  controls: [dupC1, dupC2]
              });
          }

          // PART 3 — AFTER BREAK
          const lineAfterBreak = {
              ...line,
              points: line.points.slice(segmentIndex + 1)
          };
          if (lineAfterBreak.points.length >= 2)
              newLines.push(lineAfterBreak);

          // CONTROL: AFTER BREAK
          if (isBezier) {
              const controlAfterBreak = {
                  controls: control.controls.slice(segmentIndex + 1).map(c => ({ ...c }))
              };
              if (controlAfterBreak.controls.length >= 2)
                  newControls.push(controlAfterBreak);
          }
          
        }
      }
      
    }
    else
    {
      newLines.push(line);
      if(isBezier)
      {
        newControls.push(control);
      }
    }    
  }

  return {newLines:newLines, newControls:newControls};
}

export function straighten(line, control, segment,segments)
{
    console.log("In straighten function");
    const { segmentIndex } = segment;

    const newControl = JSON.parse(JSON.stringify(control));
    const pts = line.points;
    const ctrl = newControl.controls;

    if (!pts || pts.length < 2) return { newControl };

    // segment connects i -> i+1
    const i = segmentIndex;

    if (i < 0 || i >= pts.length - 1) return { newControl };

    const pA = pts[i];
    const pB = pts[i + 1];

    // direction vector A -> B
    let dx = pB.x - pA.x;
    let dy = pB.y - pA.y;
    let len = Math.hypot(dx, dy) || 1;

    dx /= len;
    dy /= len;

    // mid point (for symmetric handles)
    const mx = (pA.x + pB.x) / 2;
    const my = (pA.y + pB.y) / 2;

    // distance-based handle length (small = straighter look)
    const handleLen = len * 0.25;

    // --- straighten OUTGOING handle of A ---
    ctrl[i].x2 = pA.x + dx * handleLen;
    ctrl[i].y2 = pA.y + dy * handleLen;

    // --- straighten INCOMING handle of B ---
    ctrl[i + 1].x1 = pB.x - dx * handleLen;
    ctrl[i + 1].y1 = pB.y - dy * handleLen;

    console.log(JSON.stringify(segment));

    segment.c1.x2 = ctrl[i].x2;
    segment.c1.y2 = ctrl[i].y2;
    segment.c2.x1 = ctrl[i + 1].x1;
    segment.c2.y1 = ctrl[i+1].y1;

    segments[i].c1.x2 = segment.c1.x2;
    segments[i].c1.y2 = segment.c1.y2;
    segments[i].c2.x1 = segment.c2.x1;
    segments[i].c2.y1 = segment.c2.y1;
    return { newControl };
}

export function smoothBezierControls(line, control, strength = 0.25)
{
    let newControl = JSON.parse(JSON.stringify(control));

    const pts = line.points;
    const ctrl = newControl.controls;

    if (pts.length < 2) return { newControl };

    for (let i = 0; i < pts.length; i++)
    {
        const pPrev = pts[i - 1];
        const pCurr = pts[i];
        const pNext = pts[i + 1];

        let tx = 0;
        let ty = 0;

        // --- incoming direction ---
        if (pPrev)
        {
            let dx = pCurr.x - pPrev.x;
            let dy = pCurr.y - pPrev.y;
            let len = Math.hypot(dx, dy) || 1;

            tx += dx / len;
            ty += dy / len;
        }

        // --- outgoing direction ---
        if (pNext)
        {
            let dx = pNext.x - pCurr.x;
            let dy = pNext.y - pCurr.y;
            let len = Math.hypot(dx, dy) || 1;

            tx += dx / len;
            ty += dy / len;
        }

        // normalize tangent
        let tLen = Math.hypot(tx, ty) || 1;
        tx /= tLen;
        ty /= tLen;

        // scale based on local segment length
        let lenIn = pPrev ? Math.hypot(pCurr.x - pPrev.x, pCurr.y - pPrev.y) : 0;
        let lenOut = pNext ? Math.hypot(pNext.x - pCurr.x, pNext.y - pCurr.y) : 0;

        let avgLen = (lenIn + lenOut) / 2 || 1;

        // --- APPLY SYMMETRIC TANGENT HANDLES ---

        ctrl[i].x1 = pCurr.x - tx * avgLen * strength;
        ctrl[i].y1 = pCurr.y - ty * avgLen * strength;

        ctrl[i].x2 = pCurr.x + tx * avgLen * strength;
        ctrl[i].y2 = pCurr.y + ty * avgLen * strength;
    }

    return { newControl };
}

export function isSameLine(segments)
{    
    if(segments.length > 1)
    {
      for(let i=0; i<segments.length; i++)
      {
        if(segments[0].lineIndex !== segments[i].lineIndex)
        {
          return false;
        }

      }
    }
    return true;
}

export function getSegmentAtPoint(x, y, segments, strokeWidth = 5) {
  if (!segments || !Array.isArray(segments)) return null;

  let closestSegment = null;
  let minDist = Infinity;

  for (const seg of segments) {
    const { p1, p2 } = seg;
    const dist = pointToSegmentDistance(x, y, p1.x, p1.y, p2.x, p2.y);

    if (dist <= strokeWidth && dist < minDist) {
      minDist = dist;
      closestSegment = seg;
    }
  }

  return closestSegment;
}

/**
 * Calculate the perpendicular distance from a point (x, y)
 * to a line segment (x1, y1) - (x2, y2)
 */
function pointToSegmentDistance(x, y, x1, y1, x2, y2) {
  const A = x - x1;
  const B = y - y1;
  const C = x2 - x1;
  const D = y2 - y1;

  const dot = A * C + B * D;
  const lenSq = C * C + D * D;
  let param = -1;

  if (lenSq !== 0) param = dot / lenSq;

  let xx, yy;

  if (param < 0) {
    xx = x1;
    yy = y1;
  } else if (param > 1) {
    xx = x2;
    yy = y2;
  } else {
    xx = x1 + param * C;
    yy = y1 + param * D;
  }

  const dx = x - xx;
  const dy = y - yy;
  return Math.sqrt(dx * dx + dy * dy);
}




export function drawSelectedSegments(ctx, selectedSegments, viewPortRef, selectedSegment = null) {
  if (!ctx || !Array.isArray(selectedSegments)) return;

  ctx.save();

  const fadeAlpha = 0.2; // opacity for faded (non-selected) segments

  // Helper to draw handle circle
  function drawHandleCircle(x, y, r = 4) {
    ctx.beginPath();
    ctx.arc(x, y, r, 0, Math.PI * 2);
    ctx.fill();
  }

  for (const seg of selectedSegments) {
    const { p1, p2 } = seg;
    if (!p1 || !p2) continue;

    // Convert to screen coordinates
    const sp1 = pageToScreen(p1.x, p1.y, viewPortRef);
    const sp2 = pageToScreen(p2.x, p2.y, viewPortRef);

    // Determine if this is the selected segment
    const isSelected =
      selectedSegment &&
      selectedSegment.lineIndex === seg.lineIndex &&
      selectedSegment.segmentIndex === seg.segmentIndex;

    // Adjust style based on selection
    ctx.lineWidth = isSelected ? 5 : 3;
    ctx.strokeStyle = isSelected
      ? "rgba(0, 200, 255, 1)" // brighter for selected
      : `rgba(0, 180, 255, ${selectedSegment ? fadeAlpha : 0.8})`;
    ctx.fillStyle = isSelected
      ? "rgba(0, 200, 255, 0.6)"
      : `rgba(0, 180, 255, ${selectedSegment ? fadeAlpha : 0.3})`;

    // Draw line
    ctx.beginPath();
    ctx.moveTo(sp1.x, sp1.y);
    ctx.lineTo(sp2.x, sp2.y);
    ctx.stroke();

    // Draw endpoints
    drawHandleCircle(sp1.x, sp1.y);
    drawHandleCircle(sp2.x, sp2.y);
  }

  let r = getSegmentsRect(selectedSegments);
  if(r != null)
  {

    const { zoom } = viewPortRef.current;
    const { x, y } = pageToScreen(r.x, r.y, viewPortRef);
    const w = r.w * zoom;
    const h = r.h * zoom;

    // ctx.fillStyle = 'rgba(0,0,255,0.3)';
    ctx.fillStyle = "rgba(0, 0, 0, 0.05)"; 
    ctx.fillRect(x, y, w, h);
  }
  ctx.restore();
}

export function drawSelectedSegmentsB(ctx, selectedSegments, viewPortRef, selectedSegment = null) {
  if (!ctx || !Array.isArray(selectedSegments)) return;

  ctx.save();

  const fadeAlpha = 0.2;

  function drawHandleCircle(x, y, r = 4) {
    ctx.beginPath();
    ctx.arc(x, y, r, 0, Math.PI * 2);
    ctx.fill();
  }

  for (const seg of selectedSegments) {
    const { p1, p2, c1, c2 } = seg;
    if (!p1 || !p2 || !c1, !c2) continue;

    // Convert endpoints
    const sp1 = pageToScreen(p1.x, p1.y, viewPortRef);
    const sp2 = pageToScreen(p2.x, p2.y, viewPortRef);

    // Convert control points
    const sc1 = pageToScreen(c1.x2, c1.y2, viewPortRef);
    const sc2 = pageToScreen(c2.x1, c2.y1, viewPortRef);

    const isSelected =
      selectedSegment &&
      selectedSegment.lineIndex === seg.lineIndex &&
      selectedSegment.segmentIndex === seg.segmentIndex;

    ctx.lineWidth = isSelected ? 5 : 3;
    ctx.strokeStyle = isSelected
      ? "rgba(0, 200, 255, 1)"
      : `rgba(0, 180, 255, ${selectedSegment ? fadeAlpha : 0.8})`;

    ctx.fillStyle = isSelected
      ? "rgba(0, 200, 255, 0.6)"
      : `rgba(0, 180, 255, ${selectedSegment ? fadeAlpha : 0.3})`;

    // 🌟 Draw CUBIC BEZIER instead of straight line
    ctx.beginPath();
    ctx.moveTo(sp1.x, sp1.y);
    ctx.bezierCurveTo(
      sc1.x, sc1.y,   // control point 1
      sc2.x, sc2.y,   // control point 2
      sp2.x, sp2.y    // end point
    );
    ctx.stroke();

    // Draw endpoint handles
    drawHandleCircle(sp1.x, sp1.y);
    drawHandleCircle(sp2.x, sp2.y);

    // ⭐ OPTIONAL: Draw control handles (usually helpful for editing)
    // drawHandleCircle(sc1.x, sc1.y);
    // drawHandleCircle(sc2.x, sc2.y);
    // ctx.beginPath();
    // ctx.moveTo(sp1.x, sp1.y);
    // ctx.lineTo(sc1.x, sc1.y);
    // ctx.moveTo(sp2.x, sp2.y);
    // ctx.lineTo(sc2.x, sc2.y);
    // ctx.stroke();
  }

  let r = getSegmentsRect(selectedSegments);
  if(r != null)
  {

    const { zoom } = viewPortRef.current;
    const { x, y } = pageToScreen(r.x, r.y, viewPortRef);
    const w = r.w * zoom;
    const h = r.h * zoom;

    // ctx.fillStyle = 'rgba(0,0,255,0.3)';
    ctx.fillStyle = "rgba(0, 0, 0, 0.05)"; 
    ctx.fillRect(x, y, w, h);
  }
  ctx.restore();
}


function addAlphaToHex(hex, alpha) {
  // Ensure hex is 7 chars like #RRGGBB
  const cleanHex = hex.replace("#", "");
  // Convert alpha (0–1) to 0–255, then to hex
  const alphaHex = Math.round(alpha * 255).toString(16).padStart(2, "0");
  return `#${cleanHex}${alphaHex}`;
}


export function applySegmentOptionsB(tempRect, options, pLines, segmentRef, controls)
{
  console.log(JSON.stringify(tempRect));
  console.log("********************");
  console.log(JSON.stringify(options));


  /*
  for(let i=0; i<pLines.length; i++)
  {
    pLines[i].stroke = options.strokeWidth;
    pLines[i].strokeColor = addAlphaToHex(options.strokeColor,options.alpha);
    pLines[i].fillColor = addAlphaToHex(options.fillColor,options.alpha);
  }
  */

  let x1 = tempRect.x;
  let y1 = tempRect.y;
  let x2 = tempRect.x + tempRect.w;
  let y2 = tempRect.y + tempRect.h;

  let selected = {x1, y1, x2, y2};
  segmentRef.current = getSelectedSegmentsB(pLines, selected, controls);
  // pointsRef.current.push({points:[], stroke:plineRef.current.stroke, strokeColor:plineRef.current.strokeColor, fill:false, fillColor: plineRef.current.fillColor}); // Push empty line
}

export function applySegmentOptions(tempRect, options, pLines, segmentRef)
{
  console.log(JSON.stringify(tempRect));
  console.log("********************");
  console.log(JSON.stringify(options));

  /*
  for(let i=0; i<pLines.length; i++)
  {
    pLines[i].stroke = options.strokeWidth;
    pLines[i].strokeColor = addAlphaToHex(options.strokeColor,options.alpha);
    pLines[i].fillColor = addAlphaToHex(options.fillColor,options.alpha);
  }
  */

  let x1 = tempRect.x;
  let y1 = tempRect.y;
  let x2 = tempRect.x + tempRect.w;
  let y2 = tempRect.y + tempRect.h;

  let selected = {x1, y1, x2, y2};
  segmentRef.current = getSelectedSegments(pLines, selected);
  // pointsRef.current.push({points:[], stroke:plineRef.current.stroke, strokeColor:plineRef.current.strokeColor, fill:false, fillColor: plineRef.current.fillColor}); // Push empty line
}

// Detects if two line segments (p1-p2 and q1-q2) intersect
function segmentsIntersect(p1, p2, q1, q2) {
    function ccw(a, b, c) {
      return (c.y - a.y) * (b.x - a.x) > (b.y - a.y) * (c.x - a.x);
    }
  
    return (
      ccw(p1, q1, q2) !== ccw(p2, q1, q2) &&
      ccw(p1, p2, q1) !== ccw(p1, p2, q2)
    );
  }
  
  // 1. Check if polygon is self-intersecting
  export function isIntersecting(points) {
    const len = points.length;
    if (len < 4) return false; // A triangle can't self-intersect
  
    for (let i = 0; i < len; i++) {
      const p1 = points[i];
      const p2 = points[(i + 1) % len];
  
      for (let j = i + 1; j < len; j++) {
        // Skip adjacent segments or the same segment
        if (Math.abs(i - j) <= 1 || (i === 0 && j === len - 1)) continue;
  
        const q1 = points[j];
        const q2 = points[(j + 1) % len];
  
        if (segmentsIntersect(p1, p2, q1, q2)) return true;
      }
    }
    return false;
  }
  
  // 2. Check if polygon is closable (>= 3 valid points)


  
  // 3. Get winding direction: 0 = CCW, 1 = CW (Clipper-style)
  export function windingDirection(points) {
    let sum = 0;
    const len = points.length;
  
    for (let i = 0; i < len; i++) {
      const p1 = points[i];
      const p2 = points[(i + 1) % len];
      sum += (p2.x - p1.x) * (p2.y + p1.y); // Shoelace direction
    }
  
    return sum > 0 ? 1 : 0; // CW = 1, CCW = 0
  }
  

// Function to check if the polygon can be closed
  
  
  // Function to check if the polygon is already closed
  export function isClosed(points) {
    if (!Array.isArray(points) || points.length < 3) return false;
  
    // Check if first and last points are the same
    const first = points[0];
    const last = points[points.length - 1];
    return first.x === last.x && first.y === last.y;
  }
  

  export function canClose(points) {
    if (!Array.isArray(points) || points.length < 3) return false;
  
    // 1. Check if the first and last points are the same (if so, already closed)
    const first = points[0];
    const last = points[points.length - 1];
    if (first.x === last.x && first.y === last.y) {
      return true; // Polygon is already closed
    }
  
    // 2. Remove duplicate points
    points = removeDuplicatePoints(points);
    if (points.length < 3) 
    {
        console.log("remove duplicates failed");
        return false;
    }
  
    // 3. Check if the polygon is collinear
    if (areCollinear(points)) 
    {
        console.log("Colinearity fails");
        return false;
    }
  
    // 4. Check if the polygon intersects itself
    if (doesIntersectAnySegment(points)) 
    {
        console.log("genral intersection failure");
        return false;
    }
  
    // 5. Check if the last segment can close the polygon
    if (doesIntersectAnySegmentToFirst(last, first, points)) 
    {
        console.log("To First segment intersection");
      return false;
    }
  
    return true; // Can close the polygon
  }
  

  // Function to check if the polygon is collinear (using all points)
function areCollinear(points) {
    for (let i = 0; i < points.length - 2; i++) {
      const [p1, p2, p3] = [points[i], points[i + 1], points[i + 2]];
      if ((p2.y - p1.y) * (p3.x - p2.x) !== (p3.y - p2.y) * (p2.x - p1.x)) {
        return false; // Not collinear
      }
    }
    return true; // Collinear
  }
  
  // Remove duplicate points (exactly the same x, y)
  function removeDuplicatePoints(points) {
    const seen = new Set();
    return points.filter(p => {
      const key = `${p.x},${p.y}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }
  

  // Helper function to check if any line segments intersect
function doesIntersectAnySegment(points) {
    for (let i = 0; i < points.length - 1; i++) {
      for (let j = i + 1; j < points.length - 1; j++) {
        // Check if segments (i, i+1) and (j, j+1) intersect
        if (doIntersect(points[i], points[i + 1], points[j], points[j + 1])) {
          return true; // Intersection found
        }
      }
    }
    return false; // No intersection
  }
  
  // Helper function to check if two line segments (p1-p2) and (p3-p4) intersect
  function doIntersect(p1, p2, p3, p4) {
    const { x: x1, y: y1 } = p1;
    const { x: x2, y: y2 } = p2;
    const { x: x3, y: y3 } = p3;
    const { x: x4, y: y4 } = p4;
  
    // Calculate the orientations of the points
    const o1 = orientation(p1, p2, p3);
    const o2 = orientation(p1, p2, p4);
    const o3 = orientation(p3, p4, p1);
    const o4 = orientation(p3, p4, p2);
  
    // General case: if orientations are different, segments intersect
    if (o1 !== o2 && o3 !== o4) {
      return true;
    }
  
    // Special case: if points are collinear, check if they are on the segment
    if (o1 === 0 && onSegment(p1, p2, p3)) return true;
    if (o2 === 0 && onSegment(p1, p2, p4)) return true;
    if (o3 === 0 && onSegment(p3, p4, p1)) return true;
    if (o4 === 0 && onSegment(p3, p4, p2)) return true;
  
    return false; // No intersection
  }
  
  // Function to calculate the orientation of the triplet (p, q, r)
  function orientation(p, q, r) {
    const val = (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
    if (val === 0) return 0; // Collinear
    return (val > 0) ? 1 : 2; // 1 -> Clockwise, 2 -> Counterclockwise
  }
  
  // Function to check if point q lies on the segment pr
  function onSegment(p, q, r) {
    return (q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) &&
            q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y));
  }
  
  // Test with the specific case:
  const points = [
    {x: 0, y: 0},
    {x: 0, y: 60},
    {x: 80, y: 60},
    {x: 80, y: 100},
    {x: 120, y: 120},
    {x: 180, y: 80},
    {x: 160, y: 40}
  ];
  
  // console.log(doesIntersectAnySegment(points)); // Expected to return false
  
  
  
  // Helper function to check if any line segments intersect with the line connecting last and first points
  function doesIntersectAnySegmentToFirst(last, first, points) {
    // We want to check if the line from the last point to the first intersects any other segment
    for (let i = 0; i < points.length - 1; i++) {
      // If the new segment intersects any existing one
      if (doIntersect(last, first, points[i], points[i + 1])) {
        return true; // Intersection found
      }
    }
    return false; // No intersection found
  }


  export function getUnique(u) {
    // ULID implementation
    function encodeTime(time, len) {
      let str = '';
      while (len > 0) {
        str = encodeChars[time % 32] + str;
        time = Math.floor(time / 32);
        len--;
      }
      return str;
    }
  
    function encodeRandom(len) {
      let str = '';
      for (let i = 0; i < len; i++) {
        str += encodeChars[Math.floor(Math.random() * 32)];
      }
      return str;
    }
  
    const encodeChars = '0123456789ABCDEFGHJKMNPQRSTVWXYZ'; // Crockford's Base32
    const now = Date.now();
  
    // Use a static counter to make the timestamp more unique for rapid iterations
    if (!getUnique.counter) {
      getUnique.counter = 0;
    }
    getUnique.counter = (getUnique.counter + 1) % 100; // A simple counter increment (mod 32 to limit size)
  
    let tsPart = encodeTime(now + getUnique.counter, 10); // Add counter to the timestamp for uniqueness
    let randPart = encodeRandom(16);
  
    let id = tsPart + randPart;
  
    // Ensure it's not equal to u (previous ID)
    while (id === u) {
      randPart = encodeRandom(16);
      id = tsPart + randPart;
    }
  
    return id;
  }

  /*
  export function getUnique(u) {
    // ULID implementation
    function encodeTime(time, len) {
      let str = '';
      while (len > 0) {
        str = encodeChars[time % 32] + str;
        time = Math.floor(time / 32);
        len--;
      }
      return str;
    }
  
    function encodeRandom(len) {
      let str = '';
      for (let i = 0; i < len; i++) {
        str += encodeChars[Math.floor(Math.random() * 32)];
      }
      return str;
    }
  
    const encodeChars = '0123456789ABCDEFGHJKMNPQRSTVWXYZ'; // Crockford's Base32
    const now = Date.now();
  
    let tsPart = encodeTime(now, 10);
    let randPart = encodeRandom(16);
  
    let id = tsPart + randPart;
  
    // Ensure it's not equal to u (previous ID)
    while (id === u) {
      randPart = encodeRandom(16);
      id = tsPart + randPart;
    }
  
    return id;
  }

  */

  export function drawText(ctx, x, y, w, h, text) {
    if (!text) return;
  
    ctx.save();
  
    // Set text alignment and color
    ctx.textAlign = 'left';
    ctx.textBaseline = 'top';
    ctx.fillStyle = 'black';
  
    // Set the font size and line height
    const fontSize = 16;  // Adjust font size as needed
    const lineHeight = fontSize * 1.2;
  
    // Set the font on the context
    ctx.font = `${fontSize}px Arial`;
  
    // Split the text into words
    const words = text.split(' ');
    let lines = [];
    let currentLine = '';
  
    // Function to measure the width of a line
    function getLineWidth(line) {
      return ctx.measureText(line).width;
    }
  
    // Wrap the text to fit within the given width
    for (let i = 0; i < words.length; i++) {

      let word = words[i];

      // CHANGED: Break very long words that exceed the rectangle width
      while (getLineWidth(word) > w) {

        let part = '';

        for (let j = 0; j < word.length; j++) {
          const testPart = part + word[j];

          if (getLineWidth(testPart) <= w) {
            part = testPart;
          } else {
            break;
          }
        }

        if (part) {
          if (currentLine) {
            lines.push(currentLine);
            currentLine = '';
          }

          lines.push(part);
          word = word.substring(part.length);

        } else {
          break;
        }
      }


      const testLine = currentLine + (currentLine ? ' ' : '') + word;

      if (getLineWidth(testLine) <= w) {
        currentLine = testLine;

      } else {

        if (currentLine) {
          lines.push(currentLine);
        }

        currentLine = word;
      }
    }

    /*
    // Wrap the text to fit within the given width
    for (let i = 0; i < words.length; i++) {
      const word = words[i];
      

      const testLine = currentLine + (currentLine ? ' ' : '') + word;
      if (getLineWidth(testLine) <= w) {
        currentLine = testLine;
      } else {
        if (currentLine) {
          lines.push(currentLine);
        }
        currentLine = word;
      }
    }
    */
  
    // Add the last line
    if (currentLine) {
      lines.push(currentLine);
    }
  
    // Clip lines that exceed the height
    const maxLines = Math.floor(h / lineHeight);
    lines = lines.slice(0, maxLines);
  
    // Draw the text within the rectangle, clipping at the bottom
    let currentY = y;
    lines.forEach((line, index) => {
      if (currentY + lineHeight > y + h) {
        return;  // If the next line is beyond the rectangle height, stop drawing
      }
      ctx.fillText(line, x, currentY);
      currentY += lineHeight;
    });
  
    ctx.restore();
  }
  
  export function resize(localPath, zoomX, zoomY) {
    return localPath.map(line => 
      Array.isArray(line.points) 
        ? {
            ...line,  // Keep all the metadata (stroke, color, etc.)
            points: line.points.map(p => 
              p && typeof p.x === 'number' && typeof p.y === 'number'
                ? { x: p.x * zoomX, y: p.y * zoomY }  // Apply the zoom factor to each point
                : p
            )
          }
        : line  // Keep the line as is if it doesn't have points
    );
  }


  export function resizeC(controls, zoomX, zoomY) {
    return controls.map(control => 
      Array.isArray(control.controls) 
        ? {
            ...control,  // Keep all the metadata (stroke, color, etc.)
            controls: control.controls.map(p => 
              p && typeof p.x1 === 'number' && typeof p.y1 === 'number' && typeof p.x2 === 'number' && typeof p.y2 === 'number'
                ? { x1: p.x1 * zoomX, y1: p.y1 * zoomY, x2: p.x2 * zoomX, y2:p.y2 * zoomY }  // Apply the zoom factor to each point
                : p
            )
          }
        : controls  // Keep the line as is if it doesn't have points
    );
  }


  export function exploadFunc(points, controls, selected)
  {

    if (!selected || !points || !controls)
    {
      console.log("points, controls or selected not defined");
      return false;
    }
    if(selected.length != 1)
    {
      console.log("Only 1 rect can be exploaded at a time");
      return false;
    }

    let rect = selected[0];
    if(rect.type != 'Bezier' && rect.type != 'Prect')
    {
      console.log("This Rectangle cannot be exploded here");
      return false;
    }


    let path = rect.path;
    let controlPath = null;
    

    if(rect.type === 'Bezier')
    {
        
        let {rPath, rControls} = rotateCurvePath(rect.x,rect.y,rect.w,rect.h,rect.rotation, path, rect.control);
        path = rPath;
        controlPath = rControls;
    }
    else
    {
      let rPath = rotatePath(rect.x,rect.y,rect.w,rect.h,rect.rotation,path);
      path = rPath;
    }


    const l = path // rect.path;
    let  c = null;
    
    if(rect.type === 'Bezier')
    {
      c=controlPath // rect.control;
    }

    if(!l)
    {
      console.log("localPath is not defined");
      return false;
    }

    for(let i=0; i<l.length; i++)
    {
      let line = l[i];

      if (!line || !line.points || line.points.length < 2) continue;

      let control = null
      
      if(c != null)
      {
        control = c[i];
      }

      let cPoint = {
        controls:[]
      }


      let nl = {
          ...line,
          points: []};

       // console.log("lines.points length: ", line.points.length);
       // console.log("control.controls length", control.controls.length);

      for(let p=0; p<line.points.length; p++)
      {
     
        let np = {x:line.points[p].x+rect.x, y:line.points[p].y+rect.y+rect.h}
        nl.points.push(np);

        if(control != null)
        {
          let c1 = control.controls[p];
          cPoint.controls.push({x1:c1.x1+rect.x, y1:c1.y1+rect.y+rect.h, x2:c1.x2+rect.x, y2:c1.y2+rect.y+rect.h});
        }
      }

      points.push(nl);
      if(control!=null)
      {
        controls.push(cPoint);
      }
    }

    return true;
  }


  export function multiplyMatrices(a, b) {
    return {
      // Top-left part: Apply rotation and scaling
      a: a.a * b.a + a.c * b.b,  // a11
      b: a.b * b.a + a.d * b.b,  // a12
      c: a.a * b.c + a.c * b.d,  // a21
      d: a.b * b.c + a.d * b.d,  // a22
  
      // Apply translation part
      e: a.a * b.e + a.c * b.f + a.e, // tx (translation x)
      f: a.b * b.e + a.d * b.f + a.f  // ty (translation y)
    };
  }


// Helper function to create a translation matrix
export function createTranslationMatrix(tx, ty) {
  return {
    a: 1, b: 0, c: 0, d: 1, e: tx, f: ty
  };
}

/*
// Helper function to create a rotation matrix (in radians)
export function createRotationMatrix(angle) {
  const cos = Math.cos(angle);
  const sin = Math.sin(angle);
  return {
    a: cos, b: sin, c: -sin, d: cos, e: 0, f: 0
  };
}
*/

export function createRotationMatrix(angle) {
  const cos = Math.cos(angle);
  const sin = Math.sin(angle);
  return {
    a: cos,  // cos(θ)
    b: -sin, // -sin(θ)
    c: sin,  // sin(θ)
    d: cos,  // cos(θ)
    e: 0,    // No translation in X
    f: 0     // No translation in Y
  };
}
// Helper function to create a transformation matrix for screen (zoom + offset)
export function createScreenTransformationMatrix(zoomX, zoomY, offsetX, offsetY) {
  return {
    a: zoomX, b: 0, c: 0,
    d: zoomY, e: offsetX*zoomX, f: offsetY*zoomY
  };
}

// Function to apply the matrix to ctx
export function applyMatrixToCtx(ctx, matrix) {
  ctx.setTransform(matrix.a, matrix.b, matrix.c, matrix.d, matrix.e, matrix.f);
}

export function transformPoint(point, matrix) {
  const x = point.x;
  const y = point.y;

  const xPrime = matrix.a * x + matrix.c * y + matrix.e;
  const yPrime = matrix.b * x + matrix.d * y + matrix.f;

  return { x: xPrime, y: yPrime };
}


export function insertMPath(pathRect, selected)
{


  if(pathRect === null)
  {
    if(selected)
    {   
      selected.mPath = undefined;
    }
    return;
  }

  if(pathRect.type === 'Bezier' ||
    pathRect.type === 'Prect')
  {
      let pR= JSON.parse(JSON.stringify(pathRect));
      selected.mPath = pR;


      pR.x = selected.x - selected.offsetViewX;
      pR.y = selected.y - selected.offsetViewY;

      // let rZoomX = selected.w/pR.w;
      // let rZoomY = selected.h/pR.h;
      let rZoomX = 1;
      let rZoomY = 1;

      //pR.w = selected.w;
      // pR.h = selected.h;

      if(selected.w < (pR.w - selected.offsetViewX))
      {
        selected.w = pR.w - selected.offsetViewX;
      }

      if(selected.h < (pR.h - selected.offsetViewY))
      {
        selected.h = pR.h - selected.offsetViewY;
      }


      const originalPath = pR.path;
      const newPath = resize(originalPath, rZoomX, rZoomY);
      pR.path = newPath;

      if(pR.type === 'Bezier')
      {   
        const originalControl = pR.control;
        const newControl = resizeC(originalControl, rZoomX, rZoomY);
        pR.control = newControl;
      }

      /*
      let lineObj = pR.path;
      let firstObjPoint = lineObj[0].points[0];
      let dX = -1*firstObjPoint.x; // firstObjPoint.x;
      let dY = -1*firstObjPoint.y; // firstObjPoint.y;

      if(pR.type === 'Bezier')
      {
        let controlObj = pR.control;
        translateBezier(lineObj, controlObj, dX, dY);
      }
      */

      console.log("MPath should be selected");
    }

    console.log("subType: ", pathRect.subType);
    if(pathRect.subType === 'SvgRect' || 
      pathRect.subType === 'SvgSquare' ||
      pathRect.subType === 'SvgCircle' ||
      pathRect.subType === 'SvgEllipse')
    {
        let pR= JSON.parse(JSON.stringify(pathRect));
        selected.mPath = pR;

        pR.x = selected.x-selected.offsetViewX;
        pR.y = selected.y-selected.offsetViewY;

        if(pathRect.subType === 'SvgSquare' || 
          pathRect.subType === 'SvgCircle')
        {
          if(pR.w < pR.h)
          {
              pR.h = pR.w;
          }
          else
          {
            pR.w = pR.h;
          }
        }


        // let rZoomX = selected.w/pR.w;
        // let rZoomY = selected.h/pR.h;
        let rZoomX = 1;
        let rZoomY = 1;

        if(selected.w < (pR.w - selected.offsetViewX))
        {
          selected.w = pR.w - selected.offsetViewX;
        }
  
        if(selected.h < (pR.h - selected.offsetViewY))
        {
          selected.h = pR.h - selected.offsetViewY;
        }
  
    }

}


export function insertMObjText(pathRect, selected)
{
  let pR= JSON.parse(JSON.stringify(pathRect));
  selected.mObj = pR;

  pR.x = selected.x - selected.offsetViewX;
  pR.y = selected.y - selected.offsetViewY;

  let rZoomX = 1; //selected.w/pR.w;
  let rZoomY = 1; //selected.h/pR.h;

  // pR.w = selected.w;
  // pR.h = selected.h;

  /*
  const originalPath = pR.path;
  const newPath = resize(originalPath, rZoomX, rZoomY);
  pR.path = newPath;
  

  if(pR.type === 'Bezier')
  {   
    const originalControl = pR.control;
    const newControl = resizeC(originalControl, rZoomX, rZoomY);
    pR.control = newControl;

  }
  */
 
  // translateMObj(pR,selected.mPath.x,selected.mPath.y);
  
  console.log("Text  should be selected");


}


export function insertMObj(pathRect, selected)
{


  if(pathRect === null)
  {
    if(selected)
    {   
      selected.mObj = undefined;
    }
    return;
  }


  let pR= JSON.parse(JSON.stringify(pathRect));
  selected.mObj = pR;


  pR.x = selected.x - selected.offsetViewX;
  pR.y = selected.y - selected.offsetViewY;

  pR.rotation = 0;
 


  let rZoomX = 1; //selected.w/pR.w;
  let rZoomY = 1; //selected.h/pR.h;

  // pR.w = selected.w;
  // pR.h = selected.h;

  /*
  const originalPath = pR.path;
  const newPath = resize(originalPath, rZoomX, rZoomY);
  pR.path = newPath;
  

  if(pR.type === 'Bezier')
  {   
    const originalControl = pR.control;
    const newControl = resizeC(originalControl, rZoomX, rZoomY);
    pR.control = newControl;

  }
 
  translateMObj(pR,selected.mPath.x,selected.mPath.y);
  */

  translateMObj(pR,pR.x, pR.y);
  
  console.log("MPath should be selected");

}

export function translateMObj(mObj, ax, ay)
{
  if(!mObj)
  {
    return;
  }

  let anchorPoint = {x:ax, y:ay}; // line.points[0];    
  let lineObj = mObj.path;

  // let firstObjPoint = lineObj[0].points[0];
  let dX = anchorPoint.x - mObj.x; // firstObjPoint.x;
  let dY = anchorPoint.y - mObj.y // firstObjPoint.y;


 // mObj.iX += dX;
  // mObj.iY += dY;

  lineObj.forEach((line) =>{
    line.points.forEach((point)=>{
      point.x += dX;
      point.y += dY;
    })
  });
}


export function doResize (rect, nw, nh)
{
  if(!rect.mObj)
  {
    return;
  }

  
  if(rect.mPath !== undefined)
  {
      if ((rect.x + nw) >= (rect.mPath.x + rect.mPath.w))
      {
        rect.w = nw;
      }
      if((rect.y+nh) >= (rect.mPath.y + rect.mPath.h))
      {
        rect.h = nh;
      }
  }
  else
  {
    if ((rect.x + nw) >= (rect.mObj.x + rect.mObj.w))
    {
      rect.w = nw;
    }
    if((rect.y+nh) >= (rect.mObj.y + rect.mObj.h))
    {
      rect.h = nh;
    }
  }
}

export function offsetView(rect, dx, dy)
{  

    if(!rect.mObj)
    {
      return;
    }
  

    let xOffset = 0;
    let yOffset = 0;
    if(rect.mPath !== undefined)
    {
      xOffset = rect.mPath.x - rect.x;
      yOffset = rect.mPath.y - rect.y;
    }
    else
    {
      xOffset = rect.mObj.x - rect.x;
      yOffset = rect.mObj.y - rect.y;
    }

    if(xOffset + dx > 0)    
    {
      if(rect.mPath !== undefined)
      {
        rect.mPath.x += dx;
      }

      if(rect.mObj)
      {
        rect.mObj.x += dx;
      }
      
      rect.offsetViewX -= dx;
      rect.w += dx;
    }

    if(yOffset + dy > 0)
    {
      if(rect.mPath !== undefined)
      {
        rect.mPath.y += dy;
      }


      if(rect.mObj)
      {
        rect.mObj.y += dy;
      }
      rect.offsetViewY -= dy;              
      rect.h += dy;        
    }    
}

export function offsetPath(mObj, dX, dY)
{
  if(!mObj)
  {
    return;
  }
    

  let lineObj = mObj.path;
 // mObj.iX += dX;
  // mObj.iY += dY;

  lineObj.forEach((line) =>{
    line.points.forEach((point)=>{
      point.x += dX;
      point.y += dY;
    })
  });

  if(mObj.type === 'Bezier')
  {
    let controlObj = mObj.control
    
    controlObj.forEach((control) =>{
      control.controls.forEach((control)=>{
        control.x1 += dX;
        control.y1 += dY;
        control.x2 += dX;
        control.y2 += dY;
  
      })
    });
  }
}


export function offsetText(m, dx, dy) {
  let path = String(m.svgText); // <-- force string

  const tokens = path.match(/[a-zA-Z]|-?\d*\.?\d+/g);
  if (!tokens) return;

  let result = [];
  let isX = true;

  for (let token of tokens) {
    if (isNaN(token)) {
      result.push(token);
      isX = true;
    } else {
      let num = parseFloat(token);
      num += isX ? dx : dy;
      result.push(num);
      isX = !isX;
    }
  }

  m.svgText = result.join(" "); // <-- FIXED (you forgot assignment before)
}

export function translateBezier(rPath, rControls, ax, ay)
{
  if(!rPath || !rControls)
  {
    return;
  }
  
  let lineObj = rPath;

  lineObj.forEach((line) =>{
    line.points.forEach((point)=>{
      point.x += ax;
      point.y += ay;
    })
  });


  let controlObj = rControls
    
  controlObj.forEach((control) =>{
    control.controls.forEach((control)=>{
      control.x1 += ax;
      control.y1 += ay;
      control.x2 += ax;
      control.y2 += ay;

    })
  });
}

export function translatePRect(rPath, ax, ay)
{
  if(!rPath)
  {
    return;
  }
  
  let lineObj = rPath;

  lineObj.forEach((line) =>{
    line.points.forEach((point)=>{
      point.x += ax;
      point.y += ay;
    })
  });

}

 export function moveGroup(rect, dx, dy) {
    const group = rect;  // Assuming you're moving a single group
    if (!group) return;
  
    // Initialize a queue with the selected group
    const queue = [group];
  
    while (queue.length > 0) {
      // Get the current group from the queue
      const currentGroup = queue.shift();
  
      // Move the group itself
      currentGroup.x += dx;
      currentGroup.y += dy;
  
      // Adjust the positions of the children
      currentGroup.children.forEach(child => {
         //child.x += dx;
         // child.y += dy;
  
        // If the child is a group, add it to the queue to be moved next
        if (child.children && child.children.length > 0) {
          queue.push(child);
        }
      });
    }
  }  

  export function getOpacity(rect)
  {
    if(rect?.hasParent)
    {
      let tAlpha = 1;
      if(rect?.fillAlpha)
      {
        if(rect?.parentAlpha)
        {
          tAlpha = rect.fillAlpha*rect.parentAlpha;
        }
        else
        {
          tAlpha = rect.fillAlpha;
        }
      }
      return tAlpha;
    }
    else
    {
      if(rect?.fillAlpha)
      {        
        return rect.fillAlpha;
      }
    }
    return 1;
  }



  export function drawPath(ctx, rect, viewPortRef)
  {    
      // console.log("lpath: ", JSON.stringify(lPath));
      let lPath = rect.path;

      // console.log(JSON.stringify(lPath));

      let rPath = rotatePath(rect.x,rect.y,rect.w,rect.h,rect.rotation,lPath);
      // let svgPath = rPathToSvg(lPath);
      let svgPath = rPathToSvgMap(lPath);
      rect.rPath = svgPath;
      let bound = getBoundingBoxFromPoints(rPath);
      rect.bound = bound;
      // rect.bound.x = rect.x + bound.x;
      // rect.bound.y = rect.y + bound.y;

      ctx.save();
      applyEffects(ctx,rect);
  
      let {w,h} = rect;
      let sw=w;
      let sh=h;
  
      
      if(rect.isDropShadow)
      {
        sw = w - Math.abs(rect.shadowOffsetX) - rect.shadowBlur;
        sh = h - Math.abs(rect.shadowOffsetY) - rect.shadowBlur;
      }
      if(rect.isBlur)
      {
        sw = sw - rect.regularBlur;
        sh = sh - rect.regularBlur;
      }
  
      let tX = (w-sw) / 2;
      let tY = (h-sh) / 2;
  
  
      let rZoomX = sw/(w+tX);
      let rZoomY = sh/(h+tY);
  
      let np = resize(lPath,rZoomX, rZoomY);
            
      translatePRect(np, tX, tY);
  
      rPath=rotatePath(rect.x,rect.y,rect.w,rect.h,rect.rotation, np);
      // let svgPath = rPathToCurveSvg(path, controlPath);
      svgPath = rPathToSvgMap(np);
      rect.rPath = svgPath;    
        

      for (const line of rPath) 
      {
        ctx.save(); 
        ctx.beginPath();
        let gAlpha = getOpacity(rect);
        ctx.globalAlpha = line.alpha * gAlpha;

        for (let p = 0; p<line.points.length; p++)
        {            
            let xP = line.points[p].x + rect.x;
            let yP = line.points[p].y + rect.y;

            // console.log("XP: ",xP);
            // console.log("YP: ", yP);
            const { x:xS, y:yS } = pageToScreenN(xP, yP,viewPortRef);
                                
            if(p == 0)
            {                   
              ctx.moveTo(xS, yS);  
            }
            else
            {
              ctx.lineTo(xS,yS);
            }            
                     
        }  

        if(line.allowStroke)
        {
          ctx.strokeStyle = line.strokeColor;
          ctx.lineWidth = line.strokeWidth;

          ctx.lineJoin = "round";
          ctx.lineCap = "round";

          ctx.stroke(); // Don't forget to stroke each path
        }

        if (line.allowFill) {

          if (line.fillMode === "gradient") {

            const angle = (line.gradientAngle || 0) * Math.PI / 180;
          
            const dx = Math.cos(angle);
            const dy = Math.sin(angle);
          
            // ✅ Use actual bounds
            const bx = rect.x;
            const by = rect.y;

            const bounds = getLineBounds(line.points);
            const bw = bounds.width;
            const bh = bounds.height;
          
            const cx = bx + bounds.x+bw / 2;
            const cy = by + bounds.y+bh / 2;
          
            const halfW = bw / 2;
            const halfH = bh / 2;
          
            const x0 = cx - dx * halfW;
            const y0 = cy - dy * halfH;
            const x1 = cx + dx * halfW;
            const y1 = cy + dy * halfH;
          
            // ⚠️ Convert to screen coords (VERY important)
            const p0 = pageToScreenN(x0, y0, viewPortRef);
            const p1 = pageToScreenN(x1, y1, viewPortRef);
          
            const grad = ctx.createLinearGradient(p0.x, p0.y, p1.x, p1.y);
          
            grad.addColorStop(0, line.gradientColor1 || "#ffffff");
            grad.addColorStop(1, line.gradientColor2 || "#000000");
          
            ctx.fillStyle = grad;
          }
          else {
              ctx.fillStyle = line.fillColor;
          }
        
          ctx.fill();
        }
      

        ctx.restore(); // Restore context state after each line
      }

    ctx.restore();      
  }

  export function drawCurvePath(ctx, rect, viewPortRef) {
    let path = rect.path;
    let controlPath = rect.control;

    let svgPath = rPathToCurveSvgMap(path, controlPath);
    rect.rPath = svgPath;

    let bound = svgPathBoundingBoxMap(svgPath);
    rect.bound = bound;

    ctx.save();
    applyEffects(ctx, rect);

    let { w, h } = rect;
    let sw = w;
    let sh = h;

    if (rect.isDropShadow) {
        sw = w - Math.abs(rect.shadowOffsetX) - rect.shadowBlur;
        sh = h - Math.abs(rect.shadowOffsetY) - rect.shadowBlur;
    }

    if (rect.isBlur) {
        sw = sw - rect.regularBlur;
        sh = sh - rect.regularBlur;
    }

    let tX = (w - sw) / 2;
    let tY = (h - sh) / 2;

    let rZoomX = sw / (w + tX);
    let rZoomY = sh / (h + tY);

    let np = resize(path, rZoomX, rZoomY);
    let rc = resizeC(controlPath, rZoomX, rZoomY);

    translateBezier(np, rc, tX, tY);

    let { rPath, rControls } = rotateCurvePath(
        rect.x,
        rect.y,
        rect.w,
        rect.h,
        rect.rotation,
        np,
        rc
    );

    svgPath = rPathToCurveSvgMap(np, rc);
    rect.rPath = svgPath;

    let gAlpha = getOpacity(rect);
    // Iterate through each contour
    for (let i = 0; i < rPath.length; i++) {

        const line = rPath[i];
        const controls = rControls[i]
            ? rControls[i].controls
            : [];

        ctx.save();

        if (!line.points || line.points.length < 2) {
            ctx.restore();
            continue;
        }

        ctx.beginPath();
      
        ctx.globalAlpha =
            ((line.alpha !== undefined && line.alpha !== null)? line.alpha : 1) * gAlpha;
        
        // console.log("gAlpha: ", gAlpha);
        // console.log("globalAlpha: ", ctx.globalAlpha);

        // console.log("ctx alpha: ", ctx.globalAlpha);
        // ---------------------------------------------------------
        // Draw the Bezier contour
        // ---------------------------------------------------------

        for (let p = 0; p < line.points.length - 1; p++) {

            const p0 = line.points[p];
            const p3 = line.points[p + 1];

            const control = controls[p];

            const p1 = control
                ? {
                    x: control.x2,
                    y: control.y2
                }
                : p0;

            const p2 = controls[p + 1]
                ? {
                    x: controls[p + 1].x1,
                    y: controls[p + 1].y1
                }
                : p3;

            const { x: xP0, y: yP0 } =
                pageToScreenN(
                    p0.x + rect.x,
                    p0.y + rect.y,
                    viewPortRef
                );

            const { x: xP1, y: yP1 } =
                pageToScreenN(
                    p1.x + rect.x,
                    p1.y + rect.y,
                    viewPortRef
                );

            const { x: xP2, y: yP2 } =
                pageToScreenN(
                    p2.x + rect.x,
                    p2.y + rect.y,
                    viewPortRef
                );

            const { x: xP3, y: yP3 } =
                pageToScreenN(
                    p3.x + rect.x,
                    p3.y + rect.y,
                    viewPortRef
                );

            if (p === 0) {
                ctx.moveTo(xP0, yP0);
            }

            ctx.bezierCurveTo(
                xP1,
                yP1,
                xP2,
                yP2,
                xP3,
                yP3
            );
        }

        // ---------------------------------------------------------
        // TEST FOR CLOSED PATH
        //
        // If the first and last points are sufficiently close,
        // explicitly close the Canvas path.
        // ---------------------------------------------------------

        const firstPoint = line.points[0];
        const lastPoint = line.points[line.points.length - 1];

        const CLOSE_TOLERANCE = 0.01;

        const dx = lastPoint.x - firstPoint.x;
        const dy = lastPoint.y - firstPoint.y;

        const distanceSquared = dx * dx + dy * dy;

        const isClosed =
            distanceSquared <=
            CLOSE_TOLERANCE * CLOSE_TOLERANCE;

        if (isClosed) {
            /*
            console.log(
                "Closing Canvas path:",
                i,
                "first:",
                firstPoint,
                "last:",
                lastPoint
            );
            */

            ctx.closePath();
        }

        // ---------------------------------------------------------
        // STROKE
        // ---------------------------------------------------------

        if (line.allowStroke) {

            ctx.strokeStyle =
                line.strokeColor || "#000";

            ctx.lineWidth =
                line.strokeWidth || 1;

            ctx.lineJoin = "round";
            ctx.lineCap = "round";

            ctx.stroke();
        }

        // ---------------------------------------------------------
        // FILL
        // ---------------------------------------------------------

        if (line.allowFill) {

            if (line.fillMode === "gradient") {

                const angle =
                    (line.gradientAngle || 0) *
                    Math.PI / 180;

                const dx = Math.cos(angle);
                const dy = Math.sin(angle);

                const bx = rect.x;
                const by = rect.y;

                const bounds =
                    getLineBounds(line.points);

                const bw = bounds.width;
                const bh = bounds.height;

                const cx =
                    bx + bounds.x + bw / 2;

                const cy =
                    by + bounds.y + bh / 2;

                const halfW = bw / 2;
                const halfH = bh / 2;

                const x0 =
                    cx - dx * halfW;

                const y0 =
                    cy - dy * halfH;

                const x1 =
                    cx + dx * halfW;

                const y1 =
                    cy + dy * halfH;

                const p0 =
                    pageToScreenN(
                        x0,
                        y0,
                        viewPortRef
                    );

                const p1 =
                    pageToScreenN(
                        x1,
                        y1,
                        viewPortRef
                    );

                const grad =
                    ctx.createLinearGradient(
                        p0.x,
                        p0.y,
                        p1.x,
                        p1.y
                    );

                grad.addColorStop(
                    0,
                    line.gradientColor1 || "#ffffff"
                );

                grad.addColorStop(
                    1,
                    line.gradientColor2 || "#000000"
                );

                ctx.fillStyle = grad;

            } else {

                ctx.fillStyle =
                    line.fillColor || "transparent";
            }

            ctx.fill();
        }

        ctx.restore();
    }

    ctx.restore();
  }

/*
  export function drawCurvePath(ctx, rect, viewPortRef) {
    let path = rect.path;
    let controlPath = rect.control;  // Assuming rect contains control points as well
    
    // let {rPath, rControls} = rotateCurvePath(rect.x,rect.y,rect.w,rect.h,rect.rotation, path, controlPath);
    
    // let svgPath = rPathToCurveSvg(path, controlPath);
    let svgPath = rPathToCurveSvgMap(path, controlPath);
    rect.rPath = svgPath;    
    let bound = svgPathBoundingBoxMap(svgPath)
    rect.bound = bound;
  
    ctx.save();
    applyEffects(ctx,rect);

    let {w,h} = rect;
    let sw=w;
    let sh=h;

    
    if(rect.isDropShadow)
    {
      sw = w - Math.abs(rect.shadowOffsetX) - rect.shadowBlur;
      sh = h - Math.abs(rect.shadowOffsetY) - rect.shadowBlur;
    }
    if(rect.isBlur)
    {
      sw = sw - rect.regularBlur;
      sh = sh - rect.regularBlur;
    }

    let tX = (w-sw) / 2;
    let tY = (h-sh) / 2;


    let rZoomX = sw/(w+tX);
    let rZoomY = sh/(h+tY);

    let np = resize(path,rZoomX, rZoomY);
    let rc = resizeC(controlPath,rZoomX, rZoomY);
    
    translateBezier(np, rc, tX, tY);

    let {rPath, rControls} = rotateCurvePath(rect.x,rect.y,rect.w,rect.h,rect.rotation, np, rc);
    // let svgPath = rPathToCurveSvg(path, controlPath);
    svgPath = rPathToCurveSvgMap(np, rc);
    rect.rPath = svgPath;    
        

    // Iterate over each line in the path (each line is a cubic bezier segment)
    for (let i = 0; i < rPath.length; i++) {    
      const line = rPath[i];
      const controls = rControls[i] ? rControls[i].controls : [];
  
      ctx.save(); 
      // Skip lines with no points
      if (!line.points || line.points.length < 2) 
      {
        ctx.restore();
        continue;
      }

      ctx.beginPath();

      let gAlpha = getOpacity(rect);

      ctx.globalAlpha = line.alpha*gAlpha;


      // Set the stroke style for the line
      ctx.strokeStyle = line.strokeColor || '#000'; // Default to black if no color is provided
      ctx.lineWidth = line.stroke || 1; // Default line width if not provided
              
      // Loop through the points to draw the Bézier curve segments
      for (let p = 0; p < line.points.length - 1; p++) {
        const p0 = line.points[p];
        const p3 = line.points[p + 1];
  
        // Get control points (make sure controls array has enough points)
        const control = controls[p];  // Get control point for the current segment
        const p1 = control ? { x: control.x2, y: control.y2 } : p0;  // Outgoing control for p0
        const p2 = controls[p + 1] ? { x: controls[p + 1].x1, y: controls[p + 1].y1 } : p3;  // Incoming control for p3
  
        // Calculate the points on screen with the offset from rect.x and rect.y
        const { x: xP0, y: yP0 } = pageToScreenN(p0.x + rect.x, p0.y + rect.y, viewPortRef);
        const { x: xP1, y: yP1 } = pageToScreenN(p1.x + rect.x, p1.y + rect.y, viewPortRef);
        const { x: xP2, y: yP2 } = pageToScreenN(p2.x + rect.x, p2.y + rect.y, viewPortRef);
        const { x: xP3, y: yP3 } = pageToScreenN(p3.x + rect.x, p3.y + rect.y, viewPortRef);
  
        // Start the path at the first point
        // if (p === 0 ) {
        //   ctx.moveTo(xP0, yP0);  // Ensure that we start the path at the first point of the first line
        // }
  
        // Draw cubic bezier curve
        // ctx.bezierCurveTo(xP1, yP1, xP2, yP2, xP3, yP3);


        if (p === 0) {
            ctx.moveTo(xP0, yP0);
        
          }
          
          
        ctx.bezierCurveTo(
              xP1,
              yP1,
              xP2,
              yP2,
              xP3,
              yP3
          );                      
      }


      if(line.allowStroke)
      {
        ctx.strokeStyle = line.strokeColor;
        ctx.lineWidth = line.strokeWidth;

        ctx.lineJoin = "round";
        ctx.lineCap = "round";

        ctx.stroke(); // Don't forget to stroke each path
      }
 
      if (line.allowFill) 
      {

        if (line.fillMode === "gradient") {

            const angle = (line.gradientAngle || 0) * Math.PI / 180;
            
            const dx = Math.cos(angle);
            const dy = Math.sin(angle);
          
            // ✅ Use actual bounds
            const bx = rect.x;
            const by = rect.y;

            const bounds = getLineBounds(line.points);
            const bw = bounds.width;
            const bh = bounds.height;
          
            const cx = bx + bounds.x+bw / 2;
            const cy = by + bounds.y+bh / 2;
          
            const halfW = bw / 2;
            const halfH = bh / 2;
          
            const x0 = cx - dx * halfW;
            const y0 = cy - dy * halfH;
            const x1 = cx + dx * halfW;
            const y1 = cy + dy * halfH;
          
            // ⚠️ Convert to screen coords (VERY important)
            const p0 = pageToScreenN(x0, y0, viewPortRef);
            const p1 = pageToScreenN(x1, y1, viewPortRef);
          
            const grad = ctx.createLinearGradient(p0.x, p0.y, p1.x, p1.y);
          
            grad.addColorStop(0, line.gradientColor1 || "#ffffff");
            grad.addColorStop(1, line.gradientColor2 || "#000000");
          
            ctx.fillStyle = grad;
          
        } 
        else 
        {
            ctx.fillStyle = line.fillColor;
        }
          
        ctx.fill();

        // ctx.fill();
          
      }
        

    
      ctx.restore();

      // ctx.stroke(); // Finalize the stroke for the entire path
      // ctx.restore(); // Restore context state after each line
    }

    ctx.restore();    
  }

  */


  export function resizeAnimate(rect, tRect, eZoomX, eZoomY,)
  {

    // let tRect = viewPortRef.current.originalRect;
    rect.w = tRect.w*eZoomX;
    rect.h = tRect.h*eZoomY;
    rect.offsetViewX = tRect.offsetViewX*eZoomX;
    rect.offsetViewY = tRect.offsetViewY*eZoomY;


    if(rect.mPath)
    {
      const originalPath = tRect.originalPath;
      if(originalPath != null)
      {
        const newPath = resize(originalPath, eZoomX, eZoomY);
        rect.path = newPath;
      }
      
      const oPathRect = tRect.mPath;

      if(oPathRect.type === 'Bezier' || oPathRect.type === 'Prect')
      {
        const oMPath = tRect.mPath.path;
        if(oMPath != null)
        {
          const nMPath = resize(oMPath, eZoomX, eZoomY);
          rect.mPath.path = nMPath;

          rect.mPath.x = rect.x - rect.offsetViewX;
          rect.mPath.y = rect.y - rect.offsetViewY;
          rect.mPath.w = oPathRect.w*eZoomX;                
          rect.mPath.h = oPathRect.h*eZoomX;                

        }

        if(rect.mPath.type === 'Bezier')
        {
          const originalControl = tRect.originalControl;
          if(originalControl != null)
          {
            const newControl = resizeC(originalControl, eZoomX, eZoomY);
            rect.control = newControl;
          }

          const oCPath = tRect.mPath.control;
          if(oCPath != null)
          {
            const nCPath = resizeC(oCPath, eZoomX, eZoomY);
            rect.mPath.control = nCPath;
          }
        }  
      }
      else
      {

        rect.mPath.x = rect.x-rect.offsetViewX;
        rect.mPath.y = rect.y-rect.offsetViewY;

        rect.mPath.w = oPathRect.w*eZoomX;
        rect.mPath.h = oPathRect.h*eZoomY;


        
      }
      // translateMObj(rect.mObj,rect.mPath.x,rect.mPath.y);
    } // end mPath define

    const oRect = tRect.mObj;
    if(oRect != undefined)
    {
      if(oRect.type === 'Bezier' || oRect.type === 'Prect')
      {
        const oMObj = tRect.mObj.path;
        
        if(oMObj != null)
        {                    
          const nMObj = resize(oMObj, eZoomX, eZoomY);
          rect.mObj.path = nMObj;      
          
          rect.mObj.x = rect.x - rect.offsetViewX;
          rect.mObj.y = rect.y - rect.offsetViewY;
          rect.mObj.w = oRect.w*eZoomX;                
          rect.mObj.h = oRect.h*eZoomX;        
          
          rect.mObj.imagePanX = oRect.imagePanX* eZoomX;
          rect.mObj.imagePanY = oRect.imagePanY* eZoomY;
        }

        if(rect.mObj.type === 'Bezier')
        {

          const oCObj = tRect.mObj.control;
          if(oCObj != null)
          {
            const nCObj = resizeC(oCObj, eZoomX, eZoomY);
            rect.mObj.control = nCObj;
          }
        }  
      }

      if(oRect.type === 'SvgText')
      {

        const originalSvgPath = oRect.svgText;

        // console.log("GRoup svg Text");
        if(originalSvgPath !== null && originalSvgPath !== "")
        {
          
          // console.log("HELP");
          let scaledPathString = scaleSvgPathString(originalSvgPath, eZoomX, eZoomY);
          let sane = sanitizePath(scaledPathString);
          rect.mObj.svgText = sane;
        }          
                    
      }
    }
  }

  export function drawClipBoardAnimate(ctx, rect, viewPortRef, webId, demo, draw)
  {

      let zoom = 1;

      ctx.save();

      let m = rect.mPath;
      if(m === undefined)
      {
        m = rect.mObj;
      }

      if(m != undefined && m != null)
      {
                        
        if(m.type === 'Bezier')
        {
          drawCurvePath(ctx, m, viewPortRef);
        }
        if(m.type ==='Prect')
        {
          drawPath(ctx, m, viewPortRef);
        }

        if(m.subType === 'SvgRect' || m.subType === 'SvgSquare')
        {
          let r = m;
          drawSvgRect(ctx,r.x,r.y,r.w,r.h, r);
        }
        if(m.subType === 'SvgEllipse' || m.subType === 'SvgCircle')
        {
          let r = m;
          drawSvgEllipse(ctx,r.x,r.y,r.w,r.h, r);
        }
                      
      }
      if(rect.mObj != undefined)
      {
        if(rect.mObj.type === 'Bezier')
        {
          drawCurvePath(ctx, rect.mObj, viewPortRef);
          if (rect.mObj.imageName !== "")
          {       
            let m = rect.mObj;
            let a = m.rotation;

            let iCache = getImage(rect.imageName, webId, demo);                                             
            drawImageClip(ctx,m.x,m.y, m.w, m.h, a, webId, m.imageName, iCache, demo, m, viewPortRef);          
          }                      
        }

        if(rect.mObj.type ==='Prect')
        {
          drawPath(ctx, rect.mObj, viewPortRef);
          if (rect.mObj.imageName !== "")
          {       
            let m = rect.mObj;
            let a = m.rotation;
            
            let iCache = getImage(rect.imageName, webId, demo);                                             
            drawImageClip(ctx,m.x,m.y, m.w, m.h, a, webId, m.imageName, iCache, demo, m, viewPortRef);          

          }                      
        }

        
        if(rect.mObj.type === 'SvgText')
        {
          let m = rect.mObj;
          ctx.save();
          // ctx.strokeRect(x, y, w, h);                               
          // drawTextPathOnCtx(ctx, rect.svgText, x,y, w,h, rect.rotation ,zoom, zoom, rect.rZoomX, rect.rZoomY, rect.fillColor, rect.strokeColor, rect.strokeWidth); 
          drawTextPathOnCtx(ctx, m.svgText, m.x,m.y, m.w,m.h, m.rotation ,m,zoom, zoom); 
          let b = getPathBoundingBox(m.svgText);
          rect.bound = b;
          ctx.restore();    
        }
      }

      // drawCurvePath(ctx,rect);
      ctx.restore();

  }


  export function resizeGroupForClip(o, rect, gZoomX, gZoomY)
  {
    const group = rect;  // Assuming you're moving a single group
    if (!group) return;
  


    // Choose the smaller zoom factor to keep the zoom proportional
    let gZoom = Math.min(gZoomX, gZoomY);
        
    gZoomX = gZoom;
    gZoomY = gZoom;

    // Apply the proportional zoom factor to both width and height
    rect.w = o.w * gZoom;
    rect.h = o.h * gZoom;
    // rect.offsetViewX = o.offsetViewX*gZoomX;
    // rect.offsetViewY = o.offsetViewY*gZoomY;

    if(rect.subType === 'Animate')
    {
        if(rect.mPath != undefined)
        {

            /*
            rect.mPath.x = rect.x;
            rect.mPath.y = rect.y;

            rect.mPath.w = rect.w;
            rect.mPath.h = rect.h;
            
            
            if(rect.mObj != undefined)
            {
              rect.mObj.w = o.mObj.w* gZoom;
              rect.mObj.h = o.mObj.h*gZoom;
            }
            */
        }
    }

    // Initialize a queue with the selected group
    const queue = [group];
    const original = [o];
  
    while (queue.length > 0) {
      // Get the current group from the queue
      const currentGroup = queue.shift();
      const originalGroup = original.shift();
  
      // Move the group itself
      // currentGroup.x += dx;
      //currentGroup.y += dy;
  
      // Adjust the positions of the children
      currentGroup.children.forEach((child,index) => {

        // viewPortRef.current.originalWidth = hit.w;
        // viewPortRef.current.originalHeight = hit.h;
        // viewPortRef.current.originalPath = hit?.path;
        // viewPortRef.current.originalControl = hit?.control;
        // viewPortRef.current.originalSvgPath = hit?.svgText;
            

       // Calculate the child's relative position within the group (before resizing)
       const childOriginal = originalGroup.children[index];

        // Get the child's current position relative to the group's origin (rect.x, rect.y)
        /*
        const relativeX = childOriginal.x - rect.x;
        const relativeY = childOriginal.y - rect.y;


        // Now scale the child's relative position
        const scaledX = rect.x + (relativeX * gZoomX); // Apply zoom to X
        const scaledY = rect.y + (relativeY * gZoomY); // Apply zoom to Y
        */

        // Get the child's current position relative to the group's origin (rect.x, rect.y)
        const relativeX = childOriginal.x;
        const relativeY = childOriginal.y;
                
        // Now scale the child's relative position
        const scaledX = (relativeX * gZoomX); // Apply zoom to X
        const scaledY = (relativeY * gZoomY); // Apply zoom to Y
        
        // Adjust the child's size based on the zoom factor
        child.x = scaledX;
        child.y = scaledY;
        child.w = childOriginal.w * gZoomX;
        child.h = childOriginal.h * gZoomY;
        child.offsetViewX = childOriginal.offsetViewX*gZoomX;
        child.offsetViewY = childOriginal.offsetViewY*gZoomY;

        child.imagePanX = childOriginal.imagePanX*gZoomX;
        child.imagePanY = childOriginal.imagePanY*gZoomY;
 
      
        if(child.subType === 'Animate')
        {
          if(child.mPath)
          {
            child.mPath.x = child.x - child.offsetViewX;
            child.mPath.y = child.y - child.offsetViewY;
            child.mPath.w = childOriginal.mPath.w * gZoomX;
            child.mPath.h = childOriginal.mPath.h * gZoomY;
          }
          if(child.mObj)
          {
              // Get the child's current position relative to the group's origin (rect.x, rect.y)
              const rX = childOriginal.mObj.x;
              const rY = childOriginal.mObj.y;
              const rW = childOriginal.mObj.w * gZoomX;
              const rH = childOriginal.mObj.h * gZoomY;
                        
              // Now scale the child's relative position
              // const sX = (rX * gZoomX); // Apply zoom to X
              // const sY = (rY * gZoomY); // Apply zoom to Y          
              // child.mObj.x = sX ;
              // child.mObj.y = sY;

              child.mObj.x =  child.x - child.offsetViewX;
              child.mObj.y = child.y - child.offsetViewY;
              child.mObj.w = rW;
              child.mObj.h = rH;

              child.mObj.imagePanX = childOriginal.mObj.imagePanX * gZoomX;
              child.mObj.imagePanY = childOriginal.mObj.imagePanY * gZoomY;
          }
        }

        if(child.type === 'SvgText')
        {
          child.rZoomX = gZoomX;
          child.rZoomY = gZoomY;
          const originalSvgPath = originalGroup.children[index].svgText;

          // console.log("GRoup svg Text");
          if(originalSvgPath !== null && originalSvgPath !== "")
          {
            
            // console.log("HELP");
            let scaledPathString = scaleSvgPathString(originalSvgPath, gZoomX, gZoomY);
            let sane = sanitizePath(scaledPathString);
            child.svgText = sane;
          }          
        }

        if(child.type === 'Prect')
        {
          
          const originalPath = childOriginal.path;
          if(originalPath != null)
          {

            const newPath = resize(originalPath, gZoomX, gZoomY);
            child.path = newPath;
          }
        }

        if(child.type === 'Bezier')
        {
          
          const originalPath = childOriginal.path;
          if(originalPath != null)
          {
            const newPath = resize(originalPath, gZoomX, gZoomY);
            child.path = newPath;
          }

          const originalControl = childOriginal.control;
          if(originalControl != null)
          {
            const newControl = resizeC(originalControl, gZoomX, gZoomY);
            child.control = newControl;
          }
        }

        if(child.subType === 'Animate')
        {
          if(child.mPath)
          {
            const originalPath = childOriginal.mPath.path;
            if(originalPath != null)
            {
              const newPath = resize(originalPath, gZoomX, gZoomY);
              child.mPath.path = newPath;
            }
          
            if(childOriginal.mPath.type === 'Bezier')
            {
              const originalControl = childOriginal.mPath.control;
              if(originalControl != null)
              {
                const newControl = resizeC(originalControl, gZoomX, gZoomY);
                child.mPath.control = newControl;
              }
            }

            /*
            if(childOriginal.mObj.type === 'Bezier' || childOriginal.mObj.type === 'Prect')
            {
              const oMObj = childOriginal.mObj.path;
              if(oMObj != null)
              {                    
                const nMObj = resize(oMObj, gZoomX, gZoomY);
                child.mObj.path = nMObj;                      
              }

              if(child.mObj.type === 'Bezier')
              {

                const oCObj = childOriginal.mObj.control;
                if(oCObj != null)
                {
                  const nCObj = resizeC(oCObj, gZoomX, gZoomY);
                  child.mObj.control = nCObj;
                }
              }  
            }
            if(childOriginal.mObj.type === 'SvgText')
            {
                child.rZoomX = gZoomX;
                child.rZoomY = gZoomY;
                const originalSvgPath = childOriginal.mObj.svgText;
      
                // console.log("GRoup svg Text");
                if(originalSvgPath !== null && originalSvgPath !== "")
                {
                  
                  // console.log("HELP");
                  let scaledPathString = scaleSvgPathString(originalSvgPath, gZoomX, gZoomY);
                  let sane = sanitizePath(scaledPathString);
                  child.mObj.svgText = sane;
                }                
            } 
            */                       
          }  // end if mPath
          if(childOriginal.mObj != undefined)
          {
              if(childOriginal.mObj.type === 'Bezier' || childOriginal.mObj.type === 'Prect')
              {
                const oMObj = childOriginal.mObj.path;
                if(oMObj != null)
                {                    
                  const nMObj = resize(oMObj, gZoomX, gZoomY);
                  child.mObj.path = nMObj;                      
                }

                if(child.mObj.type === 'Bezier')
                {

                  const oCObj = childOriginal.mObj.control;
                  if(oCObj != null)
                  {
                    const nCObj = resizeC(oCObj, gZoomX, gZoomY);
                    child.mObj.control = nCObj;
                  }
                }  
              }
              if(childOriginal.mObj.type === 'SvgText')
              {
                  child.rZoomX = gZoomX;
                  child.rZoomY = gZoomY;
                  const originalSvgPath = childOriginal.mObj.svgText;
        
                  // console.log("GRoup svg Text");
                  if(originalSvgPath !== null && originalSvgPath !== "")
                  {
                    
                    // console.log("HELP");
                    let scaledPathString = scaleSvgPathString(originalSvgPath, gZoomX, gZoomY);
                    let sane = sanitizePath(scaledPathString);
                    child.mObj.svgText = sane;
                  }                
              } 
            }
        }

        // child.x += dx;
        // child.y += dy;
  
        // If the child is a group, add it to the queue to be moved next
        if (child.children && child.children.length > 0) {
          queue.push(child);
          original.push(childOriginal);
        }
      });
    }
  }

  /*
  export function svgRectToBezier(rect, noOffset = false)
  {
    let r = JSON.parse(JSON.stringify(rect));

    if (r.subType === 'SvgSquare')
    {
      if (r.w < r.h) r.h = r.w;
      else r.w = r.h;
    }

    r.type = 'Bezier';
    r.subType = '';

    const pad = noOffset ? 0 : 5;

    const w = r.w;
    const h = r.h;

    r.w = w + pad * 2;
    r.h = h + pad * 2;

    const left = pad;
    const top = pad;
    const right = w + pad;
    const bottom = h + pad;

    const maxR = Math.min(w, h) / 2;

    const tl = Math.min(r.cornerTL || 0, maxR);
    const tr = Math.min(r.cornerTR || 0, maxR);
    const br = Math.min(r.cornerBR || 0, maxR);
    const bl = Math.min(r.cornerBL || 0, maxR);

    const p = [
      { x: left + tl, y: top },
      { x: right - tr, y: top },
      { x: right, y: top + tr },
      { x: right, y: bottom - br },
      { x: right - br, y: bottom },
      { x: left + bl, y: bottom },
      { x: left, y: bottom - bl },
      { x: left, y: top + tl }
    ];

    const points = [...p, { ...p[0] }];

    let lineObj = [{}];
    lineObj[0].points = points;

    Object.assign(lineObj[0], {
      fillColor: r.fillColor,
      strokeColor: r.strokeColor,
      strokeWidth: r.strokeWidth,
      allowFill: r.allowFill,
      allowStroke: r.allowStroke,
      fillMode: r.fillMode,
      gradientColor1: r.gradientColor1,
      gradientColor2: r.gradientColor2,
      gradientAngle: r.gradientAngle,
      alpha: r.fillAlpha
    });

    const t = 0.33;

    const lerp = (a,b,t) => a + (b-a)*t;

    const straight = (a,b) => ({
      x1: lerp(a.x,b.x,t),
      y1: lerp(a.y,b.y,t),
      x2: lerp(a.x,b.x,1-t),
      y2: lerp(a.y,b.y,1-t)
    });

    const controls = [];
    
    // IMPORTANT: vertex-based controls (NOT segment-based meaning)
    for (let i = 0; i < 8; i++)
    {
      const prev = p[(i + 7) % 8];
      const curr = p[i];
      const next = p[(i + 1) % 8];

      const incoming = straight(prev, curr);
      const outgoing = straight(curr, next);

      controls.push({
        x1: incoming.x2,
        y1: incoming.y2,
        x2: outgoing.x1,
        y2: outgoing.y1
      });
    }
    
    // close
    controls.push(controls[0]);

    let controlObj = [{}];
    controlObj[0].controls = controls;

    let { rPath, rControls } = rotateCurvePath(
      r.x,
      r.y,
      r.w,
      r.h,
      rect.rotation,
      lineObj,
      controlObj
    );

    r.rotation = 0;
    r.path = rPath;
    r.control = rControls;

    let svgPath = rPathToCurveSvgMap(r.path, r.control);
    let bound = svgPathBoundingBoxMap(svgPath);

    let offset = noOffset ? 0 : 10;

    if (!noOffset)
    {
      let dx = bound.x - offset;
      let dy = bound.y - offset;

      translateBezier(r.path, r.control, -dx, -dy);

      r.x += dx + offset;
      r.y += dy + offset;
      r.w = bound.w + 2 * offset;
      r.h = bound.h + 2 * offset;
    }

    return r;
  }

  */


  export function svgRectToBezier(rect, noOffset = false)
  {
    let r = JSON.parse(JSON.stringify(rect));

    // -----------------------------
    // Square handling (was Circle)
    // -----------------------------
    if (r.subType === 'SvgSquare')
    {
      if (r.w < r.h)
      {
        r.h = r.w;
      }
      else
      {
        r.w = r.h;
      }
    }

    r.type = 'Bezier';
    r.subType = '';

    let pad = 5;
    if (noOffset === true)
    {
      pad = 0;
    }

    let rW = r.w;
    let rH = r.h;

    r.w = r.w + pad * 2;
    r.h = r.h + pad * 2;

    // -----------------------------
    // RECTANGLE POINTS (replacing ellipse points)
    // -----------------------------
    let top    = { x: pad,     y: pad };
    let right  = { x: rW + pad, y: pad };
    let bottom = { x: rW + pad, y: rH + pad };
    let left   = { x: pad,     y: rH + pad };

    let points = [];
    points.push(top);
    points.push(right);
    points.push(bottom);
    points.push(left);
    points.push(JSON.parse(JSON.stringify(top)));

    r.path = [];

    let lineObj = [{}];
    lineObj[0].points = points;
    lineObj[0].fillColor = r.fillColor;
    lineObj[0].strokeColor = r.strokeColor;
    lineObj[0].strokeWidth = r.strokeWidth;
    lineObj[0].allowFill = r.allowFill;
    lineObj[0].allowStroke = r.allowStroke;
    lineObj[0].fillMode = r.fillMode;
    lineObj[0].gradientColor1 = r.gradientColor1;
    lineObj[0].gradientColor2 = r.gradientColor2;
    lineObj[0].gradientAngle = r.gradientAngle;
    lineObj[0].alpha = r.fillAlpha;

    let controls = [];

    // -----------------------------
    // RECTANGLE CONTROL POINTS
    // (no kappa ellipse math anymore)
    // -----------------------------
    let tc1 = { x1: top.x,    y1: top.y,    x2: right.x,  y2: top.y };
    let tc2 = { x1: right.x,  y1: right.y,  x2: right.x,  y2: bottom.y };
    let tc3 = { x1: bottom.x, y1: bottom.y, x2: left.x,   y2: bottom.y };
    let tc4 = { x1: left.x,   y1: left.y,   x2: left.x,   y2: top.y };
    let tc5 = { x1: top.x,    y1: top.y,    x2: top.x,    y2: top.y };

    controls.push(tc1);
    controls.push(tc2);
    controls.push(tc3);
    controls.push(tc4);
    controls.push(tc5);

    let controlObj = [{}];
    controlObj[0].controls = controls;

    // -----------------------------
    // ROTATION + PATH PROCESSING (UNCHANGED)
    // -----------------------------
    let { rPath, rControls } = rotateCurvePath(
      r.x,
      r.y,
      r.w,
      r.h,
      rect.rotation,
      lineObj,
      controlObj
    );

    r.rotation = 0;
    r.path = rPath;
    r.control = rControls;

    let svgPath = rPathToCurveSvgMap(r.path, r.control);

    let bound = svgPathBoundingBoxMap(svgPath);

    let offset = 10;

    if (noOffset === true)
    {
      offset = 0;
    }
    else
    {
      let dx = bound.x - offset;
      let dy = bound.y - offset;

      translateBezier(r.path, r.control, -dx, -dy);

      r.x += dx + offset;
      r.y += dy + offset;
      r.w = bound.w + 2 * offset;
      r.h = bound.h + 2 * offset;
    }

    return r;
  }

  function svgEllipseToBezier(rect, noOffset = false)
  {
    let r = JSON.parse(JSON.stringify(rect));



    if(r.subType === 'SvgCircle')
    {
      if(r.w < r.h)
      {
        r.h = r.w
      }
      else
      {
        r.w = r.h
      }
    }

    r.type = 'Bezier';
    r.subType = '';

    let pad = 5;
    if (noOffset === true)
    {
      pad = 0;
    }

    let rW = r.w
    let rH = r.h;

    r.w = r.w+pad*2;
    r.h = r.h+pad*2;


    /*
    let top    = { x: rW / 2, y: 0 };
    let right  = { x: rW,     y: rH / 2 };
    let bottom = { x: rW / 2, y: rH };
    let left   = { x: 0,       y: rH / 2 };
    */

    let top    = { x: rW / 2+pad, y: pad };
    let right  = { x: rW+pad,     y: rH / 2 + pad };
    let bottom = { x: rW / 2 + pad, y: rH + pad};
    let left   = { x: pad,       y: rH / 2+pad };


    let points = [];
    points.push(top);
    points.push(right);
    points.push(bottom);
    points.push(left);
    points.push(JSON.parse(JSON.stringify(top)));

    r.path=[];

    let lineObj = [{}];
    lineObj[0].points = points
    lineObj[0].fillColor = r.fillColor;
    lineObj[0].strokeColor = r.strokeColor;
    lineObj[0].strokeWidth = r.strokeWidth;
    lineObj[0].allowFill = r.allowFill;
    lineObj[0].allowStroke = r.allowStroke;
    lineObj[0].fillMode = r.fillMode;
    lineObj[0].gradientColor1 = r.gradientColor1;
    lineObj[0].gradientColor2 = r.gradientColor2;
    lineObj[0].gradientAngle = r.gradientAngle;
    lineObj[0].alpha = r.fillAlpha;


    let controls = [];

    // kappa constant
    const k = 0.5522847498;

    let ox = (rW / 2) * k;
    let oy = (rH / 2) * k;

    let tc1 = {x1:0,y1:0, x2:top.x+ox, y2:top.y}    
    let tc2 = {x1:right.x,y1:right.y-oy, x2:right.x, y2:right.y+oy}
    let tc3 = {x1:bottom.x+ox,y1:bottom.y, x2:bottom.x-ox, y2:bottom.y}  
    let tc4 = {x1:left.x,y1:left.y+oy, x2:left.x, y2: left.y - oy}
    let tc5 = {x1:top.x - ox,y1:top.y, x2:0, y2:0}

    controls.push(tc1);
    controls.push(tc2);
    controls.push(tc3);
    controls.push(tc4);
    controls.push(tc5);

    let controlObj = [{}];
    controlObj[0].controls = controls;


    // console.log("HELP********************")    ;
    // console.log(JSON.stringify(lineObj));
    // r.path = lineObj;
    // r.control = controlObj;


       
    // let {rPath, rControls} = rotateCurvePath(rect.x,rect.y,rect.w,rect.h,rect.rotation, path, controlPath);
    
    let {rPath, rControls} = rotateCurvePath(r.x,r.y,r.w,r.h,rect.rotation, lineObj, controlObj);
    r.rotation = 0;
    r.path = rPath;    
    r.control = rControls;


    // let svgPath = rPathToCurveSvg(path, controlPath);
    let svgPath = rPathToCurveSvgMap(r.path, r.control);

    let bound = svgPathBoundingBoxMap(svgPath)      
    //let bound = getBoundingBoxFromPoints(rPath);
    
    let offset = 10;

    if(noOffset === true)
    {
      offset = 0;
    }
    else
    {
      let dx = bound.x-offset;
      let dy = bound.y-offset;
      
      translateBezier(r.path,r.control, -dx, -dy );
      
      
      r.x += dx + offset;
      r.y += dy + offset;
      r.w = bound.w+2*offset;
      r.h = bound.h+2*offset;
    }

    return r;

  }


  export async function loadLocalSvg(r, svgUrl, noOffset = false)
  {

    const {lines, controls} = await svgFileToBezierMap(svgUrl, true);
    r.path = lines;
    r.control = controls;

    console.log("lines: ", lines);

    // let rPath = rotateCurvePath(r.x,r.y,r.w,r.h,1*rect.rotation,r.path);

    
    let {rPath, rControls} = rotateCurvePath(r.x,r.y,r.w,r.h,1*r.rotation,r.path, r.control);
    r.path = rPath;
    r.control = rControls;

    let bound = getBoundingBoxFromPoints(r.path);

    let dx = bound.x-5;
    let dy = bound.y-5;
    bound.w +=10;
    bound.h +=10;

    let offset = 10;

    if(noOffset)
    {    
      offset = 0;
    }
    else
    {    
      translateBezier(r.path,r.control, -dx, -dy );
    
     //  r.x += dx + offset ;
     // r.y += dy + offset;
      r.w = bound.w;
      r.h = bound.h;
    }

    return r;
  }


  export async function loadNewSvg(r, svgUrl, noOffset = false)
  {

    const {lines, controls} = await svgFileToBezierMap(svgUrl);
    r.path = lines;
    r.control = controls;

    console.log("lines: ", lines);

    // let rPath = rotateCurvePath(r.x,r.y,r.w,r.h,1*rect.rotation,r.path);

    
    let {rPath, rControls} = rotateCurvePath(r.x,r.y,r.w,r.h,1*r.rotation,r.path, r.control);
    r.path = rPath;
    r.control = rControls;

    let bound = getBoundingBoxFromPoints(r.path);

    let dx = bound.x-5;
    let dy = bound.y-5;
    bound.w +=10;
    bound.h +=10;

    let offset = 10;

    if(noOffset)
    {    
      offset = 0;
    }
    else
    {    
      translateBezier(r.path,r.control, -dx, -dy );
    
     //  r.x += dx + offset ;
     // r.y += dy + offset;
      r.w = bound.w;
      r.h = bound.h;
    }

    return r;
  }


  

  export async function svgFileToBezier(rect, noOffset = false, svgUrl)
  {
    let r = JSON.parse(JSON.stringify(rect));    
    r.type = 'Bezier';

    r.allowStroke = true;
    r.strokeWidth = 1;
    r.allowFill = false;
    r.fillColor = "transparent";
    r.fillAlpha = 1;
    r.imageName = "";
  
    // console.log("SvgText: ", rect.svgText);

    r.rotation = 0;
    const {lines, controls} = await svgFileToBezierMap(svgUrl);
    r.path = lines;
    r.control = controls;

    console.log("lines: ", lines);

    // let rPath = rotateCurvePath(r.x,r.y,r.w,r.h,1*rect.rotation,r.path);

    
    let {rPath, rControls} = rotateCurvePath(r.x,r.y,r.w,r.h,1*rect.rotation,r.path, r.control);
    r.path = rPath;
    r.control = rControls;

    let bound = getBoundingBoxFromPoints(r.path);

    let dx = bound.x-5;
    let dy = bound.y-5;
    bound.w +=10;
    bound.h +=10;

    let offset = 10;

    if(noOffset)
    {    
      offset = 0;
    }
    else
    {    
      translateBezier(r.path,r.control, -dx, -dy );
    
     //  r.x += dx + offset ;
     // r.y += dy + offset;
      r.w = bound.w;
      r.h = bound.h;
    }

    return r;
  }


  async function imageToBezier(rect, svgUrl) {
    let r = JSON.parse(JSON.stringify(rect));

    r.type = "Bezier";
    r.imageName = "";


    let {lines,controls} = await svgFileToBezierMap(svgUrl,false);
    r.path = lines;
    r.control = controls;

      

      let { rPath, rControls } = rotateCurvePath(
            r.x, r.y, r.w, r.h, 1 * r.rotation, r.path, r.control
      );

      r.path = rPath;
      r.control = rControls;

      let bound = getBoundingBoxFromPoints(r.path);

      let dx = bound.x - 5;
      let dy = bound.y - 5;
      bound.w += 10;
      bound.h += 10;

      translateBezier(r.path, r.control, -dx, -dy);

      r.w = bound.w;
      r.h = bound.h;

      return r;    
  }

  function svgTextToBezier(rect, noOffset = false)
  {
    let r = JSON.parse(JSON.stringify(rect));    
    r.type = 'Bezier';


    // r.allowStroke = true;
    // r.strokeWidth = 1;
    // r.allowFill = false;
    // r.fillColor = "transparent";
    // r.fillAlpha = 1;

    r.imageName = "";
  
    // console.log("SvgText: ", rect.svgText);

    r.rotation = 0;
    const {lines, controls} = svgPathToBezierMap(rect.svgText, r);
    r.path = lines;
    r.control = controls;

    // let rPath = rotateCurvePath(r.x,r.y,r.w,r.h,1*rect.rotation,r.path);

    let {rPath, rControls} = rotateCurvePath(r.x,r.y,r.w,r.h,1*rect.rotation,r.path, r.control);
    r.path = rPath;
    r.control = rControls;

    let bound = getBoundingBoxFromPoints(r.path);

    let dx = bound.x-5;
    let dy = bound.y-5;
    bound.w +=10;
    bound.h +=10;

    let offset = 10;

    if(noOffset)
    {    
      offset = 0;
    }
    else
    {    
      translateBezier(r.path,r.control, -dx, -dy );
    
      r.x += dx + offset ;
      r.y += dy + offset;
      r.w = bound.w;
      r.h = bound.h;
    }
    return r;
  }
  
  export function aiToBezier(rect, noOffset = false)
  {
      let r = JSON.parse(JSON.stringify(rect));    
      r.type = 'Bezier';
  
  
      // r.allowStroke = true;
      // r.strokeWidth = 1;
      // r.allowFill = false;
      // r.fillColor = "transparent";
      // r.fillAlpha = 1;
  
      r.imageName = "";
    
      // console.log("SvgText: ", rect.svgText);
  
      r.rotation = 0;
      const {lines, controls} =  aiSvgToBezierMap(rect.aiSvg); //svgPathToBezierMap(rect.aiSvg, r);
      r.path = lines;
      r.control = controls;
  
      // let rPath = rotateCurvePath(r.x,r.y,r.w,r.h,1*rect.rotation,r.path);
  
      let {rPath, rControls} = rotateCurvePath(r.x,r.y,r.w,r.h,1*rect.rotation,r.path, r.control);
      r.path = rPath;
      r.control = rControls;
  
      let bound = getBoundingBoxFromPoints(r.path);
  
      let dx = bound.x-5;
      let dy = bound.y-5;
      bound.w +=10;
      bound.h +=10;
  
      let offset = 10;
  
      if(noOffset)
      {    
        offset = 0;
      }
      else
      {    
        translateBezier(r.path,r.control, -dx, -dy );
      
        r.x += dx + offset ;
        r.y += dy + offset;
        r.w = bound.w;
        r.h = bound.h;
      }
      return r;
      
  }

  function pRectToBezier(rect, noOffset = false)
  {
    let r = JSON.parse(JSON.stringify(rect));

    
    r.type = 'Bezier';

    let controlObj = [];
    r.rotation = 0;

    let rPath = rotatePath(r.x,r.y,r.w,r.h,1*rect.rotation,r.path);

    let bound = getBoundingBoxFromPoints(rPath);


    // let lines = rect.path;
    
    r.path = rPath;
    let lines = r.path;

    for (let i = 0; i < lines.length; i++)
    {
        let line = lines[i];
        let points = line.points;
        let controls = [];

        // Initialize control array same length as points
        for (let p = 0; p < points.length; p++)
        {
            controls.push({
                x1: points[p].x,
                y1: points[p].y,
                x2: points[p].x,
                y2: points[p].y
            });
        }

        // Build bezier handles between each consecutive point pair
        for (let p = 1; p < points.length; p++)
        {
            let prev = points[p - 1];
            let curr = points[p];

            let dx = curr.x - prev.x;
            let dy = curr.y - prev.y;

            // Outgoing control from previous point (1/3 toward current)
            controls[p - 1].x2 = prev.x + dx / 3;
            controls[p - 1].y2 = prev.y + dy / 3;

            // Incoming control to current point (2/3 toward current)
            controls[p].x1 = prev.x + (2 * dx) / 3;
            controls[p].y1 = prev.y + (2 * dy) / 3;
        }

        controlObj.push({
            controls: controls
        });
    }

    r.control = controlObj;

    // let dx = bound.x;
    //let dy = bound.y;


    let dx = bound.x;
    let dy = bound.y;
    let offset = 10;

    if(noOffset)
    {
      offset = 0;
    }
    else
    {
      translateBezier(r.path,r.control, -dx, -dy );
    
      r.x += dx + offset ;
      r.y += dy + offset;
      r.w = bound.w;
      r.h = bound.h;
    }
    // r.x += dx;
    // r.y += dy;
    //r.w = bound.w;
    // r.h = bound.h;

    return r;
  }

  function groupToPage(rect, parents)
  {

    let newChildren = [];

    // Initialize a queue with the selected group
    const queue = [rect];
      
    while (queue.length > 0) 
    {
    // Get the current group from the queue
      const currentGroup = queue.shift();

      
      
      // Adjust the positions of the children
      currentGroup.children.forEach((child,index) => 
      {
      
            // If the child is a group, add it to the queue to be moved next
            if (child.children && child.children.length > 0) 
            {
                queue.push(child);
            }
            else
            {
              //leaf node
              if(child.type === 'Prect' || 
                child.type === 'Bezier' || 
                child.type === 'SvgText' ||
                child.subType === 'SvgCircle' || 
                child.subType === 'SvgEllipse' ||
                child.subType === 'SvgRect' ||
                child.subType === 'SvgSquare')
              {
                
                let b = JSON.parse(JSON.stringify(child));
                let parent = parents.get(child);
                if(parent != null)
                {
                  let {matrix} = getGroupTransform(parent, parents);
                  b=applyMatrixToChild(b, matrix);
                }
                else
                {
                  console.log("Not sure why parent is null");
                }

                newChildren.push(b);
                // np.push(...b.path);
                // nc.push(...b.control);

              }
            }
      })
    }
    

    // r.path = np;
    // r.control = nc;
    // return r;

    return newChildren;
  }


  function getGroupTransform(parent, parents)
  {

    if (!parent) return {matrix: null, opacity:1};
  
    let matrix = { a:1, b:0, c:0, d:1, e:0, f:0 };
    let opacity = 1;
  
    // collect hierarchy
    let hierarchy = [];
    let p = parent;
  
    while (p != null)
    {
      hierarchy.push(p);
      p = parents.get(p);
    }
  
    // apply from root → child
    hierarchy.reverse();
  
    for (let obj of hierarchy)
    {
      let pX = obj.x;
      let pY = obj.y;
  
      let cX = obj.w / 2;
      let cY = obj.h / 2;
  
      let t1 = createTranslationMatrix(pX, pY);
      let t2 = createTranslationMatrix(cX, cY);
      let r1 = createRotationMatrix((obj.rotation * Math.PI) / 180);
      let t3 = createTranslationMatrix(-cX, -cY);
  
      matrix = multiplyMatrices(matrix, t1);
      matrix = multiplyMatrices(matrix, t2);
      matrix = multiplyMatrices(matrix, r1);
      matrix = multiplyMatrices(matrix, t3);

      opacity=opacity*obj.fillAlpha;
      
    }
  
    /*
    const {offsetX, offsetY, zoom} = viewPortRef.current;
  
    let scr = createScreenTransformationMatrix(zoom, zoom, offsetX, offsetY);
  
    matrix = multiplyMatrices(scr, matrix);
    */
  
    return {matrix, opacity};
  }

  function applyMatrixToChild(rect, matrix)
  {
    
    let p1 = {x:rect.x, y:rect.y};
    let t = transformPoint(p1, matrix);
  

    let r = null;

    if(rect.type === 'Prect')
    {
      r = rect;
      let rPath = rotatePath(r.x,r.y,r.w,r.h,1*rect.rotation,r.path);
      r.rotation=0;      
      rect.path = rPath;
      rect.rotation = 0;

      r = pRectToBezier(rect, true);
    }

    if(rect.type === 'SvgText')
    {
      r = rect;
      r = svgTextToBezier(rect, true);
    }

    if(rect.subType === 'SvgCircle' ||
        rect.subType === 'SvgEllipse')
    {
        r = rect;
        r = svgEllipseToBezier(rect, true);
    }

    if(rect.subType === 'SvgRect' ||
      rect.subType === 'SvgSquare')
    {
      r = rect;
      r = svgRectToBezier(rect, true);
    }

    if(rect.type === 'Bezier')
    {
      r = rect;
      let {rPath, rControls} = rotateCurvePath(r.x,r.y,r.w,r.h,r.rotation, r.path, r.control);
      r.rotation = 0;
      r.path = rPath;    
      r.control = rControls;

    }

    if(r != null)
    {
      r.x = t.x;
      r.y = t.y;
      return r;
    }

    /*
    let lineObj = rect.path;

    let cX = rect.w/2;
    let cY = rect.h/2;

    lineObj.forEach((line) =>{
      line.points.forEach((point)=>{
        let t = transformPoint(point, matrix);
        point.x = t.x;
        point.y = t.y;
      })
    });
    
    
    let controlObj = rect.control
      
    controlObj.forEach((control) =>{
      control.controls.forEach((control)=>{
        let p1 = {x:control.x1, y:control.y1};
        let t1 = transformPoint(p1,matrix);
        let p2 = {x:control.x2, y:control.y2};
        let t2 = transformPoint(p2,matrix);

        control.x1 = t1.x+rect.x - cX ;
        control.y1 = t1.y+rect.y - cY;
        control.x2 = t2.x+rect.x - cX;
        control.y2 = t2.y+rect.y - cY;  
      })
    });
    */
  }

  function convertRectsToSingleBezier(group, newRects)
  {
    let r = JSON.parse(JSON.stringify(group));

    r.type = "Bezier";

    let p = [];
    let c = [];

    newRects.sort((a, b) => a.zIndex - b.zIndex);

    newRects.forEach(rect => {
      
      let dx = rect.x - r.x ;
      let dy = rect.y - r.y;

      translateBezier(rect.path, rect.control, dx, dy);
      p.push(...rect.path);
      c.push(...rect.control);

    });

    r.path = p;
    r.control = c;
    return r;
  }

  export function convertToImage(layout, rect, parents)
  {
    let newRect = JSON.parse(JSON.stringify(rect));
    newRect.subType = "Image";
    newRect.description = "";

    // Replace the original rect with the converted copy
    const index = layout.indexOf(rect);

    if (index !== -1) {
        layout[index] = newRect;
    }

  }

  export async function convertToBezier(layout, rect, parents, webId="", redraw = null)
  {

    if(rect.subType === 'SvgCircle' || 
      rect.subType === 'SvgEllipse')
    {

      let newRect = svgEllipseToBezier(rect);
      layout.push(newRect);
      return;

    }    

    if(rect.subType === 'AiArt')
    {
      console.log("Custom ai bezier");
      if(rect.aiSvg)
      {
        console.log("ai conversion routine called");
        let newRect = aiToBezier(rect);

           // Replace the original rect with the converted copy
           const index = layout.indexOf(rect);

           if (index !== -1) {
               layout[index] = newRect;
           }
   
        // layout.push(newRect);
        return;
      }
    }

    if(rect.subType === 'SvgRect' ||
        rect.subType === 'SvgSquare')
    {
      let newRect = svgRectToBezier(rect);
      layout.push(newRect);
      return;

    }

    if(rect.type === 'Prect')
    {
      let newRect = pRectToBezier(rect);
      layout.push(newRect);
      return;
    }

    if(rect.type === 'SvgText')
    {
      let newRect = svgTextToBezier(rect);
      newRect.fillRule = "special";
      layout.push(newRect);
      return;
    }


    if(rect.type === 'Rectangle' && rect.subType === "Image")
    {

      let u = Util.getInstance();
      let serverName = u.getServerName();

      let file = `${webId}/${rect.imageName}`;
      let svgUrl = `${serverName}/${file}`;

      let newRect = await imageToBezier(rect, svgUrl);
      layout.push(newRect);
      if(redraw != null)
      {
        redraw();
      }
      return;

    }
    if(rect.type === "Group")
    {

      let tempRotation = rect.rotation;
      rect.rotation = 0;

      let newRects = groupToPage(rect, parents);

      if(newRects.length > 0)
      {
        let r=convertRectsToSingleBezier(rect, newRects);

        console.log()

        layout.push(r);

        r.rotation = tempRotation;
        rect.rotation = tempRotation;
        
      }
      else
      {

        Swal.fire({
          title: 'Info',
          text: "No convertible rectangle found in group",
          icon: 'info',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,    
        });          
      }
    }
  }

  export function addFilteredPoint(
    pointsArray,
    dx,
    dy,
    elapsedTime = 0,
    baseMinDistance = 3
  ) {
    if (!pointsArray || pointsArray.length === 0) {
      pointsArray.push({ x: dx, y: dy, v: 0 });
      return true;
    }
  
    const n = pointsArray.length;
  
    const p1 = pointsArray[n - 1];
    const p0 = pointsArray[n - 2] || p1;
    const p_1 = pointsArray[n - 3] || p0;
  
    const velocityValue =
      elapsedTime > 0
        ? Math.hypot(dx - p1.x, dy - p1.y) / elapsedTime
        : 0;
  
    // -----------------------------
    // SPLINE-BASED DIRECTION (Catmull-Rom tangent)
    // -----------------------------
  
    const tdx = 0.5 * (p1.x - p_1.x);
    const tdy = 0.5 * (p1.y - p_1.y);
  
    const tLen = Math.hypot(tdx, tdy) || 1;
  
    const dirX = tdx / tLen;
    const dirY = tdy / tLen;
  
    // -----------------------------
    // CURSOR DIRECTION
    // -----------------------------
  
    const dxv = dx - p1.x;
    const dyv = dy - p1.y;
  
    const dLen = Math.hypot(dxv, dyv) || 1;
  
    const curX = dxv / dLen;
    const curY = dyv / dLen;
  
    // -----------------------------
    // BLEND SPLINE + USER INPUT DIRECTION
    // -----------------------------
  
    const smoothness = 0.6; // higher = more spline influence
  
    const bx = dirX * smoothness + curX * (1 - smoothness);
    const by = dirY * smoothness + curY * (1 - smoothness);
  
    const bLen = Math.hypot(bx, by) || 1;
  
    const finalDirX = bx / bLen;
    const finalDirY = by / bLen;
  
    // -----------------------------
    // VELOCITY THRESHOLD (same idea, simplified)
    // -----------------------------
  
    
    const v = Math.min(velocityValue / 5, 1);

    // smooth saturation (no aggressive jump at high speed)
    const velocityFactor = 1 + (1 - Math.exp(-v * 3)) * 1.2;
  
    const dynamicThreshold = baseMinDistance * velocityFactor;
  
    const dist = Math.hypot(dx - p1.x, dy - p1.y);
  
    if (dist < dynamicThreshold) {
      return false;
    }
  
    // -----------------------------
    // ADD ONLY REAL POINT
    // -----------------------------
  
    pointsArray.push({
      x: dx,
      y: dy,
      v: velocityValue,
      dirX: finalDirX,
      dirY: finalDirY
    });
  
    return true;
  }
  

  export function exportRectAsSvg(rect)
  {
          let id = "4364";
          let index = "4364";
          // If no imageName, just render the paths in an SVG

          let filterId = `filter-${id}`;
          let filterStr = "";
    
          if (rect.isBlur || rect.isDropShadow) {
            filterStr = `
              <filter id="${filterId}" x="-50%" y="-50%" width="200%" height="200%">
                ${rect.isDropShadow ? `<feDropShadow dx="${rect.shadowOffsetX}" dy="${rect.shadowOffsetY}" stdDeviation="${rect.shadowBlur}" flood-color="${rect.shadowColor}" />` : ""}
                ${rect.isBlur ? `<feGaussianBlur stdDeviation="${rect.regularBlur}" />` : ""}
              </filter>
            `;
          }
    
    

          const gDefs = rect.rPath.map((pathObj, index) =>{
            const gradId = `grad-${id}-${index}`;
            let gradientDef = "";
            const angle = (rect.path[index].gradientAngle || 0) * Math.PI / 180;
        
            const dx = Math.cos(angle);
            const dy = Math.sin(angle);

            gradientDef = `
            <defs>
              <linearGradient id="${gradId}" x1="${50 - dx * 50}%" y1="${50 - dy * 50}%" x2="${50 + dx * 50}%" y2="${50 + dy * 50}%">
                <stop offset="0%" stop-color="${rect.path[index].gradientColor1}" />
                <stop offset="100%" stop-color="${rect.path[index].gradientColor2}" />
              </linearGradient>
            </defs>
          `;

          return gradientDef;          
      }).join("\n");



      const pathsHtml = rect.rPath.map((pathObj, index) => {
        const gradId = `grad-${id}-${index}`;
        let fillValue = "";

        if (rect.path[index].allowFill && rect.path[index].fillMode === "gradient") {                                    
          fillValue = `fill="url(#${gradId})"`;          
        } else if (rect.path[index].allowFill) {
          fillValue = `fill="${rect.path[index].fillColor}"`;
        } else {
          fillValue = `fill="transparent"`;
        }

        const stroke = rect.path[index].allowStroke
          ? (rect.path[index].strokeColor || "#000")
          : "none";

        const strokeWidth = rect.path[index].allowStroke
          ? (rect.path[index].strokeWidth || 1)
          : 0;

        const fill = rect.path[index].allowFill
          ? (rect.path[index].fillColor || "none")
          : "none";

        const opacity = (rect.path[index].alpha !== undefined)
          ? rect.path[index].alpha
          : 1;

        return `
          <path 
            d="${pathObj.d}" 
            stroke="${stroke}" 
            stroke-width="${strokeWidth}" 
            ${fillValue}
            stroke-linecap="round"
            stroke-linejoin="round"
            opacity="${opacity}"
            ${filterStr ? `filter="url(#${filterId})"` : ""}
          />
        `;
      }).join("\n");

    const svg = `
      <svg xmlns="http://www.w3.org/2000/svg"
          width="${rect.w}"
          height="${rect.h}"
          viewBox="0 0 ${rect.w} ${rect.h}">

        ${gDefs}

        <defs>
          ${filterStr}
        </defs>

        ${pathsHtml}

      </svg>`

      return svg;
  }


  export async function svgToWebPBlob(svgString, quality = 0.92) {
    // Parse the SVG to determine its viewport dimensions.
    const parser = new DOMParser();
    const doc = parser.parseFromString(svgString, "image/svg+xml");
    const svgElement = doc.documentElement;

    if (svgElement.localName !== "svg" ||
        doc.querySelector("parsererror")) {
        throw new Error("Invalid SVG");
    }

    const viewBox = svgElement.getAttribute("viewBox")
        ?.trim()
        .split(/[\s,]+/)
        .map(Number);

    const getDimension = (name, viewBoxIndex) => {
        const attr = svgElement.getAttribute(name);
        const match = attr?.trim().match(/^(\d*\.?\d+)(px)?$/i);

        if (match) return Number(match[1]);

        if (viewBox?.length === 4 && viewBox[viewBoxIndex] > 0) {
            return viewBox[viewBoxIndex];
        }

        return 0;
    };

    const width = getDimension("width", 2);
    const height = getDimension("height", 3);

    if (!(width > 0 && height > 0 &&
          Number.isFinite(width) && Number.isFinite(height))) {
        throw new Error("Unable to determine SVG viewport dimensions");
    }

    // Create a temporary canvas.
    const canvas = document.createElement("canvas");
    canvas.width = Math.ceil(width);
    canvas.height = Math.ceil(height);

    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("Unable to create canvas context");

    // Load the SVG as an image.
    const svgBlob = new Blob([svgString], {
        type: "image/svg+xml;charset=utf-8"
    });

    const url = URL.createObjectURL(svgBlob);

    try {
        const img = new Image();

        await new Promise((resolve, reject) => {
            img.onload = resolve;
            img.onerror = () => reject(new Error("Unable to load SVG"));
            img.src = url;
        });

        // Render at the SVG viewport dimensions.
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);


        // Convert the canvas directly to a WebP Blob.
        const webpBlob = await new Promise((resolve, reject) => {
          canvas.toBlob(
              blob => {
                  if (blob) {
                      resolve(blob);
                  } else {
                      reject(new Error("WebP conversion failed"));
                  }
              },
              "image/webp",
              quality
          );
        });

        // Debug: download the WebP locally.
        /*
        console.log("WebP type:", webpBlob.type);
        console.log("WebP size:", webpBlob.size, "bytes");

        const downloadUrl = URL.createObjectURL(webpBlob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = "test.webp";
        link.click();
        

        setTimeout(() => URL.revokeObjectURL(downloadUrl), 1000);
        */

        return webpBlob;
    } finally {
        URL.revokeObjectURL(url);
    }
  }



  export function exportSvg(rect)
  {
    let svg = exportRectAsSvg(rect);
    console.log("Svg: ", svg);

        // for saving in a local directory
    const blob = new Blob([svg], { type: 'application/json' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download =`bezier.svg`;
        link.click();
        URL.revokeObjectURL(link.href);

  }

  export function exportCode(rect)
  {

    console.log("code: ", rect.aiCode);

    let txt = rect.aiCode;
        // for saving in a local directory
    const blob = new Blob([txt], { type: 'application/json' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download =`codeSnippet.txt`;
        link.click();
        URL.revokeObjectURL(link.href);

  }


  export function isCompletelyOccluded(rect, rects) {

    const index = rects.indexOf(rect);

    if (index === -1) {
        return false;
    }

    // Rectangles above this one in z-order
    const aboveRects = rects.slice(index + 1);

    if (aboveRects.length === 0) {
        return false;
    }

    const left = rect.x;
    const right = rect.x + rect.w;
    const top = rect.y;
    const bottom = rect.y + rect.h;

    // Only consider rectangles that overlap the target rectangle
    const occluders = aboveRects.filter(r =>
        !r.hasParents &&
        r.x < right &&
        r.x + r.w > left &&
        r.y < bottom &&
        r.y + r.h > top
    );

    if (occluders.length === 0) {
        return false;
    }

    // Collect all X boundaries inside the target
    const xs = [left, right];

    // Collect all Y boundaries inside the target
    const ys = [top, bottom];

    for (const r of occluders) {

        const x1 = Math.max(left, r.x);
        const x2 = Math.min(right, r.x + r.w);

        const y1 = Math.max(top, r.y);
        const y2 = Math.min(bottom, r.y + r.h);

        if (x1 < x2 && y1 < y2) {
            xs.push(x1, x2);
            ys.push(y1, y2);
        }
    }

    // Remove duplicates and sort
    xs.sort((a, b) => a - b);
    ys.sort((a, b) => a - b);

    const uniqueXs = [...new Set(xs)];
    const uniqueYs = [...new Set(ys)];

    // Check every small cell created by the rectangle boundaries.
    // If even one cell isn't covered, the rectangle isn't
    // completely occluded.
    for (let x = 0; x < uniqueXs.length - 1; x++) {

        for (let y = 0; y < uniqueYs.length - 1; y++) {

            const cellX = (uniqueXs[x] + uniqueXs[x + 1]) / 2;
            const cellY = (uniqueYs[y] + uniqueYs[y + 1]) / 2;

            const covered = occluders.some(r =>
                cellX >= r.x &&
                cellX < r.x + r.w &&
                cellY >= r.y &&
                cellY < r.y + r.h
            );

            if (!covered) {
                return false;
            }
        }
    }

    return true;
}
  /*
  export function addFilteredPoint(pointsArray, dx, dy, elapsedTime = 0, baseMinDistance = 3) {
    if (!pointsArray || pointsArray.length === 0) {
      pointsArray.push({ x: dx, y: dy, v: velocity });
      return true;
    }
  
    const lastPoint = pointsArray[pointsArray.length - 1];
  
    const distX = dx - lastPoint.x;
    const distY = dy - lastPoint.y;
  
    const distance = Math.hypot(distX, distY);
    const velocity = distance/elapsedTime;  

    // console.log("velocity: ", velocity);
  
    // velocity scaling:
    // slow = tighter sampling
    // fast = looser sampling
    const velocityFactor = Math.min(Math.max(velocity * 20, 0.5), 3);
  
    const dynamicThreshold = baseMinDistance * velocityFactor;
  
    if (distance >= dynamicThreshold) {
      pointsArray.push({ x: dx, y: dy, v: velocity });
      return true;
    }
  
    return false;
  }
  */

